webpackJsonp([1],{

/***/ "1Uz0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1jZ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2KK6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Rdu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3xIv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6F6W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A1tS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAAEhlFeZAAAABGdBTUEAALGPC/xhBQAABLZJREFUSA2lVl1oXEUUnnN373ZT8f+nNYrxxVJFin8IFguVshsrRPAtqA/FqrtJFbVKCz6YhSqKD7FakmyIBSFQfCgqgpomVB9sBStqUdEH34S4koLaP7O79+49fufencnMze4ScWB3zpzzfefMnJk5d5Rqt6EKrxeR5K9QajKROsKsHo0VWim9QcigY6M2/33whxemc+QJTA9EjhVE1BCkKEyUYjkYZ+YXRIn2G+gDIsQ+RRB/0uumPcRjGVQqnNVGyJ4G9Jx32qvCPI5qL9KbmNqdKDWLBkeaz0eReitGkrebOTossqdo3NMGQYtBsyLFe6kwyneoKNijWD0pDGlI/Qx7/mScJTFoRuJBPSWgxAhBJoTZfWdPzBgFiQTfJb1uZilaIf3D+/jS5bPBOa3DHEbnq7kpPda9IUuaT/4RLmNfTbo1yO69Pr//2EGqiY6Q1bPY3ctWAPT3wrR/5co4kYBbAu5arSdF5+PIcbpawfcw/IhsbNn5bAIKm8FSNudfJ4TPDtGZQin4Biu/R2X8Oxcm6bQ7RaKrNVB6ZC4miSwNa78Rp9U0l8zcL6lGtDwiNfTeyAWq14KLmLYhiuCS2yZMty5RdQNRi2vrh17ka4ojzXe7oc022YBiuXkYs3si0VEdme+z7SI7xF0Vzi/Wwn+QSUcfk4juX6j6J7UDc+Swd2OLtWC5I0nQzCeKpeBzTcSdYByMOEreKLHhmMs4Du8F9C8DYx0S4iuuz+ZNSdCkTIa2zU36J/RY+sFy896I1de2zkw1UXpVTSqUg0X5if5YNXcKFeodm5gcwXbJko0vvsSXZBpqfSsIfxBgxs9uQU7rH79J5/V9FFwqIpAXwgNyZrGujfITuX4uqNrRRHaIUs3mq/5e8Yj2Fw7q7yLjnj4mSbTJDvGrWugkxQYi86fssUNkxfcBMCEARL4KG36DyMVSiMTgelnNSY6llzP1K7Fq4V5sdvQYyPQ73pAYyOoW9zK5dGeqrqn3yMlUb2hiLY6GQ9ziGax5Q6wh9UuG/OG5KYr3fS0+1hT0wXKwvaX4PZz7gV5Osf0f+pTd/ckUjkGP1jUoisfdqAWzCHRrD35HE6pxC5s6tnVj9vVKhaI0yAlafIY3cxDOpo9LmvRfxlj9GY9p19x09lPNo4f28EDQCpE63q6Vq3uq4zK+5qvsRKfUSRFv1MLncOpewYRNOUr7wRfiW/L84VUlyAZilpHK8Nb5iZxTflBhvoBzfKtoCRfqAZszOBJsw3vhOOy+rbdlj8jfkPxoh22AQ86vy/anA7Yxm7DXt0He5HJQ6qb8L/v87M3Ct21YwA4TSxusL3CskscKCtDTMkDptx9vmrKqB+eIFK2YU2rOIurjBtT+Ysu4a2UA4XJNwCx/xtgcBOiL8iiBvgE9UtlupE5rEZWzHxgztAVzetMrFZCkBIXQfLw0ESv/M/5GSUluF0ltk75QDh9RHH1g6/TbRHQ9SxkcH8eD5g2HLAPiMfJoHyl+NW1D1a6uCpgCdU3vCo734zO2H/v1E5H3dt+6zNGPDtIhbZfXV9Rs7YxUdAC6m/C61aau/RqCJlxsz+1wOHNxOZqx30r4VHZ13s3QM73dSP9X/y92Tg2JsDOtaAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "D+pl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo2.3c1773d.png";

/***/ }),

/***/ "FAmo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FQ65":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HemK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IhRb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IxpF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MxxQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/_vue@2.6.11@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("kV13");

// EXTERNAL MODULE: ./node_modules/_fastclick@1.0.6@fastclick/lib/fastclick.js
var fastclick = __webpack_require__("iDdd");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("3cXf");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/libs/clean-style.js
var clean_style = __webpack_require__("gjrJ");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-9cbac0a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: group_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("FQ65")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_group = (Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0f36864e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("2KK6")
}
var inline_desc_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/libs/router.js
var router = __webpack_require__("adVT");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/components/cell/props.js
var props = __webpack_require__("VOBM");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("L2it");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: _vux_2_9_4_vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: _vux_2_9_4_vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-086b37c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("6F6W")
}
var cell_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("/Bf6");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5dbc8d5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("kF+h")
}
var tab_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1b6a630e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("ZLEe");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/libs/base.js + 1 modules
var base = __webpack_require__("p7Ev");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-dc7dd078","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("eIHG")
}
var icon_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_icon = (icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("x6d+");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1fa4d632","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/toast/index.vue
var toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var toast_staticRenderFns = []
var toast_esExports = { render: toast_render, staticRenderFns: toast_staticRenderFns }
/* harmony default export */ var src_components_toast = (toast_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/toast/index.vue
function toast_injectStyle (ssrContext) {
  __webpack_require__("w+fm")
}
var toast_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var toast___vue_template_functional__ = false
/* styles */
var toast___vue_styles__ = toast_injectStyle
/* scopeId */
var toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var toast___vue_module_identifier__ = null
var toast_Component = toast_normalizeComponent(
  components_toast,
  src_components_toast,
  toast___vue_template_functional__,
  toast___vue_styles__,
  toast___vue_scopeId__,
  toast___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_toast = (toast_Component.exports);

// EXTERNAL MODULE: ./node_modules/_validator@9.4.1@validator/lib/isEmail.js
var isEmail = __webpack_require__("Bv05");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/_validator@9.4.1@validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("BzUK");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/tools/debounce/index.js
var debounce = __webpack_require__("n0S5");

// EXTERNAL MODULE: ./node_modules/_vanilla-masker@1.2.0@vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("IFIB");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: _vux_2_9_4_vux_src_components_icon,
    InlineDesc: _vux_2_9_4_vux_src_components_inline_desc,
    Toast: _vux_2_9_4_vux_src_components_toast
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: _vux_2_9_4_vux_src_components_icon,
    InlineDesc: _vux_2_9_4_vux_src_components_inline_desc,
    Toast: _vux_2_9_4_vux_src_components_toast
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-06247374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){return _vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("pon3")
}
var x_input_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_x_input = (x_input_Component.exports);

// EXTERNAL MODULE: ./node_modules/_autosize@3.0.21@autosize/dist/autosize.js
var autosize = __webpack_require__("K2BN");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: _vux_2_9_4_vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var components_x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: _vux_2_9_4_vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6e755d96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-textarea/index.vue
var x_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){return _vm.$emit('on-focus')},"blur":function($event){return _vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var x_textarea_staticRenderFns = []
var x_textarea_esExports = { render: x_textarea_render, staticRenderFns: x_textarea_staticRenderFns }
/* harmony default export */ var src_components_x_textarea = (x_textarea_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/x-textarea/index.vue
function x_textarea_injectStyle (ssrContext) {
  __webpack_require__("NYDs")
}
var x_textarea_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var x_textarea___vue_template_functional__ = false
/* styles */
var x_textarea___vue_styles__ = x_textarea_injectStyle
/* scopeId */
var x_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_textarea___vue_module_identifier__ = null
var x_textarea_Component = x_textarea_normalizeComponent(
  components_x_textarea,
  src_components_x_textarea,
  x_textarea___vue_template_functional__,
  x_textarea___vue_styles__,
  x_textarea___vue_scopeId__,
  x_textarea___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_x_textarea = (x_textarea_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-8f9b9714","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("HemK")
}
var x_button_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_x_button = (x_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(router["a" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(router["a" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-561068d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/card/index.vue
var card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header && _vm.header.title)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header.title)},on:{"click":function($event){return _vm.$emit('on-click-header')}}}):_vm._e(),_vm._v(" "),_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_c('div',{staticClass:"vux-card-content"},[_vm._t("content")],2)]),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title)?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":"javascript:"},on:{"click":_vm.onClickFooter}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()]),_vm._v(" "),_vm._t("footer")],2)}
var card_staticRenderFns = []
var card_esExports = { render: card_render, staticRenderFns: card_staticRenderFns }
/* harmony default export */ var src_components_card = (card_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/card/index.vue
function card_injectStyle (ssrContext) {
  __webpack_require__("dqEk")
}
var card_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var card___vue_template_functional__ = false
/* styles */
var card___vue_styles__ = card_injectStyle
/* scopeId */
var card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var card___vue_module_identifier__ = null
var card_Component = card_normalizeComponent(
  components_card,
  src_components_card,
  card___vue_template_functional__,
  card___vue_styles__,
  card___vue_scopeId__,
  card___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_card = (card_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("v4/V");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-113674a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-dialog/index.vue
var x_dialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var x_dialog_staticRenderFns = []
var x_dialog_esExports = { render: x_dialog_render, staticRenderFns: x_dialog_staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (x_dialog_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/x-dialog/index.vue
function x_dialog_injectStyle (ssrContext) {
  __webpack_require__("IhRb")
}
var x_dialog_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var x_dialog___vue_template_functional__ = false
/* styles */
var x_dialog___vue_styles__ = x_dialog_injectStyle
/* scopeId */
var x_dialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_dialog___vue_module_identifier__ = null
var x_dialog_Component = x_dialog_normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  x_dialog___vue_template_functional__,
  x_dialog___vue_styles__,
  x_dialog___vue_scopeId__,
  x_dialog___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_x_dialog = (x_dialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: _vux_2_9_4_vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: _vux_2_9_4_vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-336e027e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/alert/index.vue
var alert_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var alert_staticRenderFns = []
var alert_esExports = { render: alert_render, staticRenderFns: alert_staticRenderFns }
/* harmony default export */ var _vux_2_9_4_vux_src_components_alert = (alert_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/alert/index.vue
function alert_injectStyle (ssrContext) {
  __webpack_require__("1Uz0")
}
var alert_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var alert___vue_template_functional__ = false
/* styles */
var alert___vue_styles__ = alert_injectStyle
/* scopeId */
var alert___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var alert___vue_module_identifier__ = null
var alert_Component = alert_normalizeComponent(
  src_components_alert,
  _vux_2_9_4_vux_src_components_alert,
  alert___vue_template_functional__,
  alert___vue_styles__,
  alert___vue_scopeId__,
  alert___vue_module_identifier__
)


/* harmony default export */ var node_modules__vux_2_9_4_vux_src_components_alert = (alert_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-114a9e2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/loading/index.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var src_components_loading = (loading_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/loading/index.vue
function loading_injectStyle (ssrContext) {
  __webpack_require__("kC67")
}
var loading_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  components_loading,
  src_components_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)


/* harmony default export */ var _vux_2_9_4_vux_src_components_loading = (loading_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("uiKT");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c65b5366","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/flexbox/flexbox.vue
var flexbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var flexbox_staticRenderFns = []
var flexbox_esExports = { render: flexbox_render, staticRenderFns: flexbox_staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (flexbox_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/flexbox/flexbox.vue
function flexbox_injectStyle (ssrContext) {
  __webpack_require__("kf5t")
}
var flexbox_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var flexbox___vue_template_functional__ = false
/* styles */
var flexbox___vue_styles__ = flexbox_injectStyle
/* scopeId */
var flexbox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flexbox___vue_module_identifier__ = null
var flexbox_Component = flexbox_normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  flexbox___vue_template_functional__,
  flexbox___vue_styles__,
  flexbox___vue_scopeId__,
  flexbox___vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = (flexbox_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-8d62c4e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/flexbox/flexbox-item.vue
var flexbox_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var flexbox_item_staticRenderFns = []
var flexbox_item_esExports = { render: flexbox_item_render, staticRenderFns: flexbox_item_staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (flexbox_item_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/flexbox/flexbox-item.vue
var flexbox_item_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var flexbox_item___vue_template_functional__ = false
/* styles */
var flexbox_item___vue_styles__ = null
/* scopeId */
var flexbox_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flexbox_item___vue_module_identifier__ = null
var flexbox_item_Component = flexbox_item_normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  flexbox_item___vue_template_functional__,
  flexbox_item___vue_styles__,
  flexbox_item___vue_scopeId__,
  flexbox_item___vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = (flexbox_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("cluC");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/components/radio/props.js
var radio_props = __webpack_require__("kzuz");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-e19cfe9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])],{"icon":one.icon,"label":_vm.getValue(one),"index":index,"selected":_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){return _vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var _vux_2_9_4_vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("uOi8")
}
var radio_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  _vux_2_9_4_vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules__vux_2_9_4_vux_src_components_radio = (radio_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-426ac4e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/tip/index.vue
var tip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-group-tip",style:({'text-align':_vm.align})},[_vm._t("default")],2)}
var tip_staticRenderFns = []
var tip_esExports = { render: tip_render, staticRenderFns: tip_staticRenderFns }
/* harmony default export */ var src_components_tip = (tip_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/tip/index.vue
function tip_injectStyle (ssrContext) {
  __webpack_require__("OKWU")
}
var tip_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var tip___vue_template_functional__ = false
/* styles */
var tip___vue_styles__ = tip_injectStyle
/* scopeId */
var tip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tip___vue_module_identifier__ = null
var tip_Component = tip_normalizeComponent(
  components_tip,
  src_components_tip,
  tip___vue_template_functional__,
  tip___vue_styles__,
  tip___vue_scopeId__,
  tip___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_tip = (tip_Component.exports);

// EXTERNAL MODULE: ./node_modules/_array-shuffle@1.0.1@array-shuffle/index.js
var _array_shuffle_1_0_1_array_shuffle = __webpack_require__("Cvau");
var _array_shuffle_1_0_1_array_shuffle_default = /*#__PURE__*/__webpack_require__.n(_array_shuffle_1_0_1_array_shuffle);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var checklist = ({
  name: 'checklist',
  components: {
    Tip: _vux_2_9_4_vux_src_components_tip,
    Icon: _vux_2_9_4_vux_src_components_icon,
    InlineDesc: _vux_2_9_4_vux_src_components_inline_desc
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = _array_shuffle_1_0_1_array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_checklist = ({
  name: 'checklist',
  components: {
    Tip: _vux_2_9_4_vux_src_components_tip,
    Icon: _vux_2_9_4_vux_src_components_icon,
    InlineDesc: _vux_2_9_4_vux_src_components_inline_desc
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = checklist_pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = _array_shuffle_1_0_1_array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = checklist_pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function checklist_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-21f4f3d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/checklist/index.vue
var checklist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.disabled ? 'vux-checklist-disabled' : ''},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}],staticClass:"weui-cells__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("after-title"),_vm._v(" "),_c('div',{staticClass:"weui-cells weui-cells_checkbox"},_vm._l((_vm.currentOptions),function(one,index){return _c('label',{staticClass:"weui-cell weui-check_label",class:{
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },attrs:{"for":("checkbox_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__hd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"checkbox","name":("vux-checkbox-" + _vm.uuid),"id":_vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),"disabled":_vm.isDisabled(_vm.getKey(one))},domProps:{"value":_vm.getKey(one),"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,_vm.getKey(one))>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.getKey(one),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),_c('i',{staticClass:"weui-icon-checked vux-checklist-icon-checked"})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getValue(one))}}),_vm._v(" "),(_vm.getInlineDesc(one))?_c('inline-desc',[_vm._v(_vm._s(_vm.getInlineDesc(one)))]):_vm._e()],1)])}),0),_vm._v(" "),_vm._t("footer")],2)}
var checklist_staticRenderFns = []
var checklist_esExports = { render: checklist_render, staticRenderFns: checklist_staticRenderFns }
/* harmony default export */ var src_components_checklist = (checklist_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/checklist/index.vue
function checklist_injectStyle (ssrContext) {
  __webpack_require__("ZqFO")
}
var checklist_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var checklist___vue_template_functional__ = false
/* styles */
var checklist___vue_styles__ = checklist_injectStyle
/* scopeId */
var checklist___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checklist___vue_module_identifier__ = null
var checklist_Component = checklist_normalizeComponent(
  components_checklist,
  src_components_checklist,
  checklist___vue_template_functional__,
  checklist___vue_styles__,
  checklist___vue_scopeId__,
  checklist___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_checklist = (checklist_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/components/datetime/datetimepicker.js + 6 modules
var datetimepicker = __webpack_require__("eSZc");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/mixins/uuid.js
var uuid = __webpack_require__("trHK");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/tools/date/format.js
var date_format = __webpack_require__("eFjK");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: _vux_2_9_4_vux_src_components_group,
    InlineDesc: _vux_2_9_4_vux_src_components_inline_desc,
    Icon: _vux_2_9_4_vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: _vux_2_9_4_vux_src_components_group,
    InlineDesc: _vux_2_9_4_vux_src_components_inline_desc,
    Icon: _vux_2_9_4_vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-73feec0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var datetime_staticRenderFns = []
var datetime_esExports = { render: datetime_render, staticRenderFns: datetime_staticRenderFns }
/* harmony default export */ var src_components_datetime = (datetime_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/datetime/index.vue
function datetime_injectStyle (ssrContext) {
  __webpack_require__("FAmo")
}
var datetime_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var datetime___vue_template_functional__ = false
/* styles */
var datetime___vue_styles__ = datetime_injectStyle
/* scopeId */
var datetime___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime___vue_module_identifier__ = null
var datetime_Component = datetime_normalizeComponent(
  components_datetime,
  src_components_datetime,
  datetime___vue_template_functional__,
  datetime___vue_styles__,
  datetime___vue_scopeId__,
  datetime___vue_module_identifier__
)


/* harmony default export */ var _vux_2_9_4_vux_src_components_datetime = (datetime_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1f824696","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/divider/index.vue
var divider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"vux-divider"},[_vm._t("default")],2)}
var divider_staticRenderFns = []
var divider_esExports = { render: divider_render, staticRenderFns: divider_staticRenderFns }
/* harmony default export */ var src_components_divider = (divider_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/divider/index.vue
function divider_injectStyle (ssrContext) {
  __webpack_require__("gLuL")
}
var divider_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var divider___vue_template_functional__ = false
/* styles */
var divider___vue_styles__ = divider_injectStyle
/* scopeId */
var divider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var divider___vue_module_identifier__ = null
var divider_Component = divider_normalizeComponent(
  components_divider,
  src_components_divider,
  divider___vue_template_functional__,
  divider___vue_styles__,
  divider___vue_scopeId__,
  divider___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_divider = (divider_Component.exports);

// EXTERNAL MODULE: ./node_modules/_axios@0.19.2@axios/index.js
var _axios_0_19_2_axios = __webpack_require__("I29D");
var _axios_0_19_2_axios_default = /*#__PURE__*/__webpack_require__.n(_axios_0_19_2_axios);

// CONCATENATED MODULE: ./src/bus.js

/* harmony default export */ var bus = (new vue_esm["a" /* default */]());
// CONCATENATED MODULE: ./src/utils.js
var Debounce = function Debounce(fn, time) {
    var delay = time || 500;
    var timer = void 0;
    return function () {
        var args = arguments;
        if (timer) {
            clearTimeout(timer);
        }

        var callNow = !timer;

        timer = setTimeout(function () {
            timer = null;
        }, delay);

        if (callNow) fn.apply(this, args);
    };
};
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var check_icon = ({
  name: 'check-icon',
  components: {
    Icon: _vux_2_9_4_vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_check_icon = ({
  name: 'check-icon',
  components: {
    Icon: _vux_2_9_4_vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-81b952b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/check-icon/index.vue
var check_icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-check-icon",on:{"click":_vm.updateValue}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'default' && _vm.value),expression:"type === 'default' && value"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'plain' && _vm.value),expression:"type === 'plain' && value"}],attrs:{"type":"success_circle"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],attrs:{"type":"circle"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var check_icon_staticRenderFns = []
var check_icon_esExports = { render: check_icon_render, staticRenderFns: check_icon_staticRenderFns }
/* harmony default export */ var src_components_check_icon = (check_icon_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/check-icon/index.vue
function check_icon_injectStyle (ssrContext) {
  __webpack_require__("1jZ7")
}
var check_icon_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var check_icon___vue_template_functional__ = false
/* styles */
var check_icon___vue_styles__ = check_icon_injectStyle
/* scopeId */
var check_icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var check_icon___vue_module_identifier__ = null
var check_icon_Component = check_icon_normalizeComponent(
  components_check_icon,
  src_components_check_icon,
  check_icon___vue_template_functional__,
  check_icon___vue_styles__,
  check_icon___vue_scopeId__,
  check_icon___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_check_icon = (check_icon_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/Disclaimer.vue





/* harmony default export */ var Disclaimer = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XDialog: _vux_2_9_4_vux_src_components_x_dialog, CheckIcon: _vux_2_9_4_vux_src_components_check_icon
  },
  data: function data() {
    return {
      showmodal: false,
      checkIconValue: false,
      systemId: ''
    };
  },

  methods: {
    handleLink: function handleLink() {
      this.showmodal = !this.showmodal;
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/Disclaimer.vue





/* harmony default export */ var components_Disclaimer = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XDialog: _vux_2_9_4_vux_src_components_x_dialog, CheckIcon: _vux_2_9_4_vux_src_components_check_icon
  },
  data: function data() {
    return {
      showmodal: false,
      checkIconValue: false,
      systemId: ''
    };
  },

  methods: {
    handleLink: function handleLink() {
      this.showmodal = !this.showmodal;
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-fc8e7eaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Disclaimer.vue
var Disclaimer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disclaimer"},[_c('check-icon',{attrs:{"value":_vm.checkIconValue,"type":"plain"},on:{"update:value":function($event){_vm.checkIconValue=$event}}},[_vm._v("我已阅读并同意")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"#"},on:{"click":_vm.handleLink}},[_vm._v("《用户使用规则及免责声明》")]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.showmodal),expression:"showmodal"}],staticClass:"disclaimer-mask",staticStyle:{"z-index":"5002"}},[_c('div',{staticStyle:{"padding":"10px"}},[_c('span',{staticStyle:{"position":"absolute","top":"15px","z-index":"1000","left":"10px"},on:{"click":_vm.handleLink}},[_vm._v("<返回")]),_vm._v(" "),_c('h1',{staticClass:"vux-1px-b"},[_vm._v("免责声明")]),_vm._v(" "),_c('h2',[_vm._v("第一条 协议订立")]),_vm._v(" "),(_vm.systemId==0)?_c('p',[_vm._v("\n        1.1用户在同意本网站:智慧云采丨物资采购全球供需平台 (\n        "),_c('a',{attrs:{"href":"https://yc.yonyoucloud.com/cpu-relief/"}},[_vm._v("https://yc.yonyoucloud.com/cpu-relief/")]),_vm._v(")的免责协议后，方可使用本网络服务平台(以下简称“平台”)提供的物资供需信息相关服务(以下简称“服务”)。\n      ")]):_vm._e(),_vm._v(" "),(_vm.systemId==1)?_c('p',[_vm._v("\n        1.1用户在同意本网站:互助汇丨防疫物资紧急采购发布平台 (\n        "),_c('a',{attrs:{"href":"https://yc.yonyoucloud.com/cpu-relief/?tag=hzh"}},[_vm._v("https://yc.yonyoucloud.com/cpu-relief/?tag=hzh")]),_vm._v(")的免责协议后，方可使用本网络服务平台(以下简称“平台”)提供的疫情防护物资供需信息相关服务(以下简称“服务”)。\n      ")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("1.2用户在使用本平台提供的服务前请务必认真阅读本协议，一旦用户使用本平台提供的服务即表示用户同意与本平台签订本协议且同意受本协议之约束。")]),_vm._v(" "),_c('h2',[_vm._v("第二条 服务说明")]),_vm._v(" "),_c('p',[_vm._v("2.1 通过本平台获取的捐赠机构、组织和个体，平台均称为 “捐赠方”，通过本平台获取的物资供应商，平台均称为 “供应方”。本平台仅为技术服务提供方。")]),_vm._v(" "),_c('p',[_vm._v("2.2 由于情况各异且随时会发生变化，本平台所有供应方、捐赠方目前均无法承诺实际情况。")]),_vm._v(" "),_c('p',[_vm._v("2.3 需求内容以各机构在各大官方发布信息为准(认证微博、官方微信公众号、医院盖章文件等)，平台只做内容收集展示及部分人工核实。")]),_vm._v(" "),_c('h2',[_vm._v("第三条 用户的权利和义务")]),_vm._v(" "),_c('p',[_vm._v("3.1 用户使用本平台前，应仔细阅读各方具体信息。本协议中涉及交易双方、捐赠双方权利义务的内容，如有与我国相关法律冲突的，以我国相关法律为准。")]),_vm._v(" "),_c('p',[_vm._v("3.2 用户发布信息时，应当准确填写物资类目及具体数量等信息内容。")]),_vm._v(" "),_c('p',[_vm._v("3.3 如采购方、捐赠方需取得相应凭证，应与相关合作单位联系取得。在交易和捐赠等过程中，如因各项事宜产生争议，由用户与对应方协商解决。")]),_vm._v(" "),_c('p',[_vm._v("3.4 用户同意本平台向购买方、需求方、捐赠方、接受捐赠方等相关单位披露用户提交的信息中所涉及的各项内容（包括但不限于所在单位、联系电话等个人信息）。")]),_vm._v(" "),_c('h2',[_vm._v("第四条 免责说明")]),_vm._v(" "),_c('p',[_vm._v("4.1 因疫情变化，本平台显示的信息仅供参考，最终以实际供应及需求为准。")]),_vm._v(" "),_c('p',[_vm._v("4.2 因用户提供错误信息所导致的损失，由用户自行承担，本平台不承担任何责任。")]),_vm._v(" "),_c('p',[_vm._v("4.3 用户充分知晓并认可，本平台仅为公益性信息平台，物资供应方与需求方、捐赠方产生任何纠纷与本平台无关，本平台不因平台服务而承担任何担保、保证或连带责任。")]),_vm._v(" "),_c('p',[_vm._v("4.4 本平台会尽力维护平台信息的安全，但法律规定的不可抗力，以及因为黑客入侵、计算机病毒等原因造成用户资料泄露、丢失、被盗用、被篡改的，本平台不承担任何责任。")]),_vm._v(" "),_c('p',[_vm._v("4.5 本平台仅提供技术服务，不是交易合同、赠与合同等合同的权利义务主体，不介入用户与交易方之间的纠纷，但本平台将提供协助，保护用户的合法权益。")]),_vm._v(" "),_c('p',[_vm._v("4.6 本平台如被恶意篡改用于不正当募捐和交易使用，一律追责。")]),_vm._v(" "),(_vm.systemId==0)?_c('p',[_vm._v("\n        4.7 本平台唯一官方网址\n        "),_c('a',{attrs:{"href":"https://yc.yonyoucloud.com/cpu-relief/"}},[_vm._v("https://yc.yonyoucloud.com/cpu-relief/")]),_vm._v(" (智慧云采丨物资采购全球供需平台)如被人恶意假借名义进行不正当行为，与本平台无关。但本平台保留追究其法律责任的权利。\n      ")]):_vm._e(),_vm._v(" "),(_vm.systemId==1)?_c('p',[_vm._v("\n        4.7 本平台唯一官方网址\n        "),_c('a',{attrs:{"href":"https://yc.yonyoucloud.com/cpu-relief/?tag=hzh"}},[_vm._v("https://yc.yonyoucloud.com/cpu-relief/?tag=hzh")]),_vm._v(" (互助汇丨防疫物资紧急采购需求发布平台)如被人恶意假借名义进行不正当行为，与本平台无关。但本平台保留追究其法律责任的权利。\n      ")]):_vm._e(),_vm._v(" "),_c('h2',[_vm._v("第五条 争议解决及法律适用")]),_vm._v(" "),_c('p',[_vm._v("5.1 在用户有意向捐赠、求购、发布信息后，如果在约定内容履行过程中，对相关事宜的履行发生争议，用户同意按照中华人民共和国现行有效的相关法律法规来解决争议，并同意接受平台方所在地有管辖权的人民法院的管辖。")])])])],1)}
var Disclaimer_staticRenderFns = []
var Disclaimer_esExports = { render: Disclaimer_render, staticRenderFns: Disclaimer_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Disclaimer = (Disclaimer_esExports);
// CONCATENATED MODULE: ./src/components/Disclaimer.vue
function Disclaimer_injectStyle (ssrContext) {
  __webpack_require__("3xIv")
}
var Disclaimer_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var Disclaimer___vue_template_functional__ = false
/* styles */
var Disclaimer___vue_styles__ = Disclaimer_injectStyle
/* scopeId */
var Disclaimer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Disclaimer___vue_module_identifier__ = null
var Disclaimer_Component = Disclaimer_normalizeComponent(
  components_Disclaimer,
  selectortype_template_index_0_src_components_Disclaimer,
  Disclaimer___vue_template_functional__,
  Disclaimer___vue_styles__,
  Disclaimer___vue_scopeId__,
  Disclaimer___vue_module_identifier__
)

/* harmony default export */ var src_components_Disclaimer = (Disclaimer_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/AddSubmit.vue















/* harmony default export */ var AddSubmit = ({
  name: 'AddSubmit',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    TransferDom: transfer_dom["a" /* default */], XDialog: _vux_2_9_4_vux_src_components_x_dialog, Group: _vux_2_9_4_vux_src_components_group, XInput: _vux_2_9_4_vux_src_components_x_input, XTextarea: _vux_2_9_4_vux_src_components_x_textarea, XButton: _vux_2_9_4_vux_src_components_x_button, Flexbox: src_components_flexbox_flexbox, FlexboxItem: src_components_flexbox_flexbox_item, Toast: _vux_2_9_4_vux_src_components_toast,
    Disclaimer: src_components_Disclaimer
  },
  props: ['showmodal', 'infoPlaceHolder', 'info', 'type'],
  data: function data() {
    return {
      name: '',
      nameIcon: '',
      location: '',
      locationIcon: '',
      phone: '',
      phoneIcon: '',
      materialDes: '',
      isToast: false,
      toastMsg: '提交成功',
      toastType: 'success'
    };
  },

  watch: {
    showmodal: function showmodal(v) {}
  },
  methods: {
    setIconType: function setIconType(v, icon) {
      if (v == "") {
        this[icon] = "error";
      } else {
        this[icon] = "success";
      }
    },

    submit: Debounce(function () {

      var _this = this;
      if (this.name == "") {
        this.nameIcon = "error";
        return;
      }
      if (this.location == "") {
        this.locationIcon = "error";
        return;
      }
      if (this.phone == "") {
        this.phoneIcon = "error";
        return;
      }
      if (this.materialDes == "") {
        this.isToast = true;
        this.toastMsg = this.info + '\u5FC5\u586B';
        this.toastType = "text";
        return;
      }

      _axios_0_19_2_axios_default.a.post('/yuncai-yop/contribute/save', {
        name: this.name,
        phone: this.phone,
        location: this.location,
        materialDes: this.materialDes,
        type: this.type,
        systemId: 0
      }).then(function (res) {
        _this.isToast = true;
        _this.toastMsg = "提交成功,物资信息需经平台审核通过后方可公布出来";
        _this.toastType = "success";
        console.log(res);
      }).catch(function (err) {
        console.log(err);
        _this.isToast = true;
        _this.toastMsg = "提交失败";
        _this.toastType = "warn";
      });
    }, 3000),
    close: function close() {
      bus.$emit("close-modal", false);
    },
    toastHide: function toastHide() {
      if (this.toastType !== "text") {
        this.name = '';
        this.phone = '';
        this.location = '';
        this.materialDes = '';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/AddSubmit.vue















/* harmony default export */ var components_AddSubmit = ({
  name: 'AddSubmit',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    TransferDom: transfer_dom["a" /* default */], XDialog: _vux_2_9_4_vux_src_components_x_dialog, Group: _vux_2_9_4_vux_src_components_group, XInput: _vux_2_9_4_vux_src_components_x_input, XTextarea: _vux_2_9_4_vux_src_components_x_textarea, XButton: _vux_2_9_4_vux_src_components_x_button, Flexbox: src_components_flexbox_flexbox, FlexboxItem: src_components_flexbox_flexbox_item, Toast: _vux_2_9_4_vux_src_components_toast,
    Disclaimer: src_components_Disclaimer
  },
  props: ['showmodal', 'infoPlaceHolder', 'info', 'type'],
  data: function data() {
    return {
      name: '',
      nameIcon: '',
      location: '',
      locationIcon: '',
      phone: '',
      phoneIcon: '',
      materialDes: '',
      isToast: false,
      toastMsg: '提交成功',
      toastType: 'success'
    };
  },

  watch: {
    showmodal: function showmodal(v) {}
  },
  methods: {
    setIconType: function setIconType(v, icon) {
      if (v == "") {
        this[icon] = "error";
      } else {
        this[icon] = "success";
      }
    },

    submit: Debounce(function () {

      var _this = this;
      if (this.name == "") {
        this.nameIcon = "error";
        return;
      }
      if (this.location == "") {
        this.locationIcon = "error";
        return;
      }
      if (this.phone == "") {
        this.phoneIcon = "error";
        return;
      }
      if (this.materialDes == "") {
        this.isToast = true;
        this.toastMsg = this.info + '\u5FC5\u586B';
        this.toastType = "text";
        return;
      }

      _axios_0_19_2_axios_default.a.post('/yuncai-yop/contribute/save', {
        name: this.name,
        phone: this.phone,
        location: this.location,
        materialDes: this.materialDes,
        type: this.type,
        systemId: 0
      }).then(function (res) {
        _this.isToast = true;
        _this.toastMsg = "提交成功,物资信息需经平台审核通过后方可公布出来";
        _this.toastType = "success";
        console.log(res);
      }).catch(function (err) {
        console.log(err);
        _this.isToast = true;
        _this.toastMsg = "提交失败";
        _this.toastType = "warn";
      });
    }, 3000),
    close: function close() {
      bus.$emit("close-modal", false);
    },
    toastHide: function toastHide() {
      if (this.toastType !== "text") {
        this.name = '';
        this.phone = '';
        this.location = '';
        this.materialDes = '';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-110aec06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/AddSubmit.vue
var AddSubmit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{attrs:{"dialog-style":{'max-width': '100%', width: '95%', 'background-color': '#FFF'},"hide-on-blur":"","scroll":false},model:{value:(_vm.showmodal),callback:function ($$v) {_vm.showmodal=$$v},expression:"showmodal"}},[_c('div',[_c('div',{staticClass:"i-feedback",staticStyle:{"text-align":"left"}},[_c('p',{staticClass:"red",staticStyle:{"padding":"10px 9px 0 9px","text-align":"left"}},[_vm._t("header",[_vm._v("\n                    如果您在疫情防控工作中，存在防护物资的短缺情况，请按照\n                    以下格式真实反馈，我们将全力助您查寻对应供货渠道(请真实填写)\n                ")])],2),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title1"},[_vm._v("个人信息")]),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"我的真实姓名："}},[_c('x-input',{staticClass:"form-input",attrs:{"type":"text","is-type":"china-name","icon-type":_vm.nameIcon,"placeholder":"请输入真实姓名","novalidate":"","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.name,'nameIcon')}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"企业名称："}},[_c('x-input',{staticClass:"form-input",attrs:{"placeholder":"请输入企业名称","icon-type":_vm.locationIcon,"novalidate":"","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.location,'locationIcon')}},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})],1),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"联系电话："}},[_c('x-input',{staticClass:"form-input",attrs:{"placeholder":"请输入真实联系电话","icon-type":_vm.phoneIcon,"novalidate":"","type":"number","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.phone,'phoneIcon')}},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title1"},[_vm._v(_vm._s(_vm.info||'短缺物资信息'))]),_vm._v(" "),_c('group',{staticClass:"form-group no-title",attrs:{"title":""}},[_c('x-textarea',{staticClass:"form-input textarea-bg",attrs:{"max":400,"placeholder":_vm.infoPlaceHolder||'请填写物资名称及数量，详细的规格型号或其他补充说明（最多可输入400字）',"required":""},model:{value:(_vm.materialDes),callback:function ($$v) {_vm.materialDes=$$v},expression:"materialDes"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-submit",staticStyle:{"padding-bottom":"20px"}},[_c('disclaimer'),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"submit",staticStyle:{"text-align":"center"},on:{"click":_vm.submit}},[_vm._v("提交")])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"submit",staticStyle:{"text-align":"center","background":"#FFF","color":"#333"},on:{"click":_vm.close}},[_vm._v("关闭")])])],1)],1)])])])],1),_vm._v(" "),_c('toast',{attrs:{"text":_vm.toastMsg,"type":_vm.toastType},on:{"on-hide":_vm.toastHide},model:{value:(_vm.isToast),callback:function ($$v) {_vm.isToast=$$v},expression:"isToast"}})],1)}
var AddSubmit_staticRenderFns = []
var AddSubmit_esExports = { render: AddSubmit_render, staticRenderFns: AddSubmit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_AddSubmit = (AddSubmit_esExports);
// CONCATENATED MODULE: ./src/components/AddSubmit.vue
function AddSubmit_injectStyle (ssrContext) {
  __webpack_require__("Tms6")
}
var AddSubmit_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var AddSubmit___vue_template_functional__ = false
/* styles */
var AddSubmit___vue_styles__ = AddSubmit_injectStyle
/* scopeId */
var AddSubmit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AddSubmit___vue_module_identifier__ = null
var AddSubmit_Component = AddSubmit_normalizeComponent(
  components_AddSubmit,
  selectortype_template_index_0_src_components_AddSubmit,
  AddSubmit___vue_template_functional__,
  AddSubmit___vue_styles__,
  AddSubmit___vue_scopeId__,
  AddSubmit___vue_module_identifier__
)

/* harmony default export */ var src_components_AddSubmit = (AddSubmit_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/VehicleRequire.vue







/* harmony default export */ var VehicleRequire = ({
  name: 'VehicleRequire',
  components: {
    Divider: _vux_2_9_4_vux_src_components_divider,
    AddSubmit: src_components_AddSubmit,
    Loading: _vux_2_9_4_vux_src_components_loading
  },
  props: ['imgList', 'hasAuth', 'showmodal3'],
  watch: {},
  data: function data() {
    return {
      list: [],
      pageNum: 0,
      isLoading: false,
      loadingText: '',
      positionimg2: __webpack_require__("chPc"),
      systemId: ''
    };
  },

  methods: {
    getOtherList: function getOtherList() {
      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this = this;
      var data = {
        pageNum: pageNum,
        pageSize: 10,
        type: 2,
        systemId: _this.systemID
      };
      if (this.hasAuth) {
        data.auth = 1;
      }
      this.isLoading = true;
      this.loadingText = "加载中...";
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contribute/page", data).then(function (res) {
        if (res.status == 200) {
          var list = res.data.data.list || [];
          _this.list = _this.list.concat(list);
          if (res.data.data.nextPage > 0) {
            _this.pageNum = res.data.data.nextPage - 1;
          } else {
            _this.pageNum = 0;
          }
        }
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }
    this.getOtherList();
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/VehicleRequire.vue







/* harmony default export */ var components_VehicleRequire = ({
  name: 'VehicleRequire',
  components: {
    Divider: _vux_2_9_4_vux_src_components_divider,
    AddSubmit: src_components_AddSubmit,
    Loading: _vux_2_9_4_vux_src_components_loading
  },
  props: ['imgList', 'hasAuth', 'showmodal3'],
  watch: {},
  data: function data() {
    return {
      list: [],
      pageNum: 0,
      isLoading: false,
      loadingText: '',
      positionimg2: __webpack_require__("chPc"),
      systemId: ''
    };
  },

  methods: {
    getOtherList: function getOtherList() {
      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this = this;
      var data = {
        pageNum: pageNum,
        pageSize: 10,
        type: 2,
        systemId: _this.systemID
      };
      if (this.hasAuth) {
        data.auth = 1;
      }
      this.isLoading = true;
      this.loadingText = "加载中...";
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contribute/page", data).then(function (res) {
        if (res.status == 200) {
          var list = res.data.data.list || [];
          _this.list = _this.list.concat(list);
          if (res.data.data.nextPage > 0) {
            _this.pageNum = res.data.data.nextPage - 1;
          } else {
            _this.pageNum = 0;
          }
        }
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }
    this.getOtherList();
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6267fbcb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/VehicleRequire.vue
var VehicleRequire_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vehicle-require"},[_c('p',{staticClass:"red",staticStyle:{"padding":"0 20px 15px 20px"}},[_vm._v("\n      如您需要物流资源支持，请按照要求认真填写并进行发布！\n  ")]),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"0","padding":"10px"}},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"container",staticStyle:{"box-shadow":"0 2px 15px 1px #B8BDF6","border-radius":"4px"}},[_c('div',{staticClass:"vux-1px-b",staticStyle:{"font-size":"15px","color":"#333","font-weight":"bold","padding-left":"10px","line-height":"28px","padding-bottom":"2px"}},[_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.positionimg2,"width":"20px"}}),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle","color":"#333"}},[_vm._v(_vm._s(item.location))])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 24px 0 10px","font-size":"14px","color":"#333"}},[_c('span',{staticStyle:{"margin-top":"6px"}},[_vm._v("需求：")]),_vm._v(" "),_c('span',{staticStyle:{"margin-top":"4px"}},[_vm._v(_vm._s(item.materialDes))]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","padding-right":"10px","margin-top":"10px"}},[_c('div',{staticStyle:{"position":"relative","right":"-20px","bottom":"5px"}},[_vm._v(_vm._s(item.name + ' ' + item.phone))])])]),_vm._v(" "),(index == _vm.imgList.length -1)?_c('div',{staticStyle:{"height":"8px","background-color":"#666"}}):_vm._e()])}),_vm._v(" "),(_vm.pageNum > 0)?_c('a',{staticClass:"more",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getOtherList(_vm.pageNum)}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(_vm.pageNum <= 0)?_c('divider',[_vm._v("已经到底了")]):_vm._e()],2),_vm._v(" "),_c('AddSubmit',{attrs:{"showmodal":_vm.showmodal3,"info":"车辆需求信息","field1":2,"infoPlaceHolder":"请填写需要的车辆车型，运输区域，计划运输时间区间，计划运输物品或其他补充说明（最多可输入400字）"}},[_c('template',{slot:"header"},[_vm._v("\n      为确保防护物资能第一时间送抵目的地，如您需要物流资源支持，请填写真实需求发布！\n    ")])],2),_vm._v(" "),_c('loading',{attrs:{"show":_vm.isLoading,"text":_vm.loadingText}})],1)}
var VehicleRequire_staticRenderFns = []
var VehicleRequire_esExports = { render: VehicleRequire_render, staticRenderFns: VehicleRequire_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_VehicleRequire = (VehicleRequire_esExports);
// CONCATENATED MODULE: ./src/components/VehicleRequire.vue
function VehicleRequire_injectStyle (ssrContext) {
  __webpack_require__("j4n6")
}
var VehicleRequire_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var VehicleRequire___vue_template_functional__ = false
/* styles */
var VehicleRequire___vue_styles__ = VehicleRequire_injectStyle
/* scopeId */
var VehicleRequire___vue_scopeId__ = "data-v-6267fbcb"
/* moduleIdentifier (server only) */
var VehicleRequire___vue_module_identifier__ = null
var VehicleRequire_Component = VehicleRequire_normalizeComponent(
  components_VehicleRequire,
  selectortype_template_index_0_src_components_VehicleRequire,
  VehicleRequire___vue_template_functional__,
  VehicleRequire___vue_styles__,
  VehicleRequire___vue_scopeId__,
  VehicleRequire___vue_module_identifier__
)

/* harmony default export */ var src_components_VehicleRequire = (VehicleRequire_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/VehicleResource.vue







/* harmony default export */ var VehicleResource = ({
  name: 'VehicleResource',
  components: {
    Divider: _vux_2_9_4_vux_src_components_divider,
    AddSubmit: src_components_AddSubmit,
    Loading: _vux_2_9_4_vux_src_components_loading
  },
  props: ['imgList', 'hasAuth', 'showmodal4'],
  data: function data() {
    return {
      list: [],
      pageNum: 0,
      isLoading: false,
      loadingText: '',
      positionimg2: __webpack_require__("chPc"),
      systemId: ''
    };
  },

  methods: {
    getOtherList: function getOtherList() {
      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this = this;
      var data = {
        pageNum: pageNum,
        pageSize: 10,
        type: 3,
        systemId: this.systemId
      };
      if (this.hasAuth) {
        data.auth = 1;
      }
      this.isLoading = true;
      this.loadingText = "加载中...";
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contribute/page", data).then(function (res) {
        if (res.status == 200) {
          var list = res.data.data.list || [];
          _this.list = _this.list.concat(list);
          if (res.data.data.nextPage > 0) {
            _this.pageNum = res.data.data.nextPage - 1;
          } else {
            _this.pageNum = 0;
          }
        }
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }
    this.getOtherList();
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/VehicleResource.vue







/* harmony default export */ var components_VehicleResource = ({
  name: 'VehicleResource',
  components: {
    Divider: _vux_2_9_4_vux_src_components_divider,
    AddSubmit: src_components_AddSubmit,
    Loading: _vux_2_9_4_vux_src_components_loading
  },
  props: ['imgList', 'hasAuth', 'showmodal4'],
  data: function data() {
    return {
      list: [],
      pageNum: 0,
      isLoading: false,
      loadingText: '',
      positionimg2: __webpack_require__("chPc"),
      systemId: ''
    };
  },

  methods: {
    getOtherList: function getOtherList() {
      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this = this;
      var data = {
        pageNum: pageNum,
        pageSize: 10,
        type: 3,
        systemId: this.systemId
      };
      if (this.hasAuth) {
        data.auth = 1;
      }
      this.isLoading = true;
      this.loadingText = "加载中...";
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contribute/page", data).then(function (res) {
        if (res.status == 200) {
          var list = res.data.data.list || [];
          _this.list = _this.list.concat(list);
          if (res.data.data.nextPage > 0) {
            _this.pageNum = res.data.data.nextPage - 1;
          } else {
            _this.pageNum = 0;
          }
        }
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }
    this.getOtherList();
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-39ad05cf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/VehicleResource.vue
var VehicleResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vehicle-resource"},[_c('p',{staticClass:"red",staticStyle:{"padding":"0 20px 15px 20px"}},[_vm._v("\n        全国物流资源紧缺，如您有相关车辆物流资源，烦请发布！\n    ")]),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"0","padding":"10px"}},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"container",staticStyle:{"box-shadow":"0 2px 15px 1px #B8BDF6","border-radius":"4px"}},[_c('div',{staticClass:"vux-1px-b",staticStyle:{"font-size":"15px","color":"#333","font-weight":"bold","padding-left":"10px","line-height":"28px","padding-bottom":"2px"}},[_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.positionimg2,"width":"20px"}}),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle","color":"#333"}},[_vm._v(_vm._s(item.location))])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 24px 0 10px","font-size":"14px","color":"#333"}},[_c('span',{staticStyle:{"margin-top":"6px"}},[_vm._v("资源：")]),_vm._v(" "),_c('span',{staticStyle:{"margin-top":"4px"}},[_vm._v(_vm._s(item.materialDes))]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","padding-right":"10px","margin-top":"10px"}},[_c('div',{staticStyle:{"position":"relative","right":"-20px","bottom":"5px"}},[_vm._v(_vm._s(item.name + ' ' + item.phone))])])]),_vm._v(" "),(index == _vm.imgList.length -1)?_c('div',{staticStyle:{"height":"8px","background-color":"#666"}}):_vm._e()])}),_vm._v(" "),(_vm.pageNum > 0)?_c('a',{staticClass:"more",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getOtherList(_vm.pageNum)}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(_vm.pageNum <= 0)?_c('divider',[_vm._v("已经到底了")]):_vm._e()],2),_vm._v(" "),_c('AddSubmit',{attrs:{"showmodal":_vm.showmodal4,"info":"车辆资源信息","field1":"3","infoPlaceHolder":"请填写需要的车辆车型，运输区域，计划运输时间区间，计划运输物品或其他补充说明（最多可输入400字）"}},[_c('template',{slot:"header"},[_vm._v("\n    全国疫区物流资源紧缺，为确保防护物资能第一时间送抵目的地，如您有相关物流资源，烦请发布！\n  ")])],2),_vm._v(" "),_c('loading',{attrs:{"show":_vm.isLoading,"text":_vm.loadingText}})],1)}
var VehicleResource_staticRenderFns = []
var VehicleResource_esExports = { render: VehicleResource_render, staticRenderFns: VehicleResource_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_VehicleResource = (VehicleResource_esExports);
// CONCATENATED MODULE: ./src/components/VehicleResource.vue
function VehicleResource_injectStyle (ssrContext) {
  __webpack_require__("v8q4")
}
var VehicleResource_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var VehicleResource___vue_template_functional__ = false
/* styles */
var VehicleResource___vue_styles__ = VehicleResource_injectStyle
/* scopeId */
var VehicleResource___vue_scopeId__ = "data-v-39ad05cf"
/* moduleIdentifier (server only) */
var VehicleResource___vue_module_identifier__ = null
var VehicleResource_Component = VehicleResource_normalizeComponent(
  components_VehicleResource,
  selectortype_template_index_0_src_components_VehicleResource,
  VehicleResource___vue_template_functional__,
  VehicleResource___vue_styles__,
  VehicleResource___vue_scopeId__,
  VehicleResource___vue_module_identifier__
)

/* harmony default export */ var src_components_VehicleResource = (VehicleResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid_grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c423cada","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/grid/grid.vue
var grid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-grids",class:{
    'vux-grid-no-lr-borders': !_vm.showLrBorders
  }},[_vm._t("default")],2)}
var grid_staticRenderFns = []
var grid_esExports = { render: grid_render, staticRenderFns: grid_staticRenderFns }
/* harmony default export */ var components_grid_grid = (grid_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/grid/grid.vue
function grid_injectStyle (ssrContext) {
  __webpack_require__("3Rdu")
}
var grid_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var grid___vue_template_functional__ = false
/* styles */
var grid___vue_styles__ = grid_injectStyle
/* scopeId */
var grid___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid___vue_module_identifier__ = null
var grid_Component = grid_normalizeComponent(
  grid_grid,
  components_grid_grid,
  grid___vue_template_functional__,
  grid___vue_styles__,
  grid___vue_scopeId__,
  grid___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid = (grid_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["a" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["a" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4ceda955","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/grid/grid-item.vue
var grid_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-grid",class:{
    'vux-grid-item-no-border': (_vm.isLast && !_vm.$parent.showLrBorders) || (!_vm.isLast && !_vm.$parent.showVerticalDividers),
  },style:(_vm.style),attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[(_vm.hasIconSlot || _vm.icon)?_c('div',{staticClass:"weui-grid__icon"},[_vm._t("icon",[_c('img',{attrs:{"src":_vm.icon,"alt":""}})])],2):_vm._e(),_vm._v(" "),(_vm.hasLabelSlot || _vm.label)?_c('p',{staticClass:"weui-grid__label"},[_vm._t("label",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})])],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var grid_item_staticRenderFns = []
var grid_item_esExports = { render: grid_item_render, staticRenderFns: grid_item_staticRenderFns }
/* harmony default export */ var components_grid_grid_item = (grid_item_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/grid/grid-item.vue
function grid_item_injectStyle (ssrContext) {
  __webpack_require__("lhmy")
}
var grid_item_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var grid_item___vue_template_functional__ = false
/* styles */
var grid_item___vue_styles__ = grid_item_injectStyle
/* scopeId */
var grid_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid_item___vue_module_identifier__ = null
var grid_item_Component = grid_item_normalizeComponent(
  grid_grid_item,
  components_grid_grid_item,
  grid_item___vue_template_functional__,
  grid_item___vue_styles__,
  grid_item___vue_scopeId__,
  grid_item___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid_item = (grid_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("hRKE");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/_array-find@1.0.0@array-find/find.js
var find = __webpack_require__("qZvt");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var components_selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var components_selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: components_selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-597d193b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/selector/index.vue
var selector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(_vm.direction === 'rtl' ? one.value + '‎' : one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var selector_staticRenderFns = []
var selector_esExports = { render: selector_render, staticRenderFns: selector_staticRenderFns }
/* harmony default export */ var src_components_selector = (selector_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/selector/index.vue
function selector_injectStyle (ssrContext) {
  __webpack_require__("Q1Fw")
}
var selector_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var selector___vue_template_functional__ = false
/* styles */
var selector___vue_styles__ = selector_injectStyle
/* scopeId */
var selector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selector___vue_module_identifier__ = null
var selector_Component = selector_normalizeComponent(
  components_selector,
  src_components_selector,
  selector___vue_template_functional__,
  selector___vue_styles__,
  selector___vue_scopeId__,
  selector___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_selector = (selector_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/AddForm.vue


















/* harmony default export */ var AddForm = ({
  name: 'AddForm',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    TransferDom: transfer_dom["a" /* default */], XDialog: _vux_2_9_4_vux_src_components_x_dialog, Group: _vux_2_9_4_vux_src_components_group, XInput: _vux_2_9_4_vux_src_components_x_input, XTextarea: _vux_2_9_4_vux_src_components_x_textarea, XButton: _vux_2_9_4_vux_src_components_x_button, Flexbox: src_components_flexbox_flexbox, FlexboxItem: src_components_flexbox_flexbox_item, Toast: _vux_2_9_4_vux_src_components_toast, Grid: src_components_grid_grid, GridItem: src_components_grid_grid_item, Selector: _vux_2_9_4_vux_src_components_selector, Disclaimer: src_components_Disclaimer
  },
  props: ['showmodal', 'type'],
  watch: {
    showmodal: function showmodal(v) {
      var _this2 = this;

      var el = document.getElementById('app');
      this.scrollTop = v ? document.documentElement.scrollTop : this.scrollTop;
      el.hidden = v;
      if (!v) {
        setTimeout(function () {
          window.scrollTo({ top: _this2.scrollTop || 0, left: 0 });
        }, 200);
      }
    }
  },
  data: function data() {
    return {
      originatorNameText: '',
      materialNameText: '',
      entNameText: '',
      enterpriseName: '',
      name: '',
      location: '',
      phone: '',
      nameIcon: '',
      orgnameIcon: '',
      locationIcon: '',
      phoneIcon: '',
      isToast: false,
      toastMsg: '提交成功',
      toastType: 'success',
      pg2del: __webpack_require__("Ub/c"),
      systemId: '',
      list: [{ key: 'N95医用防护口罩（GB 19083-2010）及以上', value: 'N95医用防护口罩（GB 19083-2010）及以上' }, { key: '医用外科口罩（YY0469-2011)及以上', value: '医用外科口罩（YY0469-2011)及以上' }, { key: '防护服（GB 19082-2003）及以上', value: '防护服（GB 19082-2003）及以上' }, { key: '护目镜', value: '护目镜' }, { key: '医用帽', value: '医用帽' }, { key: '一次性手术衣', value: '一次性手术衣' }, { key: '医用一次性乳胶手套（GB 10213-2006）', value: '医用一次性乳胶手套（GB 10213-2006）' }, { key: '防冲击眼罩', value: '防冲击眼罩' }, { key: '防护面罩', value: '防护面罩' }, { key: '隔离衣', value: '隔离衣' }, { key: 'N95口罩', value: 'N95口罩' }, { key: 'KN95口罩', value: 'KN95口罩' }, { key: '其他防护物品', value: '其他防护物品' }],
      materialist: [{ materialClassName: '', materialNum: '', materialDesc: '' }]
    };
  },

  methods: {
    ModalHelper: function ModalHelper() {

      var bodyCls = 'dialog-open';
      var scrollTop = void 0;
      return {
        afterOpen: function afterOpen() {
          scrollTop = document.scrollingElement.scrollTop;
          document.body.classList.add(bodyCls);
          document.body.style.top = -scrollTop + 'px';
        },
        beforeClose: function beforeClose() {
          document.body.classList.remove(bodyCls);
        }
      };
    },
    setIconType: function setIconType(v, icon) {
      if (v == "") {
        this[icon] = "error";
      } else {
        this[icon] = "success";
      }
    },

    submit: Debounce(function () {

      var _this = this;
      if (this.enterpriseName == "") {
        this.orgnameIcon = "error";
        return;
      }
      if (this.location == "") {
        this.locationIcon = "error";
        return;
      }
      if (this.name == "") {
        this.nameIcon = "error";
        return;
      }
      if (this.phone == "") {
        this.phoneIcon = "error";
        this.toastType = "text";
        return;
      }
      _axios_0_19_2_axios_default.a.post('/yuncai-yop/contribute/save', {
        enterpriseName: this.enterpriseName,
        name: this.name,
        phone: this.phone,
        location: this.location,
        details: this.materialist,
        systemId: this.systemId,
        type: this.type
      }).then(function (res) {
        _this.isToast = true;
        _this.toastMsg = "提交成功,信息需经平台审核通过后方可公布出来";
        _this.toastType = "success";
        bus.$emit("close-modal", !_this.showmodal);
      }).catch(function (err) {
        _this.isToast = true;
        _this.toastMsg = "提交失败";
        _this.toastType = "warn";
      });
    }, 3000),
    close: function close() {
      bus.$emit("close-modal", !this.showmodal);
    },
    toastHide: function toastHide() {
      if (this.toastType !== "text") {
        this.enterpriseName = '';
        this.name = '';
        this.phone = '';
        this.location = '';
        this.materialist = [{ materialClassName: '', materialNum: '', materialDesc: '' }];
      }
    },
    addmaterial: function addmaterial() {
      this.materialist.push({ materialClassName: '', materialNum: '', materialDesc: '' });
    },
    del: function del(index) {
      this.materialist.splice(index, 1);
      console.log(this.materialist);
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }

    switch (this.type) {
      case 4:
        this.originatorNameText = '募捐人信息';
        this.materialNameText = '募捐物资信息';
        this.entNameText = '供应商';
        break;
      case 6:
        this.originatorNameText = '捐赠人信息';
        this.materialNameText = '捐赠物资信息';
        this.entNameText = '募捐方';
        break;
      case 8:
        this.originatorNameText = '供货人信息';
        this.materialNameText = '供应物资信息';
        this.entNameText = '需求方';
        break;
      case 10:
        this.originatorNameText = '需求人信息';
        this.materialNameText = '需求物资信息';
        this.entNameText = '供应商';
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/AddForm.vue


















/* harmony default export */ var components_AddForm = ({
  name: 'AddForm',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    TransferDom: transfer_dom["a" /* default */], XDialog: _vux_2_9_4_vux_src_components_x_dialog, Group: _vux_2_9_4_vux_src_components_group, XInput: _vux_2_9_4_vux_src_components_x_input, XTextarea: _vux_2_9_4_vux_src_components_x_textarea, XButton: _vux_2_9_4_vux_src_components_x_button, Flexbox: src_components_flexbox_flexbox, FlexboxItem: src_components_flexbox_flexbox_item, Toast: _vux_2_9_4_vux_src_components_toast, Grid: src_components_grid_grid, GridItem: src_components_grid_grid_item, Selector: _vux_2_9_4_vux_src_components_selector, Disclaimer: src_components_Disclaimer
  },
  props: ['showmodal', 'type'],
  watch: {
    showmodal: function showmodal(v) {
      var _this2 = this;

      var el = document.getElementById('app');
      this.scrollTop = v ? document.documentElement.scrollTop : this.scrollTop;
      el.hidden = v;
      if (!v) {
        setTimeout(function () {
          window.scrollTo({ top: _this2.scrollTop || 0, left: 0 });
        }, 200);
      }
    }
  },
  data: function data() {
    return {
      originatorNameText: '',
      materialNameText: '',
      entNameText: '',
      enterpriseName: '',
      name: '',
      location: '',
      phone: '',
      nameIcon: '',
      orgnameIcon: '',
      locationIcon: '',
      phoneIcon: '',
      isToast: false,
      toastMsg: '提交成功',
      toastType: 'success',
      pg2del: __webpack_require__("Ub/c"),
      systemId: '',
      list: [{ key: 'N95医用防护口罩（GB 19083-2010）及以上', value: 'N95医用防护口罩（GB 19083-2010）及以上' }, { key: '医用外科口罩（YY0469-2011)及以上', value: '医用外科口罩（YY0469-2011)及以上' }, { key: '防护服（GB 19082-2003）及以上', value: '防护服（GB 19082-2003）及以上' }, { key: '护目镜', value: '护目镜' }, { key: '医用帽', value: '医用帽' }, { key: '一次性手术衣', value: '一次性手术衣' }, { key: '医用一次性乳胶手套（GB 10213-2006）', value: '医用一次性乳胶手套（GB 10213-2006）' }, { key: '防冲击眼罩', value: '防冲击眼罩' }, { key: '防护面罩', value: '防护面罩' }, { key: '隔离衣', value: '隔离衣' }, { key: 'N95口罩', value: 'N95口罩' }, { key: 'KN95口罩', value: 'KN95口罩' }, { key: '其他防护物品', value: '其他防护物品' }],
      materialist: [{ materialClassName: '', materialNum: '', materialDesc: '' }]
    };
  },

  methods: {
    ModalHelper: function ModalHelper() {

      var bodyCls = 'dialog-open';
      var scrollTop = void 0;
      return {
        afterOpen: function afterOpen() {
          scrollTop = document.scrollingElement.scrollTop;
          document.body.classList.add(bodyCls);
          document.body.style.top = -scrollTop + 'px';
        },
        beforeClose: function beforeClose() {
          document.body.classList.remove(bodyCls);
        }
      };
    },
    setIconType: function setIconType(v, icon) {
      if (v == "") {
        this[icon] = "error";
      } else {
        this[icon] = "success";
      }
    },

    submit: Debounce(function () {

      var _this = this;
      if (this.enterpriseName == "") {
        this.orgnameIcon = "error";
        return;
      }
      if (this.location == "") {
        this.locationIcon = "error";
        return;
      }
      if (this.name == "") {
        this.nameIcon = "error";
        return;
      }
      if (this.phone == "") {
        this.phoneIcon = "error";
        this.toastType = "text";
        return;
      }
      _axios_0_19_2_axios_default.a.post('/yuncai-yop/contribute/save', {
        enterpriseName: this.enterpriseName,
        name: this.name,
        phone: this.phone,
        location: this.location,
        details: this.materialist,
        systemId: this.systemId,
        type: this.type
      }).then(function (res) {
        _this.isToast = true;
        _this.toastMsg = "提交成功,信息需经平台审核通过后方可公布出来";
        _this.toastType = "success";
        bus.$emit("close-modal", !_this.showmodal);
      }).catch(function (err) {
        _this.isToast = true;
        _this.toastMsg = "提交失败";
        _this.toastType = "warn";
      });
    }, 3000),
    close: function close() {
      bus.$emit("close-modal", !this.showmodal);
    },
    toastHide: function toastHide() {
      if (this.toastType !== "text") {
        this.enterpriseName = '';
        this.name = '';
        this.phone = '';
        this.location = '';
        this.materialist = [{ materialClassName: '', materialNum: '', materialDesc: '' }];
      }
    },
    addmaterial: function addmaterial() {
      this.materialist.push({ materialClassName: '', materialNum: '', materialDesc: '' });
    },
    del: function del(index) {
      this.materialist.splice(index, 1);
      console.log(this.materialist);
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }

    switch (this.type) {
      case 4:
        this.originatorNameText = '募捐人信息';
        this.materialNameText = '募捐物资信息';
        this.entNameText = '供应商';
        break;
      case 6:
        this.originatorNameText = '捐赠人信息';
        this.materialNameText = '捐赠物资信息';
        this.entNameText = '募捐方';
        break;
      case 8:
        this.originatorNameText = '供货人信息';
        this.materialNameText = '供应物资信息';
        this.entNameText = '需求方';
        break;
      case 10:
        this.originatorNameText = '需求人信息';
        this.materialNameText = '需求物资信息';
        this.entNameText = '供应商';
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6fc83308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/AddForm.vue
var AddForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showmodal),expression:"showmodal"}],staticClass:"disclaimer-mask"},[_c('div',{staticClass:"i-feedback",staticStyle:{"text-align":"left"}},[_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title1"},[_vm._v(_vm._s(_vm.originatorNameText))]),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"单位/组织全称："}},[_c('x-input',{staticClass:"form-input",attrs:{"type":"text","is-type":"china-name","icon-type":_vm.orgnameIcon,"placeholder":"请输入您的单位或组织全称","novalidate":"","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.enterpriseName,'orgnameIcon')}},model:{value:(_vm.enterpriseName),callback:function ($$v) {_vm.enterpriseName=$$v},expression:"enterpriseName"}})],1),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"单位/组织所在地："}},[_c('x-input',{staticClass:"form-input",attrs:{"placeholder":"请输入您的单位或组织所在地","icon-type":_vm.locationIcon,"novalidate":"","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.location,'locationIcon')}},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})],1),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"联系人："}},[_c('x-input',{staticClass:"form-input",attrs:{"placeholder":"请输入您的真实姓名","icon-type":_vm.nameIcon,"novalidate":"","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.name,'nameIcon')}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"联系电话："}},[_c('x-input',{staticClass:"form-input",attrs:{"placeholder":"填写真实联系电话以便联系您","icon-type":_vm.phoneIcon,"novalidate":"","type":"number","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.phone,'phoneIcon')}},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title1"},[_c('span',[_vm._v(_vm._s(_vm.materialNameText))])]),_vm._v(" "),_c('group',{staticClass:"form-group no-title"},[_vm._l((_vm.materialist),function(i,index){return _c('div',{key:index,staticClass:"container",staticStyle:{"box-shadow":"0 2px 15px 1px #B8BDF6","border-radius":"4px"}},[_c('div',[_c('img',{staticStyle:{"float":"right","padding":"3px 4px","vertical-align":"inherit"},attrs:{"src":_vm.pg2del,"width":"14px"},on:{"click":function($event){return _vm.del(index)}}}),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","padding-bottom":"10px"}},[_c('div',{staticStyle:{"float":"left","width":"5%","height":"44px","line-height":"44px"}},[_vm._v(_vm._s(index+1)+".")]),_vm._v(" "),_c('div',{staticStyle:{"float":"left","width":"95%"}},[(_vm.type==4)?_c('selector',{staticClass:"form-input textarea-bg",attrs:{"title":"品类:","options":_vm.list,"placeholder":"请选择物资品类"},model:{value:(i.materialClassName),callback:function ($$v) {_vm.$set(i, "materialClassName", $$v)},expression:"i.materialClassName"}}):_vm._e(),_vm._v(" "),(_vm.type==6||_vm.type==8||_vm.type==10)?_c('x-input',{staticClass:"form-input textarea-bg",attrs:{"title":"物资:","type":"text","placeholder":"请输入物资名称"},model:{value:(i.materialClassName),callback:function ($$v) {_vm.$set(i, "materialClassName", $$v)},expression:"i.materialClassName"}}):_vm._e(),_vm._v(" "),_c('x-input',{staticClass:"form-input textarea-bg",attrs:{"title":"数量:","type":"text","placeholder":"请输入数量,  如100个"},model:{value:(i.materialNum),callback:function ($$v) {_vm.$set(i, "materialNum", $$v)},expression:"i.materialNum"}}),_vm._v(" "),_c('x-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.type==8),expression:"type==8"}],staticClass:"form-input textarea-bg",attrs:{"title":"单价:","type":"text","placeholder":"请输入人民币单价"},model:{value:(i.price),callback:function ($$v) {_vm.$set(i, "price", $$v)},expression:"i.price"}}),_vm._v(" "),_c('x-textarea',{staticClass:"form-input textarea-bg",attrs:{"title":"要求:","max":300,"placeholder":'请输入物资标准、规格型号、品牌或其他详细要求（0/300）',"required":"","height":40},model:{value:(i.materialDesc),callback:function ($$v) {_vm.$set(i, "materialDesc", $$v)},expression:"i.materialDesc"}})],1),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])])}),_vm._v(" "),_c('div',{staticClass:"addMaterial"},[_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.addmaterial}},[_vm._v("+ 增加新物资")])])],2)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"10px"}},[_c('disclaimer')],1),_vm._v(" "),_c('div',{staticClass:"form-submit",staticStyle:{"padding-bottom":"20px"}},[_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"submit",staticStyle:{"text-align":"center"},on:{"click":_vm.submit}},[_vm._v("提交")])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"submit",staticStyle:{"text-align":"center","background":"#FFF","color":"#333"},on:{"click":_vm.close}},[_vm._v("关闭")])])],1)],1)])]),_vm._v(" "),_c('toast',{attrs:{"text":_vm.toastMsg,"type":_vm.toastType},on:{"on-hide":_vm.toastHide},model:{value:(_vm.isToast),callback:function ($$v) {_vm.isToast=$$v},expression:"isToast"}})],1)}
var AddForm_staticRenderFns = []
var AddForm_esExports = { render: AddForm_render, staticRenderFns: AddForm_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_AddForm = (AddForm_esExports);
// CONCATENATED MODULE: ./src/components/AddForm.vue
function AddForm_injectStyle (ssrContext) {
  __webpack_require__("gvj7")
}
var AddForm_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var AddForm___vue_template_functional__ = false
/* styles */
var AddForm___vue_styles__ = AddForm_injectStyle
/* scopeId */
var AddForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AddForm___vue_module_identifier__ = null
var AddForm_Component = AddForm_normalizeComponent(
  components_AddForm,
  selectortype_template_index_0_src_components_AddForm,
  AddForm___vue_template_functional__,
  AddForm___vue_styles__,
  AddForm___vue_scopeId__,
  AddForm___vue_module_identifier__
)

/* harmony default export */ var src_components_AddForm = (AddForm_Component.exports);

// EXTERNAL MODULE: ./node_modules/_big.js@3.2.0@big.js/big.js
var big = __webpack_require__("JCi3");
var big_default = /*#__PURE__*/__webpack_require__.n(big);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-532be860","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-number/index.vue
var x_number_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell"},[_c('div',[_c('p',{class:_vm.labelClass,style:({width: _vm.$parent.labelWidth, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readonly),expression:"!readonly"}],staticClass:"weui-cell__ft vux-cell-primary",class:{'vux-number-round': _vm.buttonStyle === 'round'},staticStyle:{"font-size":"0"}},[_c('div',{style:({float:_vm.align})},[_c('a',{staticClass:"vux-number-selector vux-number-selector-sub",class:{'vux-number-disabled':_vm.disabledMin},on:{"click":_vm.sub}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}},[_c('defs'),_c('path',{attrs:{"d":"M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-number-input",style:({width: _vm.width}),attrs:{"name":_vm.name,"readonly":!_vm.fillable,"pattern":"[0-9]*","type":"number"},domProps:{"value":(_vm.currentValue)},on:{"blur":[_vm.blur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"vux-number-selector vux-number-selector-plus",class:{'vux-number-disabled':_vm.disabledMax},on:{"click":_vm.add}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20"}},[_c('defs'),_c('path',{attrs:{"d":"M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readonly),expression:"readonly"}],staticClass:"weui-cell__ft vux-cell-primary"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var x_number_staticRenderFns = []
var x_number_esExports = { render: x_number_render, staticRenderFns: x_number_staticRenderFns }
/* harmony default export */ var src_components_x_number = (x_number_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/x-number/index.vue
function x_number_injectStyle (ssrContext) {
  __webpack_require__("MxxQ")
}
var x_number_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var x_number___vue_template_functional__ = false
/* styles */
var x_number___vue_styles__ = x_number_injectStyle
/* scopeId */
var x_number___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_number___vue_module_identifier__ = null
var x_number_Component = x_number_normalizeComponent(
  components_x_number,
  src_components_x_number,
  x_number___vue_template_functional__,
  x_number___vue_styles__,
  x_number___vue_scopeId__,
  x_number___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_x_number = (x_number_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/inline-x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var inline_x_number = ({
  name: 'inline-x-number',
  extends: _vux_2_9_4_vux_src_components_x_number
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/inline-x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_inline_x_number = ({
  name: 'inline-x-number',
  extends: _vux_2_9_4_vux_src_components_x_number
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2c48d673","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/inline-x-number/index.vue
var inline_x_number_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-inline-x-number",class:{'vux-number-round': _vm.buttonStyle === 'round'}},[_c('div',[_c('a',{staticClass:"vux-number-selector vux-number-selector-sub",class:{'vux-number-disabled':_vm.disabledMin},on:{"click":_vm.sub}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}},[_c('defs'),_c('path',{attrs:{"d":"M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-number-input",style:({width: _vm.width}),attrs:{"name":_vm.name,"readonly":!_vm.fillable,"pattern":"[0-9]*","type":"number"},domProps:{"value":(_vm.currentValue)},on:{"blur":[_vm.blur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"vux-number-selector vux-number-selector-plus",class:{'vux-number-disabled':_vm.disabledMax},on:{"click":_vm.add}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20"}},[_c('defs'),_c('path',{attrs:{"d":"M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"}})])])])])}
var inline_x_number_staticRenderFns = []
var inline_x_number_esExports = { render: inline_x_number_render, staticRenderFns: inline_x_number_staticRenderFns }
/* harmony default export */ var src_components_inline_x_number = (inline_x_number_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/inline-x-number/index.vue
function inline_x_number_injectStyle (ssrContext) {
  __webpack_require__("dEFN")
}
var inline_x_number_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var inline_x_number___vue_template_functional__ = false
/* styles */
var inline_x_number___vue_styles__ = inline_x_number_injectStyle
/* scopeId */
var inline_x_number___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_x_number___vue_module_identifier__ = null
var inline_x_number_Component = inline_x_number_normalizeComponent(
  components_inline_x_number,
  src_components_inline_x_number,
  inline_x_number___vue_template_functional__,
  inline_x_number___vue_styles__,
  inline_x_number___vue_scopeId__,
  inline_x_number___vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_inline_x_number = (inline_x_number_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/AddFormOther.vue



















/* harmony default export */ var AddFormOther = ({
  name: 'AddFormOther',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    TransferDom: transfer_dom["a" /* default */], XDialog: _vux_2_9_4_vux_src_components_x_dialog, Group: _vux_2_9_4_vux_src_components_group, XInput: _vux_2_9_4_vux_src_components_x_input, XTextarea: _vux_2_9_4_vux_src_components_x_textarea, XButton: _vux_2_9_4_vux_src_components_x_button, Flexbox: src_components_flexbox_flexbox, FlexboxItem: src_components_flexbox_flexbox_item, Toast: _vux_2_9_4_vux_src_components_toast, Grid: src_components_grid_grid, GridItem: src_components_grid_grid_item, Selector: _vux_2_9_4_vux_src_components_selector, InlineXNumber: _vux_2_9_4_vux_src_components_inline_x_number, Disclaimer: src_components_Disclaimer
  },
  props: ['showmodal', 'type', 'billOtherId'],
  watch: {
    billOtherId: function billOtherId(v) {
      this.queryDate(v);
    },
    showmodal: function showmodal(v) {
      var _this2 = this;

      var el = document.getElementById('app');
      this.scrollTop = v ? document.documentElement.scrollTop : this.scrollTop;
      el.hidden = v;
      if (!v) {
        setTimeout(function () {
          window.scrollTo({ top: _this2.scrollTop || 0, left: 0 });
        }, 200);
      }
    }
  },
  data: function data() {
    return {
      originatorNameText: '',
      acceptNameText: '',
      materialNameText: '',
      entNameText: '',
      supplierEnterpriseName: '',
      supplierName: '',
      supplierPhone: '',
      supplierLocation: '',
      name: '',
      location: '',
      enterpriseName: '',
      phone: '',
      nameIcon: '',
      orgnameIcon: '',
      locationIcon: '',
      phoneIcon: '',
      isToast: false,
      toastMsg: '提交成功',
      toastType: 'success',
      systemId: '',
      details: [],
      positionimg2: __webpack_require__("chPc"),
      telphone: ''
    };
  },

  methods: {
    setIconType: function setIconType(v, icon) {
      if (v == "") {
        this[icon] = "error";
      } else {
        this[icon] = "success";
      }
    },

    submit: Debounce(function () {

      var _this = this;
      if (this.enterpriseName == "") {
        this.orgnameIcon = "error";
        return;
      }
      if (this.location == "") {
        this.locationIcon = "error";
        return;
      }
      if (this.name == "") {
        this.nameIcon = "error";
        return;
      }
      if (this.phone == "") {
        this.phoneIcon = "error";
        this.toastMsg = '\u5FC5\u586B';
        this.toastType = "text";
        return;
      }
      /* if (this.materialDes == "") {
      this.isToast = true
      
      this.toastType = "text"
      return
      } */
      var detailslist = this.details.map(function (v) {
        return {
          materialClassName: v.materialClassName,
          materialDesc: v.materialDesc,
          executedNum: v.materialNum,
          materialNum: v.field1,
          price: v.price
        };
      });
      _axios_0_19_2_axios_default.a.post('/yuncai-yop/contribute/save', {
        supplierEnterpriseName: this.supplierEnterpriseName,
        supplierName: this.supplierName,
        supplierPhone: this.supplierPhone,
        supplierLocation: this.supplierLocation,
        enterpriseName: this.enterpriseName,
        name: this.name,
        phone: this.phone,
        location: this.location,
        details: detailslist,
        sourceId: this.billOtherId,
        systemId: this.systemId,
        type: this.type
      }).then(function (res) {
        _this.isToast = true;
        _this.toastMsg = "提交成功";
        _this.toastType = "success";
        bus.$emit("close-modal", !_this.showmodal);
        console.log(res);
      }).catch(function (err) {
        console.log(err);
        _this.isToast = true;
        _this.toastMsg = "提交失败";
        _this.toastType = "warn";
      });
    }, 3000),
    queryDate: function queryDate(id) {
      var _this3 = this;

      _axios_0_19_2_axios_default.a.get('/yuncai-yop/contribute/detail?id=' + id).then(function (response) {
        if (response.data && response.data.status == 1) {
          var res = response.data.data;
          _this3.name = res.name;
          _this3.location = res.location;
          _this3.enterpriseName = res.enterpriseName;
          _this3.phone = res.phone;
          _this3.supplierEnterpriseName = res.supplierEnterpriseName;
          _this3.supplierName = res.supplierName;
          _this3.supplierPhone = res.supplierPhone;
          _this3.supplierLocation = res.supplierLocation;
          _this3.details = res.details;
          _this3.telphone = "tel:" + res.phone;
        }
      });
    },
    close: function close() {
      bus.$emit("close-modal", !this.showmodal);
    },
    toastHide: function toastHide() {
      if (this.toastType !== "text") {
        this.supplierEnterpriseName = '';
        this.supplierName = '';
        this.supplierPhone = '';
        this.supplierLocation = '';
      }
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }

    switch (this.type) {
      case 5:
        this.originatorNameText = '申请募捐人信息';
        this.acceptNameText = '定向捐赠人信息';
        this.materialNameText = '申请募捐物资信息';
        this.entNameText = '捐赠人';
        break;
      case 7:
        this.originatorNameText = '捐赠人信息';
        this.acceptNameText = '受赠人信息';
        this.materialNameText = '捐赠物资信息';
        this.entNameText = '募捐方';
        break;
      case 9:
        this.originatorNameText = '供货人信息';
        this.acceptNameText = '采购人信息';
        this.materialNameText = '供应物资信息';
        this.entNameText = '需求方';
        break;
      case 11:
        this.originatorNameText = '采购人信息';
        this.acceptNameText = '供货人信息';
        this.materialNameText = '采购物资信息';
        this.entNameText = '需求方';
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/AddFormOther.vue



















/* harmony default export */ var components_AddFormOther = ({
  name: 'AddFormOther',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    TransferDom: transfer_dom["a" /* default */], XDialog: _vux_2_9_4_vux_src_components_x_dialog, Group: _vux_2_9_4_vux_src_components_group, XInput: _vux_2_9_4_vux_src_components_x_input, XTextarea: _vux_2_9_4_vux_src_components_x_textarea, XButton: _vux_2_9_4_vux_src_components_x_button, Flexbox: src_components_flexbox_flexbox, FlexboxItem: src_components_flexbox_flexbox_item, Toast: _vux_2_9_4_vux_src_components_toast, Grid: src_components_grid_grid, GridItem: src_components_grid_grid_item, Selector: _vux_2_9_4_vux_src_components_selector, InlineXNumber: _vux_2_9_4_vux_src_components_inline_x_number, Disclaimer: src_components_Disclaimer
  },
  props: ['showmodal', 'type', 'billOtherId'],
  watch: {
    billOtherId: function billOtherId(v) {
      this.queryDate(v);
    },
    showmodal: function showmodal(v) {
      var _this2 = this;

      var el = document.getElementById('app');
      this.scrollTop = v ? document.documentElement.scrollTop : this.scrollTop;
      el.hidden = v;
      if (!v) {
        setTimeout(function () {
          window.scrollTo({ top: _this2.scrollTop || 0, left: 0 });
        }, 200);
      }
    }
  },
  data: function data() {
    return {
      originatorNameText: '',
      acceptNameText: '',
      materialNameText: '',
      entNameText: '',
      supplierEnterpriseName: '',
      supplierName: '',
      supplierPhone: '',
      supplierLocation: '',
      name: '',
      location: '',
      enterpriseName: '',
      phone: '',
      nameIcon: '',
      orgnameIcon: '',
      locationIcon: '',
      phoneIcon: '',
      isToast: false,
      toastMsg: '提交成功',
      toastType: 'success',
      systemId: '',
      details: [],
      positionimg2: __webpack_require__("chPc"),
      telphone: ''
    };
  },

  methods: {
    setIconType: function setIconType(v, icon) {
      if (v == "") {
        this[icon] = "error";
      } else {
        this[icon] = "success";
      }
    },

    submit: Debounce(function () {

      var _this = this;
      if (this.enterpriseName == "") {
        this.orgnameIcon = "error";
        return;
      }
      if (this.location == "") {
        this.locationIcon = "error";
        return;
      }
      if (this.name == "") {
        this.nameIcon = "error";
        return;
      }
      if (this.phone == "") {
        this.phoneIcon = "error";
        this.toastMsg = '\u5FC5\u586B';
        this.toastType = "text";
        return;
      }
      /* if (this.materialDes == "") {
      this.isToast = true
      
      this.toastType = "text"
      return
      } */
      var detailslist = this.details.map(function (v) {
        return {
          materialClassName: v.materialClassName,
          materialDesc: v.materialDesc,
          executedNum: v.materialNum,
          materialNum: v.field1,
          price: v.price
        };
      });
      _axios_0_19_2_axios_default.a.post('/yuncai-yop/contribute/save', {
        supplierEnterpriseName: this.supplierEnterpriseName,
        supplierName: this.supplierName,
        supplierPhone: this.supplierPhone,
        supplierLocation: this.supplierLocation,
        enterpriseName: this.enterpriseName,
        name: this.name,
        phone: this.phone,
        location: this.location,
        details: detailslist,
        sourceId: this.billOtherId,
        systemId: this.systemId,
        type: this.type
      }).then(function (res) {
        _this.isToast = true;
        _this.toastMsg = "提交成功";
        _this.toastType = "success";
        bus.$emit("close-modal", !_this.showmodal);
        console.log(res);
      }).catch(function (err) {
        console.log(err);
        _this.isToast = true;
        _this.toastMsg = "提交失败";
        _this.toastType = "warn";
      });
    }, 3000),
    queryDate: function queryDate(id) {
      var _this3 = this;

      _axios_0_19_2_axios_default.a.get('/yuncai-yop/contribute/detail?id=' + id).then(function (response) {
        if (response.data && response.data.status == 1) {
          var res = response.data.data;
          _this3.name = res.name;
          _this3.location = res.location;
          _this3.enterpriseName = res.enterpriseName;
          _this3.phone = res.phone;
          _this3.supplierEnterpriseName = res.supplierEnterpriseName;
          _this3.supplierName = res.supplierName;
          _this3.supplierPhone = res.supplierPhone;
          _this3.supplierLocation = res.supplierLocation;
          _this3.details = res.details;
          _this3.telphone = "tel:" + res.phone;
        }
      });
    },
    close: function close() {
      bus.$emit("close-modal", !this.showmodal);
    },
    toastHide: function toastHide() {
      if (this.toastType !== "text") {
        this.supplierEnterpriseName = '';
        this.supplierName = '';
        this.supplierPhone = '';
        this.supplierLocation = '';
      }
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }

    switch (this.type) {
      case 5:
        this.originatorNameText = '申请募捐人信息';
        this.acceptNameText = '定向捐赠人信息';
        this.materialNameText = '申请募捐物资信息';
        this.entNameText = '捐赠人';
        break;
      case 7:
        this.originatorNameText = '捐赠人信息';
        this.acceptNameText = '受赠人信息';
        this.materialNameText = '捐赠物资信息';
        this.entNameText = '募捐方';
        break;
      case 9:
        this.originatorNameText = '供货人信息';
        this.acceptNameText = '采购人信息';
        this.materialNameText = '供应物资信息';
        this.entNameText = '需求方';
        break;
      case 11:
        this.originatorNameText = '采购人信息';
        this.acceptNameText = '供货人信息';
        this.materialNameText = '采购物资信息';
        this.entNameText = '需求方';
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-446e3cd1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/AddFormOther.vue
var AddFormOther_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.showmodal),expression:"showmodal"}],staticClass:"disclaimer-mask"},[_c('div',{staticClass:"i-feedback",staticStyle:{"text-align":"left"}},[_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title1"},[_vm._v(_vm._s(_vm.originatorNameText))]),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"单位/组织全称："}},[_c('x-input',{staticClass:"form-input",attrs:{"type":"text","is-type":"china-name","icon-type":_vm.orgnameIcon,"placeholder":"请输入您的单位或组织全称","novalidate":"","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.supplierEnterpriseName,'orgnameIcon')}},model:{value:(_vm.supplierEnterpriseName),callback:function ($$v) {_vm.supplierEnterpriseName=$$v},expression:"supplierEnterpriseName"}})],1),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"单位/组织所在地："}},[_c('x-input',{staticClass:"form-input",attrs:{"placeholder":"请输入您的单位或组织所在地","icon-type":_vm.locationIcon,"novalidate":"","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.supplierLocation,'locationIcon')}},model:{value:(_vm.supplierLocation),callback:function ($$v) {_vm.supplierLocation=$$v},expression:"supplierLocation"}})],1),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"联系人："}},[_c('x-input',{staticClass:"form-input",attrs:{"placeholder":"请输入您的真实姓名","icon-type":_vm.nameIcon,"novalidate":"","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.name,'nameIcon')}},model:{value:(_vm.supplierName),callback:function ($$v) {_vm.supplierName=$$v},expression:"supplierName"}})],1),_vm._v(" "),_c('group',{staticClass:"form-group",attrs:{"title":"联系电话："}},[_c('x-input',{staticClass:"form-input",attrs:{"placeholder":"填写真实联系电话以便联系您","icon-type":_vm.phoneIcon,"novalidate":"","type":"number","show-clear":false},on:{"on-change":function($event){return _vm.setIconType(_vm.supplierPhone,'phoneIcon')}},model:{value:(_vm.supplierPhone),callback:function ($$v) {_vm.supplierPhone=$$v},expression:"supplierPhone"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title1",staticStyle:{"margin-bottom":"5px"}},[_vm._v(_vm._s(_vm.acceptNameText))]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item",staticStyle:{"font-size":"15px","color":"#333333"}},[_c('img',{staticStyle:{"vertical-align":"inherit"},attrs:{"src":_vm.positionimg2,"width":"18px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.enterpriseName))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item color666"},[_c('span',[_vm._v("所在地:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.location))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item color666"},[_c('span',[_vm._v("联系人:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item color666"},[_c('span',[_vm._v("联系电话:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.phone))]),_vm._v(" "),_c('a',{staticClass:"telphone2",staticStyle:{"float":"right"},attrs:{"href":_vm.telphone}})])]),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title1"},[_c('span',[_vm._v(_vm._s(_vm.materialNameText))])]),_vm._v(" "),_c('group',{staticClass:"form-group no-title"},[_vm._l((_vm.details),function(item,index){return _c('div',{key:index,staticClass:"container-formother"},[_c('div',{staticStyle:{"width":"100%","padding-bottom":"10px"}},[_c('div',{staticStyle:{"float":"left","font-size":"14px","width":"5%","height":"30px","line-height":"30px","color":"#666666"}},[_vm._v(_vm._s(index+1)+".")]),_vm._v(" "),_c('div',{staticStyle:{"float":"left","width":"95%"}},[_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("品类: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.materialClassName))]),_vm._v(" "),(item.materialNum)?_c('span',[_vm._v("（"+_vm._s(item.materialNum)+"）")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("要求: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.materialDesc))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item item-input"},[_c('group',[_c('x-input',{attrs:{"title":"数量:","placeholder":"请输入数量,例如:100个","show-clear":false},model:{value:(item.field1),callback:function ($$v) {_vm.$set(item, "field1", $$v)},expression:"item.field1"}})],1)],1),_vm._v(" "),(_vm.type==9||_vm.type==11)?_c('div',{staticClass:"form-title-view-item item-input"},[_c('group',[_c('x-input',{attrs:{"title":"单价:","placeholder":"请输入单价,例如:100元","show-clear":false},model:{value:(item.price),callback:function ($$v) {_vm.$set(item, "price", $$v)},expression:"item.price"}})],1)],1):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])])}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"10px"}},[_c('disclaimer')],1)],2)],1),_vm._v(" "),_c('div',{staticClass:"form-submit",staticStyle:{"padding-bottom":"20px"}},[_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"submit",staticStyle:{"text-align":"center"},on:{"click":_vm.submit}},[_vm._v("提交")])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"submit",staticStyle:{"text-align":"center","background":"#FFF","color":"#333"},on:{"click":_vm.close}},[_vm._v("关闭")])])],1)],1)])]),_vm._v(" "),_c('toast',{attrs:{"text":_vm.toastMsg,"type":_vm.toastType},on:{"on-hide":_vm.toastHide},model:{value:(_vm.isToast),callback:function ($$v) {_vm.isToast=$$v},expression:"isToast"}})],1)}
var AddFormOther_staticRenderFns = []
var AddFormOther_esExports = { render: AddFormOther_render, staticRenderFns: AddFormOther_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_AddFormOther = (AddFormOther_esExports);
// CONCATENATED MODULE: ./src/components/AddFormOther.vue
function AddFormOther_injectStyle (ssrContext) {
  __webpack_require__("IxpF")
}
var AddFormOther_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var AddFormOther___vue_template_functional__ = false
/* styles */
var AddFormOther___vue_styles__ = AddFormOther_injectStyle
/* scopeId */
var AddFormOther___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AddFormOther___vue_module_identifier__ = null
var AddFormOther_Component = AddFormOther_normalizeComponent(
  components_AddFormOther,
  selectortype_template_index_0_src_components_AddFormOther,
  AddFormOther___vue_template_functional__,
  AddFormOther___vue_styles__,
  AddFormOther___vue_scopeId__,
  AddFormOther___vue_module_identifier__
)

/* harmony default export */ var src_components_AddFormOther = (AddFormOther_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/components/popup/popup.js
var popup = __webpack_require__("yODz");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/libs/dom.js
var dom = __webpack_require__("Xspv");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-fc4c0260","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var _vux_2_9_4_vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("w8LO")
}
var popup_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  _vux_2_9_4_vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules__vux_2_9_4_vux_src_components_popup = (popup_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/AddFormView.vue
















/* harmony default export */ var AddFormView = ({
  name: 'AddFormView',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Popup: node_modules__vux_2_9_4_vux_src_components_popup, TransferDom: transfer_dom["a" /* default */], Group: _vux_2_9_4_vux_src_components_group, XButton: _vux_2_9_4_vux_src_components_x_button, Flexbox: src_components_flexbox_flexbox, FlexboxItem: src_components_flexbox_flexbox_item, Toast: _vux_2_9_4_vux_src_components_toast, Grid: src_components_grid_grid, GridItem: src_components_grid_grid_item, Selector: _vux_2_9_4_vux_src_components_selector, Disclaimer: src_components_Disclaimer
  },
  props: ['showmodal', 'type', 'billId'],
  watch: {
    showmodal: function showmodal(v) {
      var _this = this;

      var el = document.getElementById('app');
      this.scrollTop = v ? document.documentElement.scrollTop : this.scrollTop;
      el.hidden = v;
      if (!v) {
        setTimeout(function () {
          window.scrollTo({ top: _this.scrollTop || 0, left: 0 });
        }, 200);
      }
    },
    billId: function billId(v) {
      this.queryDate(v);
    }
  },
  data: function data() {
    return {
      originatorNameText: '',
      acceptNameText: '',
      materialNameText: '',
      tagtypeText: '',
      tagStatusText: '',
      name: '',
      location: '',
      enterpriseName: '',
      phone: '',
      supplierName: '',
      supplierLocation: '',
      supplierEnterpriseName: '',
      supplierPhone: '',
      isToast: false,
      toastMsg: '提交成功',
      toastType: 'success',
      systemId: '',
      executeStatus: '',
      id: '',
      details: [],
      positionimg2: __webpack_require__("chPc"),
      submitText: '',
      telphone: '',
      telSuphone: ''
    };
  },

  methods: {
    setIconType: function setIconType(v, icon) {
      if (v == "") {
        this[icon] = "error";
      } else {
        this[icon] = "success";
      }
    },
    submit: function submit() {

      bus.$emit('open-formother', true, this.id);
    },
    queryDate: function queryDate(id) {
      var _this2 = this;

      _axios_0_19_2_axios_default.a.get('/yuncai-yop/contribute/detail?id=' + id).then(function (response) {
        if (response.data && response.data.status == 1) {
          var res = response.data.data;
          _this2.name = res.name;
          _this2.id = res.id;
          _this2.location = res.location;
          _this2.enterpriseName = res.enterpriseName;
          _this2.phone = res.phone;
          _this2.supplierName = res.supplierName;
          _this2.supplierLocation = res.supplierLocation;
          _this2.supplierEnterpriseName = res.supplierEnterpriseName;
          _this2.supplierPhone = res.supplierPhone;
          _this2.details = res.details;
          _this2.executeStatus = res.executeStatus;
          _this2.telphone = "tel:" + res.phone;
          _this2.telSuphone = "tel:" + res.supplierPhone;
        }
      });
    },
    close: function close() {
      bus.$emit("close-modal", !this.showmodal);
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }

    switch (this.type) {
      case 4:
        this.originatorNameText = '募捐人信息';
        this.materialNameText = '募捐物资信息';
        this.tagtypeText = '公开募捐';
        this.tagStatusText = '待捐赠';
        this.submitText = '我要捐赠';
        break;
      case 5:
        this.originatorNameText = '申请募捐人信息';
        this.acceptNameText = '定向捐赠人信息';
        this.materialNameText = '捐赠物资信息';
        this.tagtypeText = '定向募捐';
        break;
      case 6:
        this.originatorNameText = '捐赠人信息';
        this.materialNameText = '捐赠物资信息';
        this.tagtypeText = '公开捐赠';
        this.tagStatusText = '待受捐';
        this.submitText = '我要申请受捐';
        break;
      case 7:
        this.originatorNameText = '捐赠人信息';
        this.acceptNameText = '受捐人信息';
        this.materialNameText = '捐赠物资信息';
        this.tagtypeText = '定向捐赠';
        break;
      case 8:
        this.originatorNameText = '供货人信息';
        this.materialNameText = '供应物资信息';
        this.tagtypeText = '公开供应';
        this.tagStatusText = '待采购';
        this.submitText = '我要采购';
        break;
      case 9:
        this.originatorNameText = '供货人信息';
        this.acceptNameText = '采购人信息';
        this.materialNameText = '供应物资信息';
        this.tagtypeText = '定向供应';
        break;
      case 10:
        this.originatorNameText = '需求人信息';
        this.materialNameText = '需求物资信息';
        this.tagtypeText = '公开采购';
        this.tagStatusText = '待供应';
        this.submitText = '我要供应';
        break;
      case 11:
        this.originatorNameText = '需求人信息';
        this.acceptNameText = '供应人信息';
        this.materialNameText = '需求物资信息';
        this.tagtypeText = '定向采购';
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/AddFormView.vue
















/* harmony default export */ var components_AddFormView = ({
  name: 'AddFormView',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Popup: node_modules__vux_2_9_4_vux_src_components_popup, TransferDom: transfer_dom["a" /* default */], Group: _vux_2_9_4_vux_src_components_group, XButton: _vux_2_9_4_vux_src_components_x_button, Flexbox: src_components_flexbox_flexbox, FlexboxItem: src_components_flexbox_flexbox_item, Toast: _vux_2_9_4_vux_src_components_toast, Grid: src_components_grid_grid, GridItem: src_components_grid_grid_item, Selector: _vux_2_9_4_vux_src_components_selector, Disclaimer: src_components_Disclaimer
  },
  props: ['showmodal', 'type', 'billId'],
  watch: {
    showmodal: function showmodal(v) {
      var _this = this;

      var el = document.getElementById('app');
      this.scrollTop = v ? document.documentElement.scrollTop : this.scrollTop;
      el.hidden = v;
      if (!v) {
        setTimeout(function () {
          window.scrollTo({ top: _this.scrollTop || 0, left: 0 });
        }, 200);
      }
    },
    billId: function billId(v) {
      this.queryDate(v);
    }
  },
  data: function data() {
    return {
      originatorNameText: '',
      acceptNameText: '',
      materialNameText: '',
      tagtypeText: '',
      tagStatusText: '',
      name: '',
      location: '',
      enterpriseName: '',
      phone: '',
      supplierName: '',
      supplierLocation: '',
      supplierEnterpriseName: '',
      supplierPhone: '',
      isToast: false,
      toastMsg: '提交成功',
      toastType: 'success',
      systemId: '',
      executeStatus: '',
      id: '',
      details: [],
      positionimg2: __webpack_require__("chPc"),
      submitText: '',
      telphone: '',
      telSuphone: ''
    };
  },

  methods: {
    setIconType: function setIconType(v, icon) {
      if (v == "") {
        this[icon] = "error";
      } else {
        this[icon] = "success";
      }
    },
    submit: function submit() {

      bus.$emit('open-formother', true, this.id);
    },
    queryDate: function queryDate(id) {
      var _this2 = this;

      _axios_0_19_2_axios_default.a.get('/yuncai-yop/contribute/detail?id=' + id).then(function (response) {
        if (response.data && response.data.status == 1) {
          var res = response.data.data;
          _this2.name = res.name;
          _this2.id = res.id;
          _this2.location = res.location;
          _this2.enterpriseName = res.enterpriseName;
          _this2.phone = res.phone;
          _this2.supplierName = res.supplierName;
          _this2.supplierLocation = res.supplierLocation;
          _this2.supplierEnterpriseName = res.supplierEnterpriseName;
          _this2.supplierPhone = res.supplierPhone;
          _this2.details = res.details;
          _this2.executeStatus = res.executeStatus;
          _this2.telphone = "tel:" + res.phone;
          _this2.telSuphone = "tel:" + res.supplierPhone;
        }
      });
    },
    close: function close() {
      bus.$emit("close-modal", !this.showmodal);
    }
  },
  mounted: function mounted() {
    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
    } else {

      this.systemId = 0;
    }

    switch (this.type) {
      case 4:
        this.originatorNameText = '募捐人信息';
        this.materialNameText = '募捐物资信息';
        this.tagtypeText = '公开募捐';
        this.tagStatusText = '待捐赠';
        this.submitText = '我要捐赠';
        break;
      case 5:
        this.originatorNameText = '申请募捐人信息';
        this.acceptNameText = '定向捐赠人信息';
        this.materialNameText = '捐赠物资信息';
        this.tagtypeText = '定向募捐';
        break;
      case 6:
        this.originatorNameText = '捐赠人信息';
        this.materialNameText = '捐赠物资信息';
        this.tagtypeText = '公开捐赠';
        this.tagStatusText = '待受捐';
        this.submitText = '我要申请受捐';
        break;
      case 7:
        this.originatorNameText = '捐赠人信息';
        this.acceptNameText = '受捐人信息';
        this.materialNameText = '捐赠物资信息';
        this.tagtypeText = '定向捐赠';
        break;
      case 8:
        this.originatorNameText = '供货人信息';
        this.materialNameText = '供应物资信息';
        this.tagtypeText = '公开供应';
        this.tagStatusText = '待采购';
        this.submitText = '我要采购';
        break;
      case 9:
        this.originatorNameText = '供货人信息';
        this.acceptNameText = '采购人信息';
        this.materialNameText = '供应物资信息';
        this.tagtypeText = '定向供应';
        break;
      case 10:
        this.originatorNameText = '需求人信息';
        this.materialNameText = '需求物资信息';
        this.tagtypeText = '公开采购';
        this.tagStatusText = '待供应';
        this.submitText = '我要供应';
        break;
      case 11:
        this.originatorNameText = '需求人信息';
        this.acceptNameText = '供应人信息';
        this.materialNameText = '需求物资信息';
        this.tagtypeText = '定向采购';
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-59b57c27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/AddFormView.vue
var AddFormView_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('popup',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.showmodal),expression:"showmodal"}],staticClass:"z2000",attrs:{"height":"100%"}},[_c('div',{staticClass:"i-feedback",staticStyle:{"text-align":"left"}},[(_vm.type==5 || _vm.type==7 || _vm.type==9 || _vm.type==11)?_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title-view"},[_vm._v("\n                    "+_vm._s(_vm.originatorNameText)+"\n                    "),_c('span',{staticClass:"form-title-view-tag type5 bg",staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.tagtypeText))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item",staticStyle:{"font-size":"15px","color":"#333333"}},[_c('img',{staticStyle:{"vertical-align":"text-top"},attrs:{"src":_vm.positionimg2,"width":"20px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.supplierEnterpriseName))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("所在地:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.supplierLocation))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("联系人:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.supplierName))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("联系电话:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.supplierPhone))]),_vm._v(" "),_c('a',{staticClass:"telphone1",staticStyle:{"float":"right"},attrs:{"href":_vm.telSuphone}})])]):_vm._e(),_vm._v(" "),(_vm.type==6 || _vm.type==8 || _vm.type==10 || _vm.type==4)?_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title-view",staticStyle:{"margin-right":"-10px"}},[_vm._v("\n                    "+_vm._s(_vm.originatorNameText)+"\n                    "),(_vm.executeStatus==null)?_c('span',{staticClass:"form-title-view-tag type2bg bg",staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.tagStatusText))]):_vm._e(),_vm._v(" "),(_vm.executeStatus==0)?_c('span',{staticClass:"form-title-view-tag type2bg bg",staticStyle:{"float":"right"}},[_vm._v("待执行")]):_vm._e(),_vm._v(" "),(_vm.executeStatus==2)?_c('span',{staticClass:"form-title-view-tag type2bg2 bg",staticStyle:{"float":"right"}},[_vm._v("已完成")]):_vm._e(),_vm._v(" "),(_vm.executeStatus==3)?_c('span',{staticClass:"form-title-view-tag type2bg2 bg",staticStyle:{"float":"right"}},[_vm._v("已失效")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"form-title-view-tag type6 bg",staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.tagtypeText))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item",staticStyle:{"font-size":"15px","color":"#333333"}},[_c('img',{staticStyle:{"vertical-align":"text-top"},attrs:{"src":_vm.positionimg2,"width":"20px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.enterpriseName))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("所在地:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.location))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("联系人:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("联系电话:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.phone))]),_vm._v(" "),_c('a',{staticClass:"telphone1",staticStyle:{"float":"right"},attrs:{"href":_vm.telphone}})])]):_vm._e(),_vm._v(" "),(_vm.type==5 || _vm.type==7 || _vm.type==9 || _vm.type==11)?_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title-view"},[_vm._v(_vm._s(_vm.acceptNameText))]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item",staticStyle:{"font-size":"15px","color":"#333333"}},[_c('img',{staticStyle:{"vertical-align":"text-top"},attrs:{"src":_vm.positionimg2,"width":"20px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.enterpriseName))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("所在地:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.location))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("联系人:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v("联系电话:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.phone))]),_vm._v(" "),_c('a',{staticClass:"telphone1",staticStyle:{"float":"right"},attrs:{"href":_vm.telphone}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-title-view"},[_vm._v(_vm._s(_vm.materialNameText))]),_vm._v(" "),_vm._l((_vm.details),function(item,index){return _c('div',{key:index,staticClass:"container-view"},[_c('div',{staticStyle:{"width":"100%","padding-bottom":"10px"}},[_c('div',{staticStyle:{"float":"left","font-size":"14px","width":"5%","height":"30px","line-height":"30px","color":"#666666"}},[_vm._v(_vm._s(index+1)+".")]),_vm._v(" "),_c('div',{staticStyle:{"float":"left","width":"95%"}},[_c('div',{staticClass:"form-title-view-item"},[_c('span',[_vm._v(_vm._s(item.materialClassName)+" "+_vm._s(item.materialNum))])]),_vm._v(" "),(_vm.type==8||_vm.type==11)?_c('div',{staticClass:"form-title-view-item"},[_vm._v("单价: "),_c('span',[_vm._v(_vm._s(item.price))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-title-view-item"},[_vm._v("描述: "),_c('span',[_vm._v(_vm._s(item.materialDesc))])])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])])})],2),_vm._v(" "),_c('div',{staticClass:"form-submit",staticStyle:{"padding-bottom":"20px"}},[_c('flexbox',[(_vm.type==4||_vm.type==6||_vm.type==8||_vm.type==10)?_c('flexbox-item',[_c('div',{staticClass:"submit",staticStyle:{"text-align":"center"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.submitText))])]):_vm._e(),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"submit",staticStyle:{"text-align":"center","background":"#FFF","color":"#333"},on:{"click":_vm.close}},[_vm._v("关闭")])])],1)],1)])])],1)}
var AddFormView_staticRenderFns = []
var AddFormView_esExports = { render: AddFormView_render, staticRenderFns: AddFormView_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_AddFormView = (AddFormView_esExports);
// CONCATENATED MODULE: ./src/components/AddFormView.vue
function AddFormView_injectStyle (ssrContext) {
  __webpack_require__("Xn/q")
}
var AddFormView_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var AddFormView___vue_template_functional__ = false
/* styles */
var AddFormView___vue_styles__ = AddFormView_injectStyle
/* scopeId */
var AddFormView___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AddFormView___vue_module_identifier__ = null
var AddFormView_Component = AddFormView_normalizeComponent(
  components_AddFormView,
  selectortype_template_index_0_src_components_AddFormView,
  AddFormView___vue_template_functional__,
  AddFormView___vue_styles__,
  AddFormView___vue_scopeId__,
  AddFormView___vue_module_identifier__
)

/* harmony default export */ var src_components_AddFormView = (AddFormView_Component.exports);

// EXTERNAL MODULE: ./node_modules/_weixin-js-sdk@1.4.0-test@weixin-js-sdk/index.js
var _weixin_js_sdk_1_4_0_test_weixin_js_sdk = __webpack_require__("X1H5");
var _weixin_js_sdk_1_4_0_test_weixin_js_sdk_default = /*#__PURE__*/__webpack_require__.n(_weixin_js_sdk_1_4_0_test_weixin_js_sdk);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloFromVux.vue

































Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  }return fmt;
};
/* harmony default export */ var HelloFromVux = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Group: _vux_2_9_4_vux_src_components_group,
    Cell: _vux_2_9_4_vux_src_components_cell,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    XInput: _vux_2_9_4_vux_src_components_x_input,
    XTextarea: _vux_2_9_4_vux_src_components_x_textarea,
    XButton: _vux_2_9_4_vux_src_components_x_button,
    Card: _vux_2_9_4_vux_src_components_card,
    Alert: node_modules__vux_2_9_4_vux_src_components_alert,
    Loading: _vux_2_9_4_vux_src_components_loading,
    Toast: _vux_2_9_4_vux_src_components_toast,
    Icon: _vux_2_9_4_vux_src_components_icon,
    Radio: node_modules__vux_2_9_4_vux_src_components_radio,
    Checklist: _vux_2_9_4_vux_src_components_checklist,
    Datetime: _vux_2_9_4_vux_src_components_datetime,
    XDialog: _vux_2_9_4_vux_src_components_x_dialog,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Divider: _vux_2_9_4_vux_src_components_divider,
    VehicleRequire: src_components_VehicleRequire,
    VehicleResource: src_components_VehicleResource,
    AddSubmit: src_components_AddSubmit,
    AddForm: src_components_AddForm,
    AddFormOther: src_components_AddFormOther,
    AddFormView: src_components_AddFormView
  },
  data: function data() {
    return {

      showmodal: false,
      showmodalform: false,
      showmodalform2: false,
      showmodalform3: false,
      showmodalform4: false,
      showmodalform5: false,
      showmodalform6: false,
      showmodalformview: false,
      showmodalformview2: false,
      showmodalformview3: false,
      showmodalformview4: false,
      showmodalformview5: false,
      showmodalformview6: false,
      showmodalformview7: false,
      showmodalformview8: false,
      showmodalformother: false,
      showmodalformother2: false,
      showmodalformother3: false,
      showmodalformother4: false,
      bannerurl: __webpack_require__("hKcQ"),
      banner2url: __webpack_require__("y5LZ"),
      msg: 'Hello World!',
      visindex: 1,
      hasAuth: 0,
      transform: { transform: 'translateY(0)' },
      positionimg: __webpack_require__("A1tS"),
      positionimg2: __webpack_require__("chPc"),
      positionimg3: __webpack_require__("ZK0V"),
      imgList: [{ url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfab254d-2129-4fc8-ab3b-c0c7f53d7dba_湖北-恩施.jpg', field1: '湖北-恩施' }, { url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfa7699b-6ae3-4f8b-bcbe-c56bdbdc9bc8_湖北-监利县.jpg', field1: '湖北-监利县' }, { url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/53753b9b-0f2b-48e8-b8eb-ce27b18bcb3c_湖北-公安县.jpg', field1: '湖北-公安县' }, { url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/0e4bc83a-386d-46e5-809f-da12f392124b_湖北-来凤县.jpg', field1: '湖北-来凤县' }],
      value: '',
      name: '',
      phone: '',
      location: '',
      materialDes: '',
      msgAlert: '',
      userinfo: {},
      isOpen: false,
      isLoading: false,
      loadingText: '提交中',
      isToast: false,
      toastMsg: '提交成功',
      toastType: 'success',
      list: [],
      list4Supply: [],
      list4Donation: [],
      pageNum: 0,
      pageNum4Supply: 0,
      pageNum4Donation: 0,
      nameIcon: '',
      phoneIcon: '',
      locationIcon: '',

      realName: '',
      realNameIcon: '',
      realPhone: '',
      realPhoneIcon: '',
      identity: ['中间商/代理商'], //身份
      material: ['N95医用防护口罩（GB 19083-2010）及以上', '医用外科口罩（YY0469-2011)及以上', '防护服（GB 19082-2003）及以上', '护目镜', '医用帽', '一次性手术衣', '医用一次性乳胶手套（GB 10213-2006）', '防冲击眼罩', '防护面罩', '隔离衣', 'N95口罩', 'KN95口罩', '其他防护物品'],
      materialValue: ['N95医用防护口罩（GB 19083-2010）及以上'],

      isAgreeOptions: [{ value: '同意', key: '1' }, { value: '不同意', key: '0' }],
      isAgree: ['1'],

      spot: [{ value: '是', key: '1' }, { value: '否', key: '0' }], //现货
      spotValue: ['1'],

      allowCentify: ['1'],
      businessAllow: ['1'],
      registerCentify: [{ value: '是', key: '1' }, { value: '否', key: '0' }],
      registerCentifyValue: ['1'],
      productTime: '',
      dayNumber: 0,
      company: '',
      remark: '',
      rushHelp: ['捐赠'],
      buttonText: '我要捐赠',
      buttonTextLeft: '我要采购',
      buttonTextRight: '我要供应',
      showmodal3: false,
      showmodal4: false,
      systemId: '',
      billId: '',
      billOtherId: ''
    };
  },

  methods: {
    viewpublicdata: function viewpublicdata() {

      var redirecturl = encodeURIComponent(location.origin + '/cpu-relief/');
      location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa4c7f0efdef96aa7&redirect_uri=' + redirecturl + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
    },
    isAuth: function isAuth() {
      return this.hasAuth == 0 && (this.visindex == 1 || this.visindex == 3 || this.visindex == 4);
    },
    help: function help() {
      switch (this.visindex) {
        case 0:
          this.showmodalform = true;
          break;
        case 1:
          this.showmodalform3 = true;
          break;
        case 2:
          this.showmodalform5 = true;
          break;
      }
    },
    donate: function donate() {
      switch (this.visindex) {
        case 0:
          this.showmodalform2 = true;
          break;
        case 1:
          this.showmodalform4 = true;
          break;
        case 2:
          this.showmodalform6 = true;
          break;
        case 3:
          this.showmodal3 = true;
          break;
        case 4:
          this.showmodal4 = true;
          break;
      }
    },
    format: function format(ts) {
      var d = new Date(ts).Format("yyyy-MM-dd");
      return d;
    },
    handler: function handler(index) {
      this.visindex = index;
      switch (index) {
        case 0:

          this.getDonationList();
          this.buttonTextLeft = "我要募捐";
          this.buttonTextRight = "我要捐赠";
          break;
        case 1:
          this.buttonTextLeft = "我要采购";
          this.buttonTextRight = "我要供应";
          break;
        case 2:

          this.getSupplyList();
          this.buttonTextLeft = "我要捐赠";
          this.buttonTextRight = "我要供应";
          break;
        case 3:
          this.buttonTextRight = "我要用车";
          break;
        case 4:
          this.buttonTextRight = "我有资源";
          break;
      }
    },
    setIconType: function setIconType(v, icon) {
      if (v == "") {
        this[icon] = "error";
      } else {
        this[icon] = "success";
      }
    },

    submit: Debounce(function () {

      var _this = this;
      if (this.name == "") {
        this.nameIcon = "error";
        return;
      }
      if (this.location == "") {
        this.locationIcon = "error";
        return;
      }
      if (this.phone == "") {
        this.phoneIcon = "error";
        return;
      }
      if (this.materialDes == "") {
        this.isToast = true;
        this.toastMsg = "物资信息必填";
        this.toastType = "text";
        return;
      }

      _axios_0_19_2_axios_default.a.post('/yuncai-yop/contribute/save', {
        name: this.name,
        phone: this.phone,
        location: this.location,
        materialDes: this.materialDes,
        field1: '0'
      }).then(function (res) {
        _this.isToast = true;
        _this.toastMsg = "提交成功,物资信息需经平台审核通过后方可公布出来";
        _this.toastType = "success";
        console.log(res);
      }).catch(function (err) {
        console.log(err);
        _this.isToast = true;
        _this.toastMsg = "提交失败";
        _this.toastType = "warn";
      });
    }, 3000),

    getDonationList: function getDonationList() {
      var pageNum4Donation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this = this;
      var data = {
        pageNum: pageNum4Donation,
        pageSize: 10,
        types: [4, 5],
        systemId: _this.systemId
      };
      if (this.hasAuth) {
        data.auth = 1;
      }
      this.isLoading = true;
      this.loadingText = "加载中...";
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contribute/page", data).then(function (res) {
        if (res.status == 200) {
          var list = res.data.data.list || [];
          _this.list4Donation = _this.list4Donation.concat(list);
          if (res.data.data.nextPage > 0) {
            _this.pageNum4Donation = res.data.data.nextPage - 1;
          } else {
            _this.pageNum4Donation = 0;
          }
        }
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    },
    getPurchaseList: function getPurchaseList() {
      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this = this;
      var data = {
        pageNum: pageNum,
        pageSize: 10,
        types: [0, 10, 11],
        systemId: _this.systemId
      };
      if (this.hasAuth) {
        data.auth = 1;
      }
      this.isLoading = true;
      this.loadingText = "加载中...";
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contribute/page", data).then(function (res) {
        if (res.status == 200) {
          var list = res.data.data.list || [];
          _this.list = _this.list.concat(list);
          if (res.data.data.nextPage > 0) {
            _this.pageNum = res.data.data.nextPage - 1;
          } else {
            _this.pageNum = 0;
          }
        }
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    },
    getSupplyList: function getSupplyList() {
      var pageNum4Supply = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this = this;
      var data = {
        pageNum: pageNum4Supply,
        pageSize: 10,
        types: [1, 6, 7, 8, 9],
        systemId: _this.systemId
      };
      if (this.hasAuth) {
        data.auth = 1;
      }
      this.isLoading = true;
      this.loadingText = "加载中...";
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contribute/page", data).then(function (res) {
        if (res.status == 200) {
          var list = res.data.data.list || [];
          _this.list4Supply = _this.list4Supply.concat(list);
          if (res.data.data.nextPage > 0) {
            _this.pageNum4Supply = res.data.data.nextPage - 1;
          } else {
            _this.pageNum4Supply = 0;
          }
        }
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    },
    toastHide: function toastHide() {
      if (this.toastType !== "text") {
        this.name = '';
        this.phone = '';
        this.location = '';
        this.materialDes = '';
      }
    },
    hide: function hide() {},
    billShowView: function billShowView(item) {
      this.billId = item.id;
      switch (item.type) {
        case 4:
          this.showmodalformview = true;
          break;
        case 5:
          this.showmodalformview2 = true;
          break;
        case 6:
          this.showmodalformview8 = true;
          break;
        case 7:
          this.showmodalformview7 = true;
          break;
        case 8:
          this.showmodalformview6 = true;
          break;
        case 9:
          this.showmodalformview5 = true;
          break;
        case 10:
          this.showmodalformview3 = true;
          break;
        case 11:
          this.showmodalformview4 = true;
          break;
      }
    },

    /* ------------------------------ */

    myDonation: function myDonation(item) {
      this.billOtherId = item.id;
      this.showmodalformother = true;
    },
    mySupply: function mySupply(item) {
      this.billOtherId = item.id;
      this.showmodalformother2 = true;
    },
    myPurchase: function myPurchase(item) {
      this.billOtherId = item.id;
      this.showmodalformother3 = true;
    },
    myFundrais: function myFundrais(item) {
      this.billOtherId = item.id;
      this.showmodalformother4 = true;
    },
    resetValue: function resetValue() {
      this.realName = '';
      this.realPhone = '';
    },

    submitHelp: Debounce(function () {
      var _this = this;
      if (this.realName == "") {
        this.realNameIcon = "error";
        window.scroll(0, 0);
        return;
      }
      if (this.realPhone == "") {
        this.realPhoneIcon = "error";
        window.scroll(0, 0);
        return;
      }
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contributeMaterial/save", {
        name: this.realName,
        phone: this.realPhone,
        identity: this.identity.join(","),
        agentQualify: '',
        materials: this.materialValue.join(","),
        inStock: this.spotValue.join(","),
        mdpl: this.allowCentify.join(","),
        businessLicense: this.businessAllow.join(","),
        mirc: this.registerCentifyValue.join(","),
        packImg: '',
        productionDate: this.productTime,
        output: this.dayNumber,
        company: this.company,
        isOpen: this.isAgree.join(","),
        rescueType: this.rushHelp.join(","),
        remark: this.remark
      }).then(function (res) {
        console.log(res);
        _this.isToast = true;
        _this.toastMsg = "提交成功";
        _this.toastType = "success";
        _this.resetValue();
      }).catch(function (err) {
        console.log(err);
        _this.isToast = true;
        _this.toastMsg = "提交失败";
        _this.toastType = "warn";
      });
    }, 3000),
    getRequest: function getRequest(key) {
      var url = location.href.split('?');
      var decodeFunc = unescape;
      if (url.length > 1) {
        var theRequest = new Object();
        var strs = url[1].split('&');
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = decodeFunc(strs[i].split('=')[1]);
        }
        return theRequest[key];
      } else {
        return null;
      }
    },
    saveViewUser: function saveViewUser() {
      var data = this.userinfo;
      data.privilege = data.privilege.toString();
      _axios_0_19_2_axios_default.a.post('/yuncai-yop/contribute/saveWXuser', data, { headers: { 'Content-Type': 'application/json' } }).then(function (res) {});
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var _this = this;

    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
      document.getElementsByTagName("title")[0].innerText = '互助汇 | 防疫物资紧急采购需求发布平台';
    } else {

      this.systemId = 0;
    }
    bus.$on('close-modal', function (v) {
      switch (_this.visindex) {
        case 0:
          _this.showmodalform = v;
          _this.showmodalform2 = v;
          _this.showmodalformview = v;
          _this.showmodalformview2 = v;
          _this.showmodalformother = v;
        case 1:
          _this.showmodalform3 = v;
          _this.showmodalform4 = v;
          _this.showmodalformview3 = v;
          _this.showmodalformview4 = v;
          _this.showmodalformother2 = v;
        case 2:
          _this.showmodalform5 = v;
          _this.showmodalform6 = v;
          _this.showmodalformview5 = v;
          _this.showmodalformview6 = v;
          _this.showmodalformview7 = v;
          _this.showmodalformview8 = v;

          _this.showmodalformother3 = v;
          _this.showmodalformother4 = v;

          break;
        case 3:
          _this.showmodal3 = false;
          break;
        case 4:
          _this.showmodal4 = false;
          break;
      }
    });

    bus.$on('open-formother', function (v, id) {
      switch (_this.visindex) {
        case 0:
          _this.showmodalformother = v;
          _this.billOtherId = id;
          break;
        case 1:
          _this.showmodalformother2 = v;
          _this.billOtherId = id;
          break;
        case 2:
          _this.showmodalformother3 = v;
          _this.showmodalformother4 = v;
          _this.billOtherId = id;
          break;
      }
    });

    _axios_0_19_2_axios_default.a.get('/yuncai-yop/contribute/addVisitRecord', {}, { timeout: 500 });

    var ui = localStorage.getItem('ui');
    var code = this.getRequest('code');
    if (!ui) {

      if (code) {
        this.hasAuth = 1;
        _axios_0_19_2_axios_default.a.get('/yuncai-yop/wechart/userInfo?code=' + code).then(function (response) {
          if (response.data && response.data.status == 1) {
            _this2.userinfo = response.data.data;
            localStorage.setItem('ui', stringify_default()(_this2.userinfo));
            _this2.saveViewUser();
          }
        });
      } else {
        this.hasAuth = 0;
      }
    } else {
      this.userinfo = JSON.parse(ui);
      this.hasAuth = 1;
      this.saveViewUser();
    }

    this.getPurchaseList();
    _axios_0_19_2_axios_default.a.post('/yuncai-yop/wechart/sign', {
      url: location.href.split('#')[0]
    }).then(function (response) {
      if (response.data.status == 1) {
        var _response$data$data = response.data.data,
            signature = _response$data$data.signature,
            appId = _response$data$data.appId,
            nonceStr = _response$data$data.nonceStr,
            timestamp = _response$data$data.timestamp;

        _weixin_js_sdk_1_4_0_test_weixin_js_sdk_default.a.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appId, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
        });
      }
    });

    _weixin_js_sdk_1_4_0_test_weixin_js_sdk_default.a.ready(function () {
      debugger;
      var config = {
        title: '智慧云采丨防疫物资紧急采购需求发布平台',
        desc: '用友采购云-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道',
        link: location.href.split('#')[0],
        imgUrl: location.origin + '/cpu-relief/static/logo.jpg',
        success: function success(res) {
          console.log('已分享');
        }
      };
      var tag = window.location.search.split('=')[1];
      if (tag && tag.includes('hzh')) {
        config.title = '互助汇丨防疫物资紧急采购全球供需平台';
        config.desc = '互助汇-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道';
        config.imgUrl = location.origin + '/cpu-relief/static/logo2.png';
      }
      _weixin_js_sdk_1_4_0_test_weixin_js_sdk_default.a.updateAppMessageShareData(config);
      _weixin_js_sdk_1_4_0_test_weixin_js_sdk_default.a.updateTimelineShareData(config);
    });
    var abs = 0;
    var i = 0;
    setInterval(function () {
      if (_this2.visindex == 0) {
        abs -= 26;
        i++;
        if (_this2.list.length < i + 3) {
          abs = 0;
          i = 0;
        }
        _this2.transform = { transform: 'translateY(' + abs + 'px)' };
      }
    }, 2000);
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloFromVux.vue

































Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  }return fmt;
};
/* harmony default export */ var components_HelloFromVux = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Group: _vux_2_9_4_vux_src_components_group,
    Cell: _vux_2_9_4_vux_src_components_cell,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    XInput: _vux_2_9_4_vux_src_components_x_input,
    XTextarea: _vux_2_9_4_vux_src_components_x_textarea,
    XButton: _vux_2_9_4_vux_src_components_x_button,
    Card: _vux_2_9_4_vux_src_components_card,
    Alert: node_modules__vux_2_9_4_vux_src_components_alert,
    Loading: _vux_2_9_4_vux_src_components_loading,
    Toast: _vux_2_9_4_vux_src_components_toast,
    Icon: _vux_2_9_4_vux_src_components_icon,
    Radio: node_modules__vux_2_9_4_vux_src_components_radio,
    Checklist: _vux_2_9_4_vux_src_components_checklist,
    Datetime: _vux_2_9_4_vux_src_components_datetime,
    XDialog: _vux_2_9_4_vux_src_components_x_dialog,
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Divider: _vux_2_9_4_vux_src_components_divider,
    VehicleRequire: src_components_VehicleRequire,
    VehicleResource: src_components_VehicleResource,
    AddSubmit: src_components_AddSubmit,
    AddForm: src_components_AddForm,
    AddFormOther: src_components_AddFormOther,
    AddFormView: src_components_AddFormView
  },
  data: function data() {
    return {

      showmodal: false,
      showmodalform: false,
      showmodalform2: false,
      showmodalform3: false,
      showmodalform4: false,
      showmodalform5: false,
      showmodalform6: false,
      showmodalformview: false,
      showmodalformview2: false,
      showmodalformview3: false,
      showmodalformview4: false,
      showmodalformview5: false,
      showmodalformview6: false,
      showmodalformview7: false,
      showmodalformview8: false,
      showmodalformother: false,
      showmodalformother2: false,
      showmodalformother3: false,
      showmodalformother4: false,
      bannerurl: __webpack_require__("hKcQ"),
      banner2url: __webpack_require__("y5LZ"),
      msg: 'Hello World!',
      visindex: 1,
      hasAuth: 0,
      transform: { transform: 'translateY(0)' },
      positionimg: __webpack_require__("A1tS"),
      positionimg2: __webpack_require__("chPc"),
      positionimg3: __webpack_require__("ZK0V"),
      imgList: [{ url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfab254d-2129-4fc8-ab3b-c0c7f53d7dba_湖北-恩施.jpg', field1: '湖北-恩施' }, { url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfa7699b-6ae3-4f8b-bcbe-c56bdbdc9bc8_湖北-监利县.jpg', field1: '湖北-监利县' }, { url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/53753b9b-0f2b-48e8-b8eb-ce27b18bcb3c_湖北-公安县.jpg', field1: '湖北-公安县' }, { url: 'http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/0e4bc83a-386d-46e5-809f-da12f392124b_湖北-来凤县.jpg', field1: '湖北-来凤县' }],
      value: '',
      name: '',
      phone: '',
      location: '',
      materialDes: '',
      msgAlert: '',
      userinfo: {},
      isOpen: false,
      isLoading: false,
      loadingText: '提交中',
      isToast: false,
      toastMsg: '提交成功',
      toastType: 'success',
      list: [],
      list4Supply: [],
      list4Donation: [],
      pageNum: 0,
      pageNum4Supply: 0,
      pageNum4Donation: 0,
      nameIcon: '',
      phoneIcon: '',
      locationIcon: '',

      realName: '',
      realNameIcon: '',
      realPhone: '',
      realPhoneIcon: '',
      identity: ['中间商/代理商'], //身份
      material: ['N95医用防护口罩（GB 19083-2010）及以上', '医用外科口罩（YY0469-2011)及以上', '防护服（GB 19082-2003）及以上', '护目镜', '医用帽', '一次性手术衣', '医用一次性乳胶手套（GB 10213-2006）', '防冲击眼罩', '防护面罩', '隔离衣', 'N95口罩', 'KN95口罩', '其他防护物品'],
      materialValue: ['N95医用防护口罩（GB 19083-2010）及以上'],

      isAgreeOptions: [{ value: '同意', key: '1' }, { value: '不同意', key: '0' }],
      isAgree: ['1'],

      spot: [{ value: '是', key: '1' }, { value: '否', key: '0' }], //现货
      spotValue: ['1'],

      allowCentify: ['1'],
      businessAllow: ['1'],
      registerCentify: [{ value: '是', key: '1' }, { value: '否', key: '0' }],
      registerCentifyValue: ['1'],
      productTime: '',
      dayNumber: 0,
      company: '',
      remark: '',
      rushHelp: ['捐赠'],
      buttonText: '我要捐赠',
      buttonTextLeft: '我要采购',
      buttonTextRight: '我要供应',
      showmodal3: false,
      showmodal4: false,
      systemId: '',
      billId: '',
      billOtherId: ''
    };
  },

  methods: {
    viewpublicdata: function viewpublicdata() {

      var redirecturl = encodeURIComponent(location.origin + '/cpu-relief/');
      location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa4c7f0efdef96aa7&redirect_uri=' + redirecturl + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
    },
    isAuth: function isAuth() {
      return this.hasAuth == 0 && (this.visindex == 1 || this.visindex == 3 || this.visindex == 4);
    },
    help: function help() {
      switch (this.visindex) {
        case 0:
          this.showmodalform = true;
          break;
        case 1:
          this.showmodalform3 = true;
          break;
        case 2:
          this.showmodalform5 = true;
          break;
      }
    },
    donate: function donate() {
      switch (this.visindex) {
        case 0:
          this.showmodalform2 = true;
          break;
        case 1:
          this.showmodalform4 = true;
          break;
        case 2:
          this.showmodalform6 = true;
          break;
        case 3:
          this.showmodal3 = true;
          break;
        case 4:
          this.showmodal4 = true;
          break;
      }
    },
    format: function format(ts) {
      var d = new Date(ts).Format("yyyy-MM-dd");
      return d;
    },
    handler: function handler(index) {
      this.visindex = index;
      switch (index) {
        case 0:

          this.getDonationList();
          this.buttonTextLeft = "我要募捐";
          this.buttonTextRight = "我要捐赠";
          break;
        case 1:
          this.buttonTextLeft = "我要采购";
          this.buttonTextRight = "我要供应";
          break;
        case 2:

          this.getSupplyList();
          this.buttonTextLeft = "我要捐赠";
          this.buttonTextRight = "我要供应";
          break;
        case 3:
          this.buttonTextRight = "我要用车";
          break;
        case 4:
          this.buttonTextRight = "我有资源";
          break;
      }
    },
    setIconType: function setIconType(v, icon) {
      if (v == "") {
        this[icon] = "error";
      } else {
        this[icon] = "success";
      }
    },

    submit: Debounce(function () {

      var _this = this;
      if (this.name == "") {
        this.nameIcon = "error";
        return;
      }
      if (this.location == "") {
        this.locationIcon = "error";
        return;
      }
      if (this.phone == "") {
        this.phoneIcon = "error";
        return;
      }
      if (this.materialDes == "") {
        this.isToast = true;
        this.toastMsg = "物资信息必填";
        this.toastType = "text";
        return;
      }

      _axios_0_19_2_axios_default.a.post('/yuncai-yop/contribute/save', {
        name: this.name,
        phone: this.phone,
        location: this.location,
        materialDes: this.materialDes,
        field1: '0'
      }).then(function (res) {
        _this.isToast = true;
        _this.toastMsg = "提交成功,物资信息需经平台审核通过后方可公布出来";
        _this.toastType = "success";
        console.log(res);
      }).catch(function (err) {
        console.log(err);
        _this.isToast = true;
        _this.toastMsg = "提交失败";
        _this.toastType = "warn";
      });
    }, 3000),

    getDonationList: function getDonationList() {
      var pageNum4Donation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this = this;
      var data = {
        pageNum: pageNum4Donation,
        pageSize: 10,
        types: [4, 5],
        systemId: _this.systemId
      };
      if (this.hasAuth) {
        data.auth = 1;
      }
      this.isLoading = true;
      this.loadingText = "加载中...";
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contribute/page", data).then(function (res) {
        if (res.status == 200) {
          var list = res.data.data.list || [];
          _this.list4Donation = _this.list4Donation.concat(list);
          if (res.data.data.nextPage > 0) {
            _this.pageNum4Donation = res.data.data.nextPage - 1;
          } else {
            _this.pageNum4Donation = 0;
          }
        }
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    },
    getPurchaseList: function getPurchaseList() {
      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this = this;
      var data = {
        pageNum: pageNum,
        pageSize: 10,
        types: [0, 10, 11],
        systemId: _this.systemId
      };
      if (this.hasAuth) {
        data.auth = 1;
      }
      this.isLoading = true;
      this.loadingText = "加载中...";
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contribute/page", data).then(function (res) {
        if (res.status == 200) {
          var list = res.data.data.list || [];
          _this.list = _this.list.concat(list);
          if (res.data.data.nextPage > 0) {
            _this.pageNum = res.data.data.nextPage - 1;
          } else {
            _this.pageNum = 0;
          }
        }
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    },
    getSupplyList: function getSupplyList() {
      var pageNum4Supply = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this = this;
      var data = {
        pageNum: pageNum4Supply,
        pageSize: 10,
        types: [1, 6, 7, 8, 9],
        systemId: _this.systemId
      };
      if (this.hasAuth) {
        data.auth = 1;
      }
      this.isLoading = true;
      this.loadingText = "加载中...";
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contribute/page", data).then(function (res) {
        if (res.status == 200) {
          var list = res.data.data.list || [];
          _this.list4Supply = _this.list4Supply.concat(list);
          if (res.data.data.nextPage > 0) {
            _this.pageNum4Supply = res.data.data.nextPage - 1;
          } else {
            _this.pageNum4Supply = 0;
          }
        }
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    },
    toastHide: function toastHide() {
      if (this.toastType !== "text") {
        this.name = '';
        this.phone = '';
        this.location = '';
        this.materialDes = '';
      }
    },
    hide: function hide() {},
    billShowView: function billShowView(item) {
      this.billId = item.id;
      switch (item.type) {
        case 4:
          this.showmodalformview = true;
          break;
        case 5:
          this.showmodalformview2 = true;
          break;
        case 6:
          this.showmodalformview8 = true;
          break;
        case 7:
          this.showmodalformview7 = true;
          break;
        case 8:
          this.showmodalformview6 = true;
          break;
        case 9:
          this.showmodalformview5 = true;
          break;
        case 10:
          this.showmodalformview3 = true;
          break;
        case 11:
          this.showmodalformview4 = true;
          break;
      }
    },

    /* ------------------------------ */

    myDonation: function myDonation(item) {
      this.billOtherId = item.id;
      this.showmodalformother = true;
    },
    mySupply: function mySupply(item) {
      this.billOtherId = item.id;
      this.showmodalformother2 = true;
    },
    myPurchase: function myPurchase(item) {
      this.billOtherId = item.id;
      this.showmodalformother3 = true;
    },
    myFundrais: function myFundrais(item) {
      this.billOtherId = item.id;
      this.showmodalformother4 = true;
    },
    resetValue: function resetValue() {
      this.realName = '';
      this.realPhone = '';
    },

    submitHelp: Debounce(function () {
      var _this = this;
      if (this.realName == "") {
        this.realNameIcon = "error";
        window.scroll(0, 0);
        return;
      }
      if (this.realPhone == "") {
        this.realPhoneIcon = "error";
        window.scroll(0, 0);
        return;
      }
      _axios_0_19_2_axios_default.a.post("/yuncai-yop/contributeMaterial/save", {
        name: this.realName,
        phone: this.realPhone,
        identity: this.identity.join(","),
        agentQualify: '',
        materials: this.materialValue.join(","),
        inStock: this.spotValue.join(","),
        mdpl: this.allowCentify.join(","),
        businessLicense: this.businessAllow.join(","),
        mirc: this.registerCentifyValue.join(","),
        packImg: '',
        productionDate: this.productTime,
        output: this.dayNumber,
        company: this.company,
        isOpen: this.isAgree.join(","),
        rescueType: this.rushHelp.join(","),
        remark: this.remark
      }).then(function (res) {
        console.log(res);
        _this.isToast = true;
        _this.toastMsg = "提交成功";
        _this.toastType = "success";
        _this.resetValue();
      }).catch(function (err) {
        console.log(err);
        _this.isToast = true;
        _this.toastMsg = "提交失败";
        _this.toastType = "warn";
      });
    }, 3000),
    getRequest: function getRequest(key) {
      var url = location.href.split('?');
      var decodeFunc = unescape;
      if (url.length > 1) {
        var theRequest = new Object();
        var strs = url[1].split('&');
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = decodeFunc(strs[i].split('=')[1]);
        }
        return theRequest[key];
      } else {
        return null;
      }
    },
    saveViewUser: function saveViewUser() {
      var data = this.userinfo;
      data.privilege = data.privilege.toString();
      _axios_0_19_2_axios_default.a.post('/yuncai-yop/contribute/saveWXuser', data, { headers: { 'Content-Type': 'application/json' } }).then(function (res) {});
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var _this = this;

    var tag = window.location.search.split('=')[1];
    if (tag && tag.includes('hzh')) {

      this.systemId = 1;
      document.getElementsByTagName("title")[0].innerText = '互助汇 | 防疫物资紧急采购需求发布平台';
    } else {

      this.systemId = 0;
    }
    bus.$on('close-modal', function (v) {
      switch (_this.visindex) {
        case 0:
          _this.showmodalform = v;
          _this.showmodalform2 = v;
          _this.showmodalformview = v;
          _this.showmodalformview2 = v;
          _this.showmodalformother = v;
        case 1:
          _this.showmodalform3 = v;
          _this.showmodalform4 = v;
          _this.showmodalformview3 = v;
          _this.showmodalformview4 = v;
          _this.showmodalformother2 = v;
        case 2:
          _this.showmodalform5 = v;
          _this.showmodalform6 = v;
          _this.showmodalformview5 = v;
          _this.showmodalformview6 = v;
          _this.showmodalformview7 = v;
          _this.showmodalformview8 = v;

          _this.showmodalformother3 = v;
          _this.showmodalformother4 = v;

          break;
        case 3:
          _this.showmodal3 = false;
          break;
        case 4:
          _this.showmodal4 = false;
          break;
      }
    });

    bus.$on('open-formother', function (v, id) {
      switch (_this.visindex) {
        case 0:
          _this.showmodalformother = v;
          _this.billOtherId = id;
          break;
        case 1:
          _this.showmodalformother2 = v;
          _this.billOtherId = id;
          break;
        case 2:
          _this.showmodalformother3 = v;
          _this.showmodalformother4 = v;
          _this.billOtherId = id;
          break;
      }
    });

    _axios_0_19_2_axios_default.a.get('/yuncai-yop/contribute/addVisitRecord', {}, { timeout: 500 });

    var ui = localStorage.getItem('ui');
    var code = this.getRequest('code');
    if (!ui) {

      if (code) {
        this.hasAuth = 1;
        _axios_0_19_2_axios_default.a.get('/yuncai-yop/wechart/userInfo?code=' + code).then(function (response) {
          if (response.data && response.data.status == 1) {
            _this2.userinfo = response.data.data;
            localStorage.setItem('ui', stringify_default()(_this2.userinfo));
            _this2.saveViewUser();
          }
        });
      } else {
        this.hasAuth = 0;
      }
    } else {
      this.userinfo = JSON.parse(ui);
      this.hasAuth = 1;
      this.saveViewUser();
    }

    this.getPurchaseList();
    _axios_0_19_2_axios_default.a.post('/yuncai-yop/wechart/sign', {
      url: location.href.split('#')[0]
    }).then(function (response) {
      if (response.data.status == 1) {
        var _response$data$data = response.data.data,
            signature = _response$data$data.signature,
            appId = _response$data$data.appId,
            nonceStr = _response$data$data.nonceStr,
            timestamp = _response$data$data.timestamp;

        _weixin_js_sdk_1_4_0_test_weixin_js_sdk_default.a.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appId, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
        });
      }
    });

    _weixin_js_sdk_1_4_0_test_weixin_js_sdk_default.a.ready(function () {
      debugger;
      var config = {
        title: '智慧云采丨防疫物资紧急采购需求发布平台',
        desc: '用友采购云-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道',
        link: location.href.split('#')[0],
        imgUrl: location.origin + '/cpu-relief/static/logo.jpg',
        success: function success(res) {
          console.log('已分享');
        }
      };
      var tag = window.location.search.split('=')[1];
      if (tag && tag.includes('hzh')) {
        config.title = '互助汇丨防疫物资紧急采购全球供需平台';
        config.desc = '互助汇-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道';
        config.imgUrl = location.origin + '/cpu-relief/static/logo2.png';
      }
      _weixin_js_sdk_1_4_0_test_weixin_js_sdk_default.a.updateAppMessageShareData(config);
      _weixin_js_sdk_1_4_0_test_weixin_js_sdk_default.a.updateTimelineShareData(config);
    });
    var abs = 0;
    var i = 0;
    setInterval(function () {
      if (_this2.visindex == 0) {
        abs -= 26;
        i++;
        if (_this2.list.length < i + 3) {
          abs = 0;
          i = 0;
        }
        _this2.transform = { transform: 'translateY(' + abs + 'px)' };
      }
    }, 2000);
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-362e7337","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloFromVux.vue
var HelloFromVux_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vux-demo",style:({
      backgroundImage: _vm.systemId == 0 ? 'url(' + _vm.bannerurl + ')' : 'url(' + _vm.banner2url + ')',    
      backgroundSize: '100%',
      paddingTop: '58%'})}),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px 12px","margin-top":"-34px"}},[_c('div',{staticClass:"tabs"},[(false)?_c('div',{class:[_vm.systemId == 0 ? 'tabs-item': 'tabs-item-hzh'],on:{"click":function($event){return _vm.handler(0)}}},[_c('div',{staticClass:"icon icon-1",class:[_vm.visindex == 0 ? 'active': '']}),_vm._v(" "),_c('div',[_vm._v("募捐专区")])]):_vm._e(),_vm._v(" "),_c('div',{class:[_vm.systemId == 0 ? 'tabs-item': 'tabs-item-hzh'],on:{"click":function($event){return _vm.handler(1)}}},[_c('div',{staticClass:"icon icon-2",class:[_vm.visindex == 1 ? 'active': '']}),_vm._v(" "),_c('div',[_vm._v("采购专区")])]),_vm._v(" "),_c('div',{class:[_vm.systemId == 0 ? 'tabs-item': 'tabs-item-hzh'],on:{"click":function($event){return _vm.handler(2)}}},[_c('div',{staticClass:"icon icon-3",class:[_vm.visindex == 2 ? 'active': '']}),_vm._v(" "),_c('div',[_vm._v("供应专区")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.systemId==0),expression:"systemId==0"}],class:[_vm.systemId == 0 ? 'tabs-item': 'tabs-item-hzh'],on:{"click":function($event){return _vm.handler(3)}}},[_c('div',{staticClass:"icon icon-4",class:[_vm.visindex == 3 ? 'active': '']}),_vm._v(" "),_c('div',[_vm._v("车辆需求")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.systemId==0),expression:"systemId==0"}],class:[_vm.systemId == 0 ? 'tabs-item': 'tabs-item-hzh'],on:{"click":function($event){return _vm.handler(4)}}},[_c('div',{staticClass:"icon icon-5",class:[_vm.visindex == 4 ? 'active': '']}),_vm._v(" "),_c('div',[_vm._v("车辆资源")])])])]),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visindex==0),expression:"visindex==0"}]},[(_vm.systemId==1)?_c('p',{staticClass:"red",staticStyle:{"padding":"0 20px 15px 20px"}},[_vm._v("\n        全国各大疫区物资紧缺，急需救援！如您愿意可为以下企业单位给予爱心支援！\n    ")]):_vm._e(),_vm._v(" "),(_vm.systemId==0)?_c('p',{staticClass:"blue",staticStyle:{"padding":"0 20px 15px 20px"}},[_c('span',[_vm._v("告急!")]),_vm._v("  湖北及其他城市医院防控物资非常紧缺，急需救援！以下是各大医院名单及医院官方发布的资料！请求大家支援！请放心捐赠！\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"0","padding":"10px"}},[_vm._l((_vm.list4Donation),function(item,index){return _c('div',{key:index,staticClass:"container",staticStyle:{"box-shadow":"0 2px 15px 1px #B8BDF6","border-radius":"4px"}},[_c('div',{staticClass:"vux-1px-b",staticStyle:{"font-size":"15px","color":"#333","font-weight":"bold","padding-left":"10px","line-height":"28px","padding-bottom":"2px"}},[_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.positionimg,"width":"15px"}}),_vm._v(" "),(item.type==4)?_c('span',{staticStyle:{"vertical-align":"middle","color":"#333"}},[_vm._v(_vm._s(item.enterpriseName))]):_vm._e(),_vm._v(" "),(item.type==5)?_c('span',{staticStyle:{"vertical-align":"middle","color":"#333"}},[_vm._v(_vm._s(item.supplierEnterpriseName))]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px 24px 0 0","font-size":"12px","margin-left":"-5px"}},[(item.isPub==1 && item.type==4 && item.executeStatus==null)?_c('span',{staticClass:"executeStatus"},[_vm._v("待捐赠")]):_vm._e(),_vm._v(" "),(item.isPub==1 && item.executeStatus==0)?_c('span',{staticClass:"executeStatus"},[_vm._v("待实施")]):_vm._e(),_vm._v(" "),(item.isPub==1 && item.executeStatus==2)?_c('span',{staticClass:"executeStatus2"},[_vm._v("已完成")]):_vm._e(),_vm._v(" "),(item.isPub==1 && item.executeStatus==3)?_c('span',{staticClass:"executeStatus2"},[_vm._v("已失效")]):_vm._e(),_vm._v(" "),(item.type==4)?_c('span',{staticClass:"type2"},[_vm._v("公开募捐")]):_vm._e(),_vm._v(" "),(item.type==5 && item.executeStatus!=null)?_c('span',{staticClass:"type"},[_vm._v("定向募捐")]):_vm._e(),_vm._v(" "),(item.type==5 && item.executeStatus==null)?_c('span',{staticClass:"type4"},[_vm._v("定向募捐")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 24px 10px 10px","font-size":"14px","color":"#333"},on:{"click":function($event){return _vm.billShowView(item)}}},[_c('div',{staticStyle:{"margin-top":"5px"}}),_vm._v(" "),_vm._l((item.details),function(i,key){return _c('span',{key:key},[_c('span',{staticStyle:{"margin-top":"4px"}},[_vm._v(_vm._s(i.materialClassName)+"\n                "),(i.materialNum)?_c('span',[_vm._v("（"+_vm._s(i.materialNum)+"）")]):_vm._e()]),_vm._v(";\n            ")])}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","padding-right":"10px","margin-top":"10px","color":"#666666"}},[(item.type==4)?_c('div',[_vm._v("联系人： "+_vm._s(item.name + ' ' + item.phone))]):_vm._e(),_vm._v(" "),(item.type==5)?_c('div',[_vm._v("联系人： "+_vm._s(item.supplierName + ' ' + item.supplierPhone))]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","padding-right":"10px","margin-top":"10px","color":"#666666"}},[_c('div',[_vm._v("地址： "+_vm._s(item.location))])])],2),_vm._v(" "),(item.isPub==1 && item.type==4 && item.executeStatus==null)?_c('div',{staticClass:"vux-1px-t area_btn",on:{"click":function($event){return _vm.myDonation(item)}}},[_vm._v("我要捐赠")]):_vm._e()])}),_vm._v(" "),(_vm.pageNum4Donation > 0)?_c('a',{staticClass:"more",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getDonationList(_vm.pageNum4Donation)}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(_vm.pageNum4Donation <= 0)?_c('divider',[_vm._v("已经到底了")]):_vm._e()],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visindex==1),expression:"visindex==1"}]},[_c('div',{},[(_vm.systemId==1)?_c('p',{staticClass:"red",staticStyle:{"padding":"0 20px 15px 20px"}},[_vm._v("\n        紧急动员全球爱心人士，通过互联网大数据分析帮你联系对应供货渠道，携手共渡难关。（人工对接请联系"),_c('a',{staticStyle:{"color":"#4966e5"},attrs:{"href":"tel:13810206951"}},[_vm._v("13810206951")]),_vm._v("）\n      ")]):_vm._e(),_vm._v(" "),(_vm.systemId==0)?_c('p',{staticClass:"red",staticStyle:{"padding":"0 20px 15px 20px"}},[_vm._v("\n        集结友云采全国30万+优质供应商及全国供应商资源，通过互联网大数据，助力企业复工物资采购。（人工对接\n        "),_c('a',{staticStyle:{"color":"#4966e5"},attrs:{"href":"tel:13601118654"}},[_vm._v("13601118654")]),_vm._v("）\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"0","padding":"10px"}},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"container",staticStyle:{"box-shadow":"0 2px 15px 1px #B8BDF6","border-radius":"4px"}},[_c('div',{staticClass:"vux-1px-b",staticStyle:{"font-size":"15px","color":"#333","font-weight":"bold","padding-left":"10px","line-height":"28px","padding-bottom":"2px"}},[_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.positionimg,"width":"15px"}}),_vm._v(" "),(item.type==10)?_c('span',{staticStyle:{"vertical-align":"middle","color":"#333"}},[_vm._v(_vm._s(item.enterpriseName))]):_vm._e(),_vm._v(" "),(item.type==11)?_c('span',{staticStyle:{"vertical-align":"middle","color":"#333"}},[_vm._v(_vm._s(item.supplierEnterpriseName))]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px 24px 0 0","font-size":"12px","margin-left":"-5px"}},[(item.isPub==1 && item.type==10 && item.executeStatus==null)?_c('span',{staticClass:"executeStatus"},[_vm._v("待供应")]):_vm._e(),_vm._v(" "),(item.isPub==1 && item.executeStatus==0)?_c('span',{staticClass:"executeStatus"},[_vm._v("待实施")]):_vm._e(),_vm._v(" "),(item.isPub==1 && item.executeStatus==2)?_c('span',{staticClass:"executeStatus2"},[_vm._v("已完成")]):_vm._e(),_vm._v(" "),(item.isPub==1 && item.executeStatus==3)?_c('span',{staticClass:"executeStatus2"},[_vm._v("已失效")]):_vm._e(),_vm._v(" "),(item.type==10)?_c('span',{staticClass:"type2"},[_vm._v("公开采购")]):_vm._e(),_vm._v(" "),(item.type==11 && item.executeStatus!=null)?_c('span',{staticClass:"type"},[_vm._v("定向采购")]):_vm._e(),_vm._v(" "),(item.type==11 && item.executeStatus==null)?_c('span',{staticClass:"type4"},[_vm._v("定向采购")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 24px 10px 10px","font-size":"14px","color":"#333"},on:{"click":function($event){return _vm.billShowView(item)}}},[_c('div',{staticStyle:{"margin-top":"5px"}}),_vm._v(" "),_vm._l((item.details),function(i,key){return _c('span',{key:key},[_c('span',{staticStyle:{"margin-top":"4px"}},[_vm._v(_vm._s(i.materialClassName)+"\n                "),(i.materialNum)?_c('span',[_vm._v("（"+_vm._s(i.materialNum)+"）")]):_vm._e()]),_vm._v(";\n            ")])}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","padding-right":"10px","margin-top":"10px","color":"#666666"}},[(item.type==10)?_c('div',[_vm._v("联系人： "+_vm._s(item.name + ' ' + item.phone))]):_vm._e(),_vm._v(" "),(item.type==11)?_c('div',[_vm._v("联系人： "+_vm._s(item.supplierName + ' ' + item.supplierPhone))]):_vm._e()])],2),_vm._v(" "),(item.isPub==1 && item.type==10 && item.executeStatus==null)?_c('div',{staticClass:"vux-1px-t area_btn",on:{"click":function($event){return _vm.mySupply(item)}}},[_vm._v("我要供应")]):_vm._e()])}),_vm._v(" "),(_vm.pageNum > 0)?_c('a',{staticClass:"more",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getPurchaseList(_vm.pageNum)}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(_vm.pageNum <= 0)?_c('divider',[_vm._v("已经到底了")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visindex==2),expression:"visindex==2"}]},[_c('div',{},[(_vm.systemId==1)?_c('p',{staticClass:"red",staticStyle:{"padding":"0 20px 15px 20px"}},[_vm._v("\n        为快速帮助全国医院及单位及时找到各类防护物资，如您有相关货源，请及时发布出来，感谢支持！（人工对接请联系"),_c('a',{staticStyle:{"color":"#4966e5"},attrs:{"href":"tel:13810206951"}},[_vm._v("13810206951")]),_vm._v("）")]):_vm._e(),_vm._v(" "),(_vm.systemId==0)?_c('p',{staticClass:"red",staticStyle:{"padding":"0 20px 15px 20px"}},[_vm._v("为快速帮助企业及时找到各类复工物资，如您有相关货源，请及时发布出来！（人工对接\n        "),_c('a',{staticStyle:{"color":"#4966e5"},attrs:{"href":"tel:13716275798"}},[_vm._v("13716275798")]),_vm._v("）")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"margin-top":"0","padding":"10px"}},[_vm._l((_vm.list4Supply),function(item,index){return _c('div',{key:index,staticClass:"container",staticStyle:{"box-shadow":"0 2px 15px 1px #B8BDF6","border-radius":"4px"}},[_c('div',{staticClass:"vux-1px-b",staticStyle:{"font-size":"15px","color":"#333","font-weight":"bold","padding-left":"10px","line-height":"28px","padding-bottom":"2px"}},[_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.positionimg,"width":"15px"}}),_vm._v(" "),(item.type==6||item.type==8)?_c('span',{staticStyle:{"vertical-align":"middle","color":"#333"}},[_vm._v(_vm._s(item.enterpriseName))]):_vm._e(),_vm._v(" "),(item.type==7||item.type==9)?_c('span',{staticStyle:{"vertical-align":"middle","color":"#333"}},[_vm._v(_vm._s(item.supplierEnterpriseName))]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px 24px 0 0","font-size":"12px","margin-left":"-5px"}},[(item.isPub==1 && item.executeStatus==null && item.type==8)?_c('span',{staticClass:"executeStatus"},[_vm._v("待采购")]):_vm._e(),_vm._v(" "),(item.isPub==1 && item.executeStatus==null && item.type==6)?_c('span',{staticClass:"executeStatus"},[_vm._v("待受捐")]):_vm._e(),_vm._v(" "),(item.isPub==1 && item.executeStatus==0)?_c('span',{staticClass:"executeStatus"},[_vm._v("待执行")]):_vm._e(),_vm._v(" "),(item.isPub==1 && item.executeStatus==1)?_c('span',{staticClass:"executeStatus2"},[_vm._v("已完成")]):_vm._e(),_vm._v(" "),(item.isPub==1 && item.executeStatus==2)?_c('span',{staticClass:"executeStatus2"},[_vm._v("已失效")]):_vm._e(),_vm._v(" "),(item.type==6)?_c('span',{staticClass:"type2"},[_vm._v("非定向捐赠")]):_vm._e(),_vm._v(" "),(item.type==7 && item.executeStatus!=null)?_c('span',{staticClass:"type"},[_vm._v("定向捐赠")]):_vm._e(),_vm._v(" "),(item.type==8)?_c('span',{staticClass:"type2"},[_vm._v("公开供应")]):_vm._e(),_vm._v(" "),(item.type==9 && item.executeStatus!=null)?_c('span',{staticClass:"type"},[_vm._v("定向供应")]):_vm._e(),_vm._v(" "),(item.type==7 && item.executeStatus==null)?_c('span',{staticClass:"type4"},[_vm._v("定向捐赠")]):_vm._e(),_vm._v(" "),(item.type==9 && item.executeStatus==null)?_c('span',{staticClass:"type4"},[_vm._v("定向供应")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 24px 10px 10px","font-size":"14px","color":"#333"},on:{"click":function($event){return _vm.billShowView(item)}}},[_c('div',{staticStyle:{"margin-top":"5px"}}),_vm._v(" "),_vm._l((item.details),function(i,key){return _c('span',{key:key},[_c('span',{staticStyle:{"margin-top":"4px"}},[_vm._v(_vm._s(i.materialClassName)+"\n                "),(i.materialNum)?_c('span',[_vm._v("（"+_vm._s(i.materialNum)+"）")]):_vm._e()]),_vm._v(";\n            ")])}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","padding-right":"10px","margin-top":"10px","color":"#666666"}},[(item.type==6||item.type==8)?_c('div',[_vm._v("联系人： "+_vm._s(item.name + ' ' + item.phone))]):_vm._e(),_vm._v(" "),(item.type==7||item.type==9)?_c('div',[_vm._v("联系人： "+_vm._s(item.supplierName + ' ' + item.supplierPhone))]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","padding-right":"10px","margin-top":"10px","color":"#666666"}},[_c('div',[_vm._v("地址： "+_vm._s(item.location))])])],2),_vm._v(" "),(item.executeStatus==null && item.type==8)?_c('div',{staticClass:"vux-1px-t area_btn",on:{"click":function($event){return _vm.myPurchase(item)}}},[_vm._v("我要采购")]):_vm._e(),_vm._v(" "),(item.executeStatus==null && item.type==6)?_c('div',{staticClass:"vux-1px-t area_btn",on:{"click":function($event){return _vm.myFundrais(item)}}},[_vm._v("申请受捐")]):_vm._e()])}),_vm._v(" "),(_vm.pageNum4Supply > 0)?_c('a',{staticClass:"more",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.getSupplyList(_vm.pageNum4Supply)}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(_vm.pageNum4Supply <= 0)?_c('divider',[_vm._v("已经到底了")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visindex==3),expression:"visindex==3"}]},[_c('VehicleRequire',{attrs:{"imgList":_vm.imgList,"hasAuth":_vm.hasAuth,"showmodal3":_vm.showmodal3}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visindex==4),expression:"visindex==4"}]},[_c('VehicleResource',{attrs:{"imgList":_vm.imgList,"hasAuth":_vm.hasAuth,"showmodal4":_vm.showmodal4}})],1),_vm._v(" "),_c('AddSubmit',{attrs:{"showmodal":_vm.showmodal,"type":0}}),_vm._v(" "),_c('AddForm',{attrs:{"showmodal":_vm.showmodalform,"type":4}}),_vm._v(" "),_c('AddForm',{attrs:{"showmodal":_vm.showmodalform2,"type":6}}),_vm._v(" "),_c('AddForm',{attrs:{"showmodal":_vm.showmodalform3,"type":10}}),_vm._v(" "),_c('AddForm',{attrs:{"showmodal":_vm.showmodalform4,"type":8}}),_vm._v(" "),_c('AddForm',{attrs:{"showmodal":_vm.showmodalform5,"type":6}}),_vm._v(" "),_c('AddForm',{attrs:{"showmodal":_vm.showmodalform6,"type":8}}),_vm._v(" "),_c('AddFormView',{attrs:{"showmodal":_vm.showmodalformview,"billId":_vm.billId,"type":4}}),_vm._v(" "),_c('AddFormView',{attrs:{"showmodal":_vm.showmodalformview2,"billId":_vm.billId,"type":5}}),_vm._v(" "),_c('AddFormView',{attrs:{"showmodal":_vm.showmodalformview3,"billId":_vm.billId,"type":10}}),_vm._v(" "),_c('AddFormView',{attrs:{"showmodal":_vm.showmodalformview4,"billId":_vm.billId,"type":11}}),_vm._v(" "),_c('AddFormView',{attrs:{"showmodal":_vm.showmodalformview5,"billId":_vm.billId,"type":9}}),_vm._v(" "),_c('AddFormView',{attrs:{"showmodal":_vm.showmodalformview6,"billId":_vm.billId,"type":8}}),_vm._v(" "),_c('AddFormView',{attrs:{"showmodal":_vm.showmodalformview7,"billId":_vm.billId,"type":7}}),_vm._v(" "),_c('AddFormView',{attrs:{"showmodal":_vm.showmodalformview8,"billId":_vm.billId,"type":6}}),_vm._v(" "),_c('AddFormOther',{attrs:{"showmodal":_vm.showmodalformother,"billOtherId":_vm.billOtherId,"type":7}}),_vm._v(" "),_c('AddFormOther',{attrs:{"showmodal":_vm.showmodalformother2,"billOtherId":_vm.billOtherId,"type":9}}),_vm._v(" "),_c('AddFormOther',{attrs:{"showmodal":_vm.showmodalformother3,"billOtherId":_vm.billOtherId,"type":11}}),_vm._v(" "),_c('AddFormOther',{attrs:{"showmodal":_vm.showmodalformother4,"billOtherId":_vm.billOtherId,"type":5}}),_vm._v(" "),(_vm.systemId==0)?_c('img',{staticStyle:{"margin":"20px auto","width":"100px","display":"block"},attrs:{"src":__webpack_require__("UI73")}}):_vm._e(),_vm._v(" "),(_vm.systemId==1)?_c('img',{staticStyle:{"margin":"20px auto","width":"100px","display":"block"},attrs:{"src":__webpack_require__("D+pl")}}):_vm._e(),_vm._v(" "),_c('alert',{attrs:{"title":"提示","content":_vm.msgAlert},on:{"on-hide":_vm.hide},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.isLoading,"text":_vm.loadingText}}),_vm._v(" "),_c('toast',{attrs:{"text":_vm.toastMsg,"type":_vm.toastType},on:{"on-hide":_vm.toastHide},model:{value:(_vm.isToast),callback:function ($$v) {_vm.isToast=$$v},expression:"isToast"}}),_vm._v(" "),_c('div',{staticClass:"float-button"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAuth()),expression:"isAuth()"}],staticClass:"float-button-detail",on:{"click":_vm.viewpublicdata}},[_vm._v("授权查看")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visindex==0 || _vm.visindex==1 || _vm.visindex==2),expression:"visindex==0 || visindex==1 || visindex==2"}],staticClass:"float-button-detail",staticStyle:{"right":"90px"},on:{"click":_vm.help}},[_vm._v(_vm._s(_vm.buttonTextLeft))]),_vm._v(" "),_c('div',{staticClass:"float-button-detail",on:{"click":_vm.donate}},[_vm._v(_vm._s(_vm.buttonTextRight))])])],1)}
var HelloFromVux_staticRenderFns = []
var HelloFromVux_esExports = { render: HelloFromVux_render, staticRenderFns: HelloFromVux_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_HelloFromVux = (HelloFromVux_esExports);
// CONCATENATED MODULE: ./src/components/HelloFromVux.vue
function HelloFromVux_injectStyle (ssrContext) {
  __webpack_require__("OFWd")
}
var HelloFromVux_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var HelloFromVux___vue_template_functional__ = false
/* styles */
var HelloFromVux___vue_styles__ = HelloFromVux_injectStyle
/* scopeId */
var HelloFromVux___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HelloFromVux___vue_module_identifier__ = null
var HelloFromVux_Component = HelloFromVux_normalizeComponent(
  components_HelloFromVux,
  selectortype_template_index_0_src_components_HelloFromVux,
  HelloFromVux___vue_template_functional__,
  HelloFromVux___vue_styles__,
  HelloFromVux___vue_scopeId__,
  HelloFromVux___vue_module_identifier__
)

/* harmony default export */ var src_components_HelloFromVux = (HelloFromVux_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//


/* harmony default export */ var App = ({
  name: 'app',
  components: {
    Home: src_components_HelloFromVux
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  components: {
    Home: src_components_HelloFromVux
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-fb78546a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('home')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Nlj4")
}
var App_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./i18nData/index.js
var i18nData = __webpack_require__("cnn2");
var i18nData_default = /*#__PURE__*/__webpack_require__.n(i18nData);

// CONCATENATED MODULE: ./src/cblang.js

var cb = {
  lang: {
    template: function template(resid) {
      var locale = window.localStorage.getItem('locale') || 'zhcn';
      var word = i18nData_default.a[locale][resid] || "";
      if (!word) {
        console.error("resid:" + resid + "WordNotFound");
      }
      return word;
    }
  }
};
/* harmony default export */ var cblang = (cb);
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import VueRouter from 'vue-router'


window.cb = cblang;
// Vue.use(VueRouter)

// const routes = [
//   {
//     path: '/',
//     component: Home
//   },
//   {
//     path:'/b',
//     // name:'OtherRequire',
//     components:OtherRequire
//   },
//   {
//     path:'/c',
//     // name:IFeedBack,
//     components:IFeedBack
//   }
// ]

// const router = new VueRouter({
//   routes
// })

fastclick_default.a.attach(document.body);
fastclick_default.a.prototype.focus = function (targetElement) {
  var length;
  var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
  var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
  //兼容处理:在iOS7中，有一些元素（如date、datetime、month等）在setSelectionRange会出现TypeError    
  //这是因为这些元素并没有selectionStart和selectionEnd的整型数字属性，所以一旦引用就会报错，因此排除这些属性才使用setSelectionRange方法
  if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month' && targetElement.type !== 'email') {
    length = targetElement.value.length;
    targetElement.setSelectionRange(length, length); //修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘    
    targetElement.focus();
  } else {
    targetElement.focus();
  }
};
var u = navigator.userAgent;
var flag;
var timer;
var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
if (isIOS) {
  document.body.addEventListener('focusin', function () {
    //软键盘弹起事件
    flag = true;
    clearTimeout(timer);
  });
  document.body.addEventListener('focusout', function () {
    //软键盘关闭事件
    flag = false;
    if (!flag) {
      timer = setTimeout(function () {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        }); //重点  =======当键盘收起的时候让页面回到原始位置(这里的top可以根据你们个人的需求改变，并不一定要回到页面顶部)
      }, 200);
    } else {
      return false;
    }
  });
}

vue_esm["a" /* default */].config.productionTip = false;
vue_esm["a" /* default */].prototype.cb = cblang;
/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "NYDs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nlj4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OFWd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OKWU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q1Fw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tms6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UI73":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.ce6d28a.jpg";

/***/ }),

/***/ "Ub/c":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAABGdBTUEAALGPC/xhBQAAAb5JREFUOBFtUj1LA0EQnbmPaKEgiGDwX1hGLRO1k4CCgmAXFdLYpsl/EEULG1sVFIuI2imCrbW9KAqCFnq3yTpv7vY8jttibnbezJuZt0eNrahN7tRbkVV/eduOkBq5MkKAxvxw9LMff3kOOdnnb82vb0bH6ohpbMav3GjFPQQs2YWZahgqCA4HMC5AHl7MJVBWDkvrTHx1fRguIohG6KgJMDigAG9yIwJLt8vGQwAVDgQTYlkLGe3NWjvhKgDiOEaZIX4PwmCqt8u/CZTYeis+I+ZLj6wdN1H8s9i2Qy5BwDvZtMmWphkAEgAGlXDYROZWwFmpPrk5CFdUzHySsqQgfN0i6c/3CoqRmdadrwlpT6UFkJ9JpNWBsp75dphJGP4HQjXaAUiZnlQHrIoAVPQrwVJRE2A4yRsZeW4hlcNMzypDPzLn7ikUKBAVC5EDmWYmgzWVCXfMXkYk/+mI64g8V4gfQa8azBkVITYXstZ8Lix1fFqbDFZdocOyCRAoHdVlyrdMIyUoLUx3fPwgv2w1Jzbe8Ux2bGaN0sLiqKUaeXQkz2g2mAYdsl6vVvV3ioUZceookYn37IDmmLzOH6LUFCGFYIPyAAAAAElFTkSuQmCC"

/***/ }),

/***/ "WqJG":
/***/ (function(module, exports) {

module.exports = {
  "YC_FED_1990880851": "Company/Orgnaization Full Name:",
  "YC_FED_831434141": "Please enter the full name of your company or organization",
  "YC_FED_4020825779": "Company/Orgnaization's Address:",
  "YC_FED_1028132413": "Please enter the address of your company or organization",
  "YC_FED_1122636714": "Key Contact:",
  "YC_FED_67440951": "Please enter your name",
  "YC_FED_911029432": "Phone Number:",
  "YC_FED_2186083564": "Please enter your phone number for reaching out",
  "YC_FED_192667973": "Category:",
  "YC_FED_1333127493": "Please select supply category",
  "YC_FED_194386418": "Supplies:",
  "YC_FED_2473871252": "Please enter the name of supplies",
  "YC_FED_194603968": "Quantity:",
  "YC_FED_3439953582": "Please enter qty, i.e. 100",
  "YC_FED_192826333": "Unit Price:",
  "YC_FED_118396460": "Please enter the unit price in CNY (RMB)",
  "YC_FED_192488796": "Description:",
  "YC_FED_434177049": "Please enter the supply goods specifications, brand or other detailed description (0/300 words limit)",
  "YC_FED_1213834093": "+ Add another supply",
  "YC_FED_6437105": "提交",
  "YC_FED_4618299": "关闭",
  "YC_FED_2533636894": "提交成功",
  "YC_FED_606653812": "N95 Medical Respirators (GB 19083-2010 or equivalent/higher standard)",
  "YC_FED_3133487643": "Surgical Masks (YY0469-2011 or equivalent/higher standard)",
  "YC_FED_4134432385": "Protective Suits (GB 19082-2003 or equivalent/higher standard)",
  "YC_FED_151877491": "Goggles",
  "YC_FED_208007819": "Medical Cap",
  "YC_FED_911057188": "Disposable Surgical Gowns",
  "YC_FED_1682877813": "Disposable Medical Latex Gloves",
  "YC_FED_2681630027": "Shock-proof / Splash-proof Safety Goggles",
  "YC_FED_2321700280": "Protective Masks",
  "YC_FED_159113289": "Isolation Gowns",
  "YC_FED_3028139373": "N95 Mask",
  "YC_FED_1144351558": "KN95 Mask",
  "YC_FED_3870867899": "Other Protective Supplies",
  "YC_FED_919362501": "Submission Failed",
  "YC_FED_1068639580": "提交成功,信息需经平台审核通过后方可公布出来",
  "YC_FED_1740703422": "募捐人信息",
  "YC_FED_1037509641": "募捐物资信息",
  "YC_FED_204689708": "供应商",
  "YC_FED_1739264961": "捐赠人信息",
  "YC_FED_1035681206": "捐赠物资信息",
  "YC_FED_200448147": "Supplies Raiser",
  "YC_FED_1739269997": "供货人信息",
  "YC_FED_1037192073": "供应物资信息",
  "YC_FED_200551582": "Demand Organization",
  "YC_FED_1740683955": "需求人信息",
  "YC_FED_1037618308": "需求物资信息",
  "YC_FED_2074959271": "所在地:",
  "YC_FED_2068410378": "联系人:",
  "YC_FED_1245154200": "联系电话:",
  "YC_FED_2853835295": "请输入数量,例如:100个",
  "YC_FED_452494987": "Please enter the unit price, i.e. 100 CNY",
  "YC_FED_1544319898": "申请募捐人信息",
  "YC_FED_4274620010": "定向捐赠人信息",
  "YC_FED_270630829": "申请募捐物资信息",
  "YC_FED_213722159": "Donor",
  "YC_FED_1739268934": "Donation Recipient Information",
  "YC_FED_1739323515": "Buyer Information",
  "YC_FED_1035728396": "Need to Purchase Supplies Information",
  "YC_FED_159160491": "Pending Fulfillment",
  "YC_FED_202378507": "Fulfilled",
  "YC_FED_200536782": "Expired",
  "YC_FED_194436000": "描述:",
  "YC_FED_2406273446": "公开募捐",
  "YC_FED_158279504": "待捐赠",
  "YC_FED_929987013": "我要捐赠",
  "YC_FED_2406173793": "Directed Supplies Raising",
  "YC_FED_928281369": "Openly Supplies Raising",
  "YC_FED_203092231": "待受捐",
  "YC_FED_3782982486": "我要申请受捐",
  "YC_FED_1740703670": "受捐人信息",
  "YC_FED_928292574": "Directed Donation",
  "YC_FED_2564348198": "公开供应",
  "YC_FED_159694250": "待采购",
  "YC_FED_974226303": "我要采购",
  "YC_FED_2564388065": "定向供应",
  "YC_FED_974926435": "Openly Purchasing",
  "YC_FED_207857551": "Not Fulfilled",
  "YC_FED_2563883258": "I have supplies",
  "YC_FED_1741057470": "供应人信息",
  "YC_FED_974857828": "Directed Procurement Request",
  "YC_FED_1593734474": "如果您在疫情防控工作中，存在防护物资的短缺情况，请按照以下格式真实反馈，我们将全力助您查寻对应供货渠道(请真实填写)",
  "YC_FED_2395463995": "Personal Information",
  "YC_FED_1041404309": "Full Name:",
  "YC_FED_1808074203": "Please enter your full name",
  "YC_FED_2549854617": "企业名称：",
  "YC_FED_432081186": "请输入企业名称",
  "YC_FED_1710252738": "请输入真实联系电话",
  "YC_FED_1037402129": "短缺物资信息",
  "YC_FED_1220517444": "请填写物资名称及数量，详细的规格型号或其他补充说明（最多可输入400字）",
  "YC_FED_3219929105": "提交成功,物资信息需经平台审核通过后方可公布出来",
  "YC_FED_1462376749": "我已阅读并同意",
  "YC_FED_1182055339": "《用户使用规则及免责声明》",
  "YC_FED_3087410922": "< back",
  "YC_FED_2348497461": "免责声明",
  "YC_FED_528452416": "第一条 协议订立",
  "YC_FED_4055161575": "1.1用户在同意本网站:智慧云采丨防疫物资紧急采购发布平台 (",
  "YC_FED_3221434543": ")的免责协议后，方可使用本网络服务平台(以下简称“平台”)提供的疫情防护物资供需信息相关服务(以下简称“服务”)。",
  "YC_FED_1736612144": "1.1用户在同意本网站:互助汇丨防疫物资紧急采购发布平台 (",
  "YC_FED_2084807500": "1.2用户在使用本平台提供的服务前请务必认真阅读本协议，一旦用户使用本平台提供的服务即表示用户同意与本平台签订本协议且同意受本协议之约束。",
  "YC_FED_3124526546": "第二条 服务说明",
  "YC_FED_2201916839": "2.1 通过本平台获取的捐赠机构、组织和个体，平台均称为 “捐赠方”，通过本平台获取的物资供应商，平台均称为 “供应方”。本平台仅为技术服务提供方。",
  "YC_FED_3665445276": "2.2 由于情况各异且随时会发生变化，本平台所有供应方、捐赠方目前均无法承诺实际情况。",
  "YC_FED_291743527": "2.3 需求内容以各机构在各大官方发布信息为准(认证微博、官方微信公众号、医院盖章文件等)，平台只做内容收集展示及部分人工核实。",
  "YC_FED_74884276": "第三条 用户的权利和义务",
  "YC_FED_1299145044": "3.1 用户使用本平台前，应仔细阅读各方具体信息。本协议中涉及交易双方、捐赠双方权利义务的内容，如有与我国相关法律冲突的，以我国相关法律为准。",
  "YC_FED_3689983678": "3.2 用户发布信息时，应当准确填写物资类目及具体数量等信息内容。",
  "YC_FED_2434946685": "3.3 如采购方、捐赠方需取得相应凭证，应与相关合作单位联系取得。在交易和捐赠等过程中，如因各项事宜产生争议，由用户与对应方协商解决。",
  "YC_FED_2177695349": "3.4 用户同意本平台向购买方、需求方、捐赠方、接受捐赠方等相关单位披露用户提交的信息中所涉及的各项内容（包括但不限于所在单位、联系电话等个人信息）。",
  "YC_FED_473969063": "第四条 免责说明",
  "YC_FED_2244574431": "4.1 因疫情变化，本平台显示的信息仅供参考，最终以实际供应及需求为准。",
  "YC_FED_478052221": "4.2 因用户提供错误信息所导致的损失，由用户自行承担，本平台不承担任何责任。",
  "YC_FED_251437274": "4.3 用户充分知晓并认可，本平台仅为公益性信息平台，物资供应方与需求方、捐赠方产生任何纠纷与本平台无关，本平台不因平台服务而承担任何担保、保证或连带责任。",
  "YC_FED_1502473923": "4.4 本平台会尽力维护平台信息的安全，但法律规定的不可抗力，以及因为黑客入侵、计算机病毒等原因造成用户资料泄露、丢失、被盗用、被篡改的，本平台不承担任何责任。",
  "YC_FED_3230073079": "4.5 本平台仅提供技术服务，不是交易合同、赠与合同等合同的权利义务主体，不介入用户与交易方之间的纠纷，但本平台将提供协助，保护用户的合法权益。",
  "YC_FED_2152434189": "4.6 本平台如被恶意篡改用于不正当募捐和交易使用，一律追责。",
  "YC_FED_539696760": "4.7 本平台唯一官方网址",
  "YC_FED_3133507652": "(智慧云采丨防疫物资紧急采购需求发布平台)如被人恶意假借名义进行不正当行为，与本平台无关。但本平台保留追究其法律责任的权利。",
  "YC_FED_154048019": "(互助汇丨防疫物资紧急采购需求发布平台)如被人恶意假借名义进行不正当行为，与本平台无关。但本平台保留追究其法律责任的权利。",
  "YC_FED_183727381": "第五条 争议解决及法律适用",
  "YC_FED_2912025593": "5.1 在用户有意向捐赠、求购、发布信息后，如果在约定内容履行过程中，对相关事宜的履行发生争议，用户同意按照中华人民共和国现行有效的相关法律法规来解决争议，并同意接受平台方所在地有管辖权的人民法院的管辖。",
  "YC_FED_2554030307": "Donation Center",
  "YC_FED_2552182054": "Purchasing Center",
  "YC_FED_2553971171": "Supply Center",
  "YC_FED_2448709159": "Vehicle Demands",
  "YC_FED_2471655281": "Vehicle Resource",
  "YC_FED_113148420": "全国各大疫区物资紧缺，急需救援！如您愿意可为以下企业单位给予爱心支援！",
  "YC_FED_192519691": "告急!",
  "YC_FED_3475192107": "&nbsp;&nbsp;湖北及其他城市医院防控物资非常紧缺，急需救援！以下是各大医院名单及医院官方发布的资料！请求大家支援！请放心捐赠！",
  "YC_FED_200132291": "Pending Fulfillment",
  "YC_FED_553553962": "联系人： ",
  "YC_FED_2099197199": "地址： ",
  "YC_FED_2619873061": "查看更多",
  "YC_FED_3205136507": "已经到底了",
  "YC_FED_3018779863": "Ask for urgent favor to all caring individuals around the globe: Let us help you match demand and supply channel by using big data analysis. We can ride out the storm hand-in-hand!",
  "YC_FED_2555520228": "Ask for urgent favor to all caring individuals around the globe: With the resource of 50000+ safety and protection goods suppliers of Yonyou Procurement Cloud, let us help you match demand and supply channel by using big data analysis. We can ride out the storm hand-in-hand!(Mobile:",
  "YC_FED_3602995043": "To help hospitals and organizations getting protective supplies ASAP, please post information if you have source of supplies. We appreciate your support!",
  "YC_FED_2918819944": "Yonyou Procurement Cloud established the demand and supply matching platform for epidemic control, to help Wuhan and other epidemic areas against CoronaVirus, make sure the medical and protection supplies arrives fornt-line hospitals and organizations on time. Please post information if you have source of supplies. We appreciate your support! Thank you!",
  "YC_FED_568913344": "Donation",
  "YC_FED_2405343526": "Apply for Donation",
  "YC_FED_6030255": "Reminder",
  "YC_FED_2234412832": "Authorize to View",
  "YC_FED_1927386792": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfab254d-2129-4fc8-ab3b-c0c7f53d7dba_湖北-恩施.jpg",
  "YC_FED_3577225693": "湖北-恩施",
  "YC_FED_2330653473": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfa7699b-6ae3-4f8b-bcbe-c56bdbdc9bc8_湖北-监利县.jpg",
  "YC_FED_3036342030": "湖北-监利县",
  "YC_FED_269199880": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/53753b9b-0f2b-48e8-b8eb-ce27b18bcb3c_湖北-公安县.jpg",
  "YC_FED_657870771": "湖北-公安县",
  "YC_FED_3130702216": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/0e4bc83a-386d-46e5-809f-da12f392124b_湖北-来凤县.jpg",
  "YC_FED_3847805047": "湖北-来凤县",
  "YC_FED_212206716": "Submitting…",
  "YC_FED_2434616598": "中间商/代理商",
  "YC_FED_6110694": "Agree",
  "YC_FED_201634987": "Not Agree",
  "YC_FED_185226": "Yes",
  "YC_FED_188803": "No",
  "YC_FED_4796981": "Donate",
  "YC_FED_2405767290": "我要募捐",
  "YC_FED_978087483": "I need transportation vehicles",
  "YC_FED_2470384297": "I have vehicle resource",
  "YC_FED_4077360456": "Supplies Information - Required",
  "YC_FED_3381849403": "Loading...",
  "YC_FED_2617892266": "Youyou and UBBS Against CoronaVirus - Emergency Supplies Global Sourcing Platform",
  "YC_FED_1759574121": "智慧云采丨防疫物资紧急采购需求发布平台",
  "YC_FED_3956978529": "用友采购云-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道",
  "YC_FED_212056634": "已分享",
  "YC_FED_2308923102": "Youyou and UBBS Against CoronaVirus - Emergency Supplies Global Sourcing Platform",
  "YC_FED_3071947429": "Youyou and UBBS Against CoronaVirus - Emergency Supplies Global Sourcing Platform",
  "YC_FED_1218218790": "为确保防护物资能第一时间送抵目的地，如您需要物流资源支持，请填写真实需求发布！",
  "YC_FED_163921277": "需求：",
  "YC_FED_1864683465": "车辆需求信息",
  "YC_FED_471295947": "请填写需要的车辆车型，运输区域，计划运输时间区间，计划运输物品或其他补充说明（最多可输入400字）",
  "YC_FED_1323221205": "全国疫区物流资源紧缺，为确保防护物资能第一时间送抵目的地，如您有相关物流资源，烦请发布！",
  "YC_FED_163954859": "资源：",
  "YC_FED_3027635972": "紧急动员全球爱心人士，通过互联网大数据分析帮你联系对应供货渠道，携手共渡难关。（人工对接请联系",
  "YC_FED_1789495300": "紧急动员全球爱心人士，集结友云采全国5万+优质安全防护类供应商，通过互联网大数据分析尽可能联系对应的供货渠道，携手共渡难关。（人工对接",
  "YC_FED_3875593424": "为快速帮助全国医院及单位及时找到各类防护物资，如您有相关货源，请及时发布出来，感谢支持！（人工对接请联系",
  "YC_FED_1857246879": "车辆资源信息"
}

/***/ }),

/***/ "Xn/q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZK0V":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAYAAAFvkPaZAAAABGdBTUEAALGPC/xhBQAAAuZJREFUOBGNVM9L1FEQn/n+UJcOWVBo0Eb9BZXlIYgg2A13MeggRB3q1K4aiSfrEEQgXYI0Mnc71cFOgWD5YzWC8FIEUrcOHUqpFalYD6Xs98dr5u2+5/uuq/kO3zczn8/Mm/nOvAdAK5nxfvAOiYy3LGglMmWBFUNZNDe7zRJNZr17DkP79giw2LTyG0DzJKf6sRI94ijLhVHHtFdkjkFn/tIIKbf4bGVAZiiF97l8A8oT9+8FmM25EqN8VnQalLU0CstJYteA2F0qeSVpqbpLOZH1fpqxZfKpHtHiBV5Rsc3dcty2wgguIHneBiHummCtjBbep3LFRQX0XbYhfVrmCJPzIQyPBRKiZFPyaCohIKXCUF7VHRFDKtWWIAtkGKzhANsYq7VLnSs1q1UkeTQrnX0ivr7uj5GhnRr+CSzn2txj/MiYJFFTPlBBJ9hgLgQszubdA0gFDFMBN0wwIiNObOpmhFBVImMy/sCBXTGEP2sCLvT7mh/5T0zgpXbFipBevK78cbUrEnZkxTFfeAvKULs76B6X8ZPZ8iLN1sFaAiIszeYa4pUkCK33p3lu2VHnZKN72Ixk6po0k8Ov1NkB6WnhTalXvfRxrF+9I5qKRX+QetdLXWiscupuNCnj2OT0FoZQT7oM1tUvYqtr3jwV2VbXcxsjz0EDOidf5fA7prvFkXLof6aBqVzQbRy3g2wb2p2y8Me2ChRvBbjSacOhVoRvRQHPXgawqIuKhg5CyPPl/UuXNxaF6P+dt+BSavPleT4VwNOJsJZOOq5zl57UQeDLUuTJ0pSt7HTD8rIBlN0kZZfSHobA7128BWFxWcjX1oA2RMSpuZyb1qNxLuM/CiHs3WDsTLLAGinknevM1sFY6ej2zgQC3mz1VDFHLX62bISz06PuW2XTk80GBk61OI004e8Uod5Os/WeeWYg5kUyMx0TPV4SQ5g2s+Rs6PTUTM4tmNwdy9ScIXrkVpMZ/+H/nP4BfV0aJ+/hwyMAAAAASUVORK5CYII="

/***/ }),

/***/ "ZqFO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "chPc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAFqwL0MAAAABGdBTUEAALGPC/xhBQAABKBJREFUSA3tVl1oXEUUnjP3TirRVC1irfhQhYoiPigoQh8q2N1txL9qWxGF9kGy2aSBBH9AtC8KFcSf1tKkWyyICP60GmwVzUYfWtGCD/4/NChafEnRWgq2Sd25d47fubtzc3ezm42Kb87DnjPn55tzzpwzd5Wqr3yx+pOwJD+5YpWFytI1MvebCibLXYn1nMpz6/p5Za5oq8ycWFAWUBFtTzHEg4ivaAAS69UrTPDZtI3FQA6ifNEeBFqvYg5F6FcQqJvjWH2hK2VzV1bpwxMlafWad0jouoHqTQ0CbNIYUIsfsT3EiochPIZaXCNoyblJKsZcxdYmBcuiJHkGZK6M2f7coFD6YVbuFU1ab2lWiqEo5QitHF/uPZO8FSU18LKGynlhlqZZZIXCo4AvSUZeftFtJty/qRFddA0AcoP5/gghMCH29Yrdy6zo4sk9pgeAZwHY7QF9wROAfH+1xKxGRWkD02Ni+4c3zNIubZZZtrtg+yA6IQKwoVypOqicejzQeih27r2sQztekxoiMkeci76sRVC0TyC87fMcAnNDoKxxMR2FPsjqpU8qY12bGzosayD85Ch9LRT5C2m5EgC5TeVQYVKE/BBVbRxSD1IRVEm0LfWpYRODHpzK9dvVTeKGbYLaIMFm49scnP7ERqmcaCcqnvZEKgczD6AwyNe5yH4vRjKen5+Inkd/jMDyBzTwKpFrRS9OlM0jNV5+6wvhbhNn5DuDa7peZlszfayVvsc7e1tP015HM32D0X4apZoiTVuZ7XdiFCv3ARPfIiPnnbI0SUEeIlTeIMw3iFWMaX4oayQ8EX164WXh2tPT9s9kr9Rgpdw1mj5cGNw+3OUIQr222dnvAfJrZY9ZjlRt7SGid2spoONQqB0LOQsIbC7N99tYZgDbX9A1lXoKc++xP60T9dPYtpW11ncoHUxrZ7sip462A2wLoCiYmthNeCqTL0Y7//lfkLaWbRRpH7TRdxTXplFeUrSfWLeaNqgyk5pYJbbCpYxsFrvypWgzTirjWpeIDw5AI9JApRzuWyyGt1t0AIURXsaz0Vs4dG3qTDSOjNH4fG9GNmkovL/KdhPm8GovF4oRO/zRWHgwK2vfBXWrQjG62xG/7mbsBQkIkcOBI3Se2c/non06DJ9Ct9yXL1WH8A7uQIA5HH5KbJ3EllkanlidA8g/yuerM9GrANuA8cR5iB5jSIrvRL2X4uv1jpu1OwWNI9uLJzuG7SAmLJC/AHFMh6BZLvpOq+EKekt2DYbmAJwv8Y643yPUHa5Xs9GwY97m5e0oXrM3A2O26Eh1VzkaR6+smbOlk6FWGz4cM4e9jPrKbI5/FeNb6YpeKBT39Wz3kvC5s+cSkFuzusXwyOyYMub2iV3qeKEUPYMKPZn1g37vyhvNVryG9kRaLqIzWquNgeaT1tL7qTzr+Td5VHBGa3pAmi83YPMYyAPo2x6BqV0rmMIwr9CxOhVHtq/eSP/6gWgZJ9ELlbHwseJeFf72rVo6vpt+T3sAjdT6z0VLpH8u9H9IPELHMfSGWaoDs2pitPZQezkSiJr//XjdQvS/KfVCJzbp/g/gLx6x7O164Z5vAAAAAElFTkSuQmCC"

/***/ }),

/***/ "cnn2":
/***/ (function(module, exports, __webpack_require__) {

var zhcn = __webpack_require__("wgRm")
var enus = __webpack_require__("WqJG")
var i18n = {
  zhcn: zhcn,
  enus: enus
}
module.exports = i18n

/***/ }),

/***/ "dEFN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dqEk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eIHG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gLuL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gvj7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hKcQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.15bfbb8.jpg";

/***/ }),

/***/ "j4n6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kC67":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kF+h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kf5t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lhmy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pon3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uOi8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v8q4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w+fm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w8LO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wgRm":
/***/ (function(module, exports) {

module.exports = {
  "YC_FED_1990880851": "单位/组织全称：",
  "YC_FED_831434141": "请输入您的单位或组织全称",
  "YC_FED_4020825779": "单位/组织所在地：",
  "YC_FED_1028132413": "请输入您的单位或组织所在地",
  "YC_FED_1122636714": "联系人：",
  "YC_FED_67440951": "请输入您的真实姓名",
  "YC_FED_911029432": "联系电话：",
  "YC_FED_2186083564": "填写真实联系电话以便联系您",
  "YC_FED_192667973": "品类:",
  "YC_FED_1333127493": "请选择物资品类",
  "YC_FED_194386418": "物资:",
  "YC_FED_2473871252": "请输入物资名称",
  "YC_FED_194603968": "数量:",
  "YC_FED_3439953582": "请输入数量,  如100个",
  "YC_FED_192826333": "单价:",
  "YC_FED_118396460": "请输入人民币单价",
  "YC_FED_192488796": "要求:",
  "YC_FED_434177049": "请输入物资标准、规格型号、品牌或其他详细要求（0/300）",
  "YC_FED_1213834093": "+ 增加新物资",
  "YC_FED_6437105": "提交",
  "YC_FED_4618299": "关闭",
  "YC_FED_2533636894": "提交成功",
  "YC_FED_606653812": "N95医用防护口罩（GB 19083-2010）及以上",
  "YC_FED_3133487643": "医用外科口罩（YY0469-2011)及以上",
  "YC_FED_4134432385": "防护服（GB 19082-2003）及以上",
  "YC_FED_151877491": "护目镜",
  "YC_FED_208007819": "医用帽",
  "YC_FED_911057188": "一次性手术衣",
  "YC_FED_1682877813": "医用一次性乳胶手套（GB 10213-2006）",
  "YC_FED_2681630027": "防冲击眼罩",
  "YC_FED_2321700280": "防护面罩",
  "YC_FED_159113289": "隔离衣",
  "YC_FED_3028139373": "N95口罩",
  "YC_FED_1144351558": "KN95口罩",
  "YC_FED_3870867899": "其他防护物品",
  "YC_FED_919362501": "提交失败",
  "YC_FED_1068639580": "提交成功,信息需经平台审核通过后方可公布出来",
  "YC_FED_1740703422": "募捐人信息",
  "YC_FED_1037509641": "募捐物资信息",
  "YC_FED_204689708": "供应商",
  "YC_FED_1739264961": "捐赠人信息",
  "YC_FED_1035681206": "捐赠物资信息",
  "YC_FED_200448147": "募捐方",
  "YC_FED_1739269997": "供货人信息",
  "YC_FED_1037192073": "供应物资信息",
  "YC_FED_200551582": "需求方",
  "YC_FED_1740683955": "需求人信息",
  "YC_FED_1037618308": "需求物资信息",
  "YC_FED_2074959271": "所在地:",
  "YC_FED_2068410378": "联系人:",
  "YC_FED_1245154200": "联系电话:",
  "YC_FED_2853835295": "请输入数量,例如:100个",
  "YC_FED_452494987": "请输入单价,例如:100元",
  "YC_FED_1544319898": "申请募捐人信息",
  "YC_FED_4274620010": "定向捐赠人信息",
  "YC_FED_270630829": "申请募捐物资信息",
  "YC_FED_213722159": "捐赠人",
  "YC_FED_1739268934": "受赠人信息",
  "YC_FED_1739323515": "采购人信息",
  "YC_FED_1035728396": "采购物资信息",
  "YC_FED_159160491": "待执行",
  "YC_FED_202378507": "已完成",
  "YC_FED_200536782": "已失效",
  "YC_FED_194436000": "描述:",
  "YC_FED_2406273446": "公开募捐",
  "YC_FED_158279504": "待捐赠",
  "YC_FED_929987013": "我要捐赠",
  "YC_FED_2406173793": "定向募捐",
  "YC_FED_928281369": "公开捐赠",
  "YC_FED_203092231": "待受捐",
  "YC_FED_3782982486": "我要申请受捐",
  "YC_FED_1740703670": "受捐人信息",
  "YC_FED_928292574": "定向捐赠",
  "YC_FED_2564348198": "公开供应",
  "YC_FED_159694250": "待采购",
  "YC_FED_974226303": "我要采购",
  "YC_FED_2564388065": "定向供应",
  "YC_FED_974926435": "公开采购",
  "YC_FED_207857551": "待供应",
  "YC_FED_2563883258": "我要供应",
  "YC_FED_1741057470": "供应人信息",
  "YC_FED_974857828": "定向采购",
  "YC_FED_1593734474": "如果您在疫情防控工作中，存在防护物资的短缺情况，请按照                        以下格式真实反馈，我们将全力助您查寻对应供货渠道(请真实填写)",
  "YC_FED_2395463995": "个人信息",
  "YC_FED_1041404309": "我的真实姓名：",
  "YC_FED_1808074203": "请输入真实姓名",
  "YC_FED_2549854617": "企业名称：",
  "YC_FED_432081186": "请输入企业名称",
  "YC_FED_1710252738": "请输入真实联系电话",
  "YC_FED_1037402129": "短缺物资信息",
  "YC_FED_1220517444": "请填写物资名称及数量，详细的规格型号或其他补充说明（最多可输入400字）",
  "YC_FED_3219929105": "提交成功,物资信息需经平台审核通过后方可公布出来",
  "YC_FED_1462376749": "我已阅读并同意",
  "YC_FED_1182055339": "《用户使用规则及免责声明》",
  "YC_FED_3087410922": "<返回",
  "YC_FED_2348497461": "免责声明",
  "YC_FED_528452416": "第一条 协议订立",
  "YC_FED_4055161575": "1.1用户在同意本网站:智慧云采丨防疫物资紧急采购发布平台 (",
  "YC_FED_3221434543": ")的免责协议后，方可使用本网络服务平台(以下简称“平台”)提供的疫情防护物资供需信息相关服务(以下简称“服务”)。",
  "YC_FED_1736612144": "1.1用户在同意本网站:互助汇丨防疫物资紧急采购发布平台 (",
  "YC_FED_2084807500": "1.2用户在使用本平台提供的服务前请务必认真阅读本协议，一旦用户使用本平台提供的服务即表示用户同意与本平台签订本协议且同意受本协议之约束。",
  "YC_FED_3124526546": "第二条 服务说明",
  "YC_FED_2201916839": "2.1 通过本平台获取的捐赠机构、组织和个体，平台均称为 “捐赠方”，通过本平台获取的物资供应商，平台均称为 “供应方”。本平台仅为技术服务提供方。",
  "YC_FED_3665445276": "2.2 由于情况各异且随时会发生变化，本平台所有供应方、捐赠方目前均无法承诺实际情况。",
  "YC_FED_291743527": "2.3 需求内容以各机构在各大官方发布信息为准(认证微博、官方微信公众号、医院盖章文件等)，平台只做内容收集展示及部分人工核实。",
  "YC_FED_74884276": "第三条 用户的权利和义务",
  "YC_FED_1299145044": "3.1 用户使用本平台前，应仔细阅读各方具体信息。本协议中涉及交易双方、捐赠双方权利义务的内容，如有与我国相关法律冲突的，以我国相关法律为准。",
  "YC_FED_3689983678": "3.2 用户发布信息时，应当准确填写物资类目及具体数量等信息内容。",
  "YC_FED_2434946685": "3.3 如采购方、捐赠方需取得相应凭证，应与相关合作单位联系取得。在交易和捐赠等过程中，如因各项事宜产生争议，由用户与对应方协商解决。",
  "YC_FED_2177695349": "3.4 用户同意本平台向购买方、需求方、捐赠方、接受捐赠方等相关单位披露用户提交的信息中所涉及的各项内容（包括但不限于所在单位、联系电话等个人信息）。",
  "YC_FED_473969063": "第四条 免责说明",
  "YC_FED_2244574431": "4.1 因疫情变化，本平台显示的信息仅供参考，最终以实际供应及需求为准。",
  "YC_FED_478052221": "4.2 因用户提供错误信息所导致的损失，由用户自行承担，本平台不承担任何责任。",
  "YC_FED_251437274": "4.3 用户充分知晓并认可，本平台仅为公益性信息平台，物资供应方与需求方、捐赠方产生任何纠纷与本平台无关，本平台不因平台服务而承担任何担保、保证或连带责任。",
  "YC_FED_1502473923": "4.4 本平台会尽力维护平台信息的安全，但法律规定的不可抗力，以及因为黑客入侵、计算机病毒等原因造成用户资料泄露、丢失、被盗用、被篡改的，本平台不承担任何责任。",
  "YC_FED_3230073079": "4.5 本平台仅提供技术服务，不是交易合同、赠与合同等合同的权利义务主体，不介入用户与交易方之间的纠纷，但本平台将提供协助，保护用户的合法权益。",
  "YC_FED_2152434189": "4.6 本平台如被恶意篡改用于不正当募捐和交易使用，一律追责。",
  "YC_FED_539696760": "4.7 本平台唯一官方网址",
  "YC_FED_3133507652": "(智慧云采丨防疫物资紧急采购需求发布平台)如被人恶意假借名义进行不正当行为，与本平台无关。但本平台保留追究其法律责任的权利。",
  "YC_FED_154048019": "(互助汇丨防疫物资紧急采购需求发布平台)如被人恶意假借名义进行不正当行为，与本平台无关。但本平台保留追究其法律责任的权利。",
  "YC_FED_183727381": "第五条 争议解决及法律适用",
  "YC_FED_2912025593": "5.1 在用户有意向捐赠、求购、发布信息后，如果在约定内容履行过程中，对相关事宜的履行发生争议，用户同意按照中华人民共和国现行有效的相关法律法规来解决争议，并同意接受平台方所在地有管辖权的人民法院的管辖。",
  "YC_FED_2554030307": "募捐专区",
  "YC_FED_2552182054": "采购专区",
  "YC_FED_2553971171": "供应专区",
  "YC_FED_2448709159": "车辆需求",
  "YC_FED_2471655281": "车辆资源",
  "YC_FED_113148420": "全国各大疫区物资紧缺，急需救援！如您愿意可为以下企业单位给予爱心支援！",
  "YC_FED_192519691": "告急!",
  "YC_FED_3475192107": "&nbsp;&nbsp;湖北及其他城市医院防控物资非常紧缺，急需救援！以下是各大医院名单及医院官方发布的资料！请求大家支援！请放心捐赠！",
  "YC_FED_200132291": "待实施",
  "YC_FED_553553962": "联系人： ",
  "YC_FED_2099197199": "地址： ",
  "YC_FED_2619873061": "查看更多",
  "YC_FED_3205136507": "已经到底了",
  "YC_FED_3018779863": "紧急动员全球爱心人士，通过互联网大数据分析帮你联系对应供货渠道，携手共渡难关。",
  "YC_FED_2555520228": "紧急动员全球爱心人士，集结友云采全国5万+优质安全防护类供应商，通过互联网大数据分析尽可能联系对应的供货渠道，携手共渡难关。(人工对接",
  "YC_FED_3602995043": "为快速帮助全国医院及单位及时找到各类防护物资，如您有相关货源，请及时发布出来，感谢支持！",
  "YC_FED_2918819944": "驰援武汉及其他新冠肺炎疫区抗击疫情，用友采购云设立防疫物资供采平台，确保各类医疗防护用品第一时间送达一线医院及工作单位。如果您有相关货源，烦请给予支持！感谢！",
  "YC_FED_568913344": "非定向捐赠",
  "YC_FED_2405343526": "申请受捐",
  "YC_FED_6030255": "提示",
  "YC_FED_2234412832": "授权查看",
  "YC_FED_1927386792": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfab254d-2129-4fc8-ab3b-c0c7f53d7dba_湖北-恩施.jpg",
  "YC_FED_3577225693": "湖北-恩施",
  "YC_FED_2330653473": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/cfa7699b-6ae3-4f8b-bcbe-c56bdbdc9bc8_湖北-监利县.jpg",
  "YC_FED_3036342030": "湖北-监利县",
  "YC_FED_269199880": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/53753b9b-0f2b-48e8-b8eb-ce27b18bcb3c_湖北-公安县.jpg",
  "YC_FED_657870771": "湖北-公安县",
  "YC_FED_3130702216": "http://ncc-yc-cpumall-ec.obs.cn-north-4.myhuaweicloud.com/h050u1t9/0e4bc83a-386d-46e5-809f-da12f392124b_湖北-来凤县.jpg",
  "YC_FED_3847805047": "湖北-来凤县",
  "YC_FED_212206716": "提交中",
  "YC_FED_2434616598": "中间商/代理商",
  "YC_FED_6110694": "同意",
  "YC_FED_201634987": "不同意",
  "YC_FED_185226": "是",
  "YC_FED_188803": "否",
  "YC_FED_4796981": "捐赠",
  "YC_FED_2405767290": "我要募捐",
  "YC_FED_978087483": "我要用车",
  "YC_FED_2470384297": "我有资源",
  "YC_FED_4077360456": "物资信息必填",
  "YC_FED_3381849403": "加载中...",
  "YC_FED_2617892266": "互助汇 | 防疫物资紧急采购需求发布平台",
  "YC_FED_1759574121": "智慧云采丨防疫物资紧急采购需求发布平台",
  "YC_FED_3956978529": "用友采购云-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道",
  "YC_FED_212056634": "已分享",
  "YC_FED_2308923102": "互助汇丨防疫物资紧急采购全球供需平台",
  "YC_FED_3071947429": "互助汇-疫区物资公益求助平台,快捷发布信息并通过互联网对接供货渠道",
  "YC_FED_1218218790": "为确保防护物资能第一时间送抵目的地，如您需要物流资源支持，请填写真实需求发布！",
  "YC_FED_163921277": "需求：",
  "YC_FED_1864683465": "车辆需求信息",
  "YC_FED_471295947": "请填写需要的车辆车型，运输区域，计划运输时间区间，计划运输物品或其他补充说明（最多可输入400字）",
  "YC_FED_1323221205": "全国疫区物流资源紧缺，为确保防护物资能第一时间送抵目的地，如您有相关物流资源，烦请发布！",
  "YC_FED_163954859": "资源：",
  "YC_FED_3027635972": "紧急动员全球爱心人士，通过互联网大数据分析帮你联系对应供货渠道，携手共渡难关。（人工对接请联系",
  "YC_FED_1789495300": "紧急动员全球爱心人士，集结友云采全国5万+优质安全防护类供应商，通过互联网大数据分析尽可能联系对应的供货渠道，携手共渡难关。（人工对接",
  "YC_FED_3875593424": "为快速帮助全国医院及单位及时找到各类防护物资，如您有相关货源，请及时发布出来，感谢支持！（人工对接请联系",
  "YC_FED_1857246879": "车辆资源信息"
}

/***/ }),

/***/ "y5LZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner2.be84b1c.jpg";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.25a4c35a3b512599ca14.js